webpackJsonp([0],Array(176).concat([
/* 176 */
/*!******************************!*\
  !*** ./client/views/404.vue ***!
  \******************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./404.vue */ 226),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7d24ed9c"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./404.vue */ 227),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/*!*******************************!*\
  !*** ./client/views/Home.vue ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 228),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1aa37216"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 256),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/*!********************************!*\
  !*** ./client/views/Terms.vue ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Terms.vue */ 257),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-61559961"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Terms.vue */ 264),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/*!***************************************!*\
  !*** ./client/views/InfoDentists.vue ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InfoDentists.vue */ 265),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c0f639d8"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InfoDentists.vue */ 276),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/*!****************************************!*\
  !*** ./client/views/InfoReviewers.vue ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./InfoReviewers.vue */ 277),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-89a8494c"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./InfoReviewers.vue */ 287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/*!**************************************************!*\
  !*** ./client/views/UnderstandingYourReport.vue ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./UnderstandingYourReport.vue */ 288),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-27c4e6e5"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./UnderstandingYourReport.vue */ 310),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/*!************************************!*\
  !*** ./client/views/TrackLink.vue ***!
  \************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./TrackLink.vue */ 311),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-35919082"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./TrackLink.vue */ 312),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/*!********************************!*\
  !*** ./client/views/Login.vue ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Login.vue */ 313),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-fe01037a"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Login.vue */ 314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/*!*********************************!*\
  !*** ./client/views/Logout.vue ***!
  \*********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Logout.vue */ 315),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-27fd5ac0"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Logout.vue */ 316),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/*!***************************************************!*\
  !*** ./client/views/register/RegisterDentist.vue ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterDentist.vue */ 317),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-26c67c2c"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterDentist.vue */ 318),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/*!***************************************************!*\
  !*** ./client/views/register/RegisterPatient.vue ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RegisterPatient.vue */ 319),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3cfbe2cc"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RegisterPatient.vue */ 320),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/*!*************************************!*\
  !*** ./client/views/auth/Reset.vue ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Reset.vue */ 321),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1afe04fe"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Reset.vue */ 322),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/*!***************************************!*\
  !*** ./client/views/auth/Confirm.vue ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Confirm.vue */ 323),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-55cc37a2"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Confirm.vue */ 324),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/*!************************************!*\
  !*** ./client/views/Dashboard.vue ***!
  \************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dashboard.vue */ 325),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-145ebaee"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dashboard.vue */ 329),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/*!***************************************************!*\
  !*** ./client/views/dashboard/profile/MyInfo.vue ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MyInfo.vue */ 330),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-694db4de"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyInfo.vue */ 333),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/*!*****************************************************!*\
  !*** ./client/views/dashboard/profile/Password.vue ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Password.vue */ 334),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-64e6591c"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Password.vue */ 335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/*!*********************************************!*\
  !*** ./client/views/dashboard/Requests.vue ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Requests.vue */ 336),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e7b33b16"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Requests.vue */ 339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/*!********************************************!*\
  !*** ./client/views/dashboard/Reviews.vue ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Reviews.vue */ 340),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1e27b00c"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Reviews.vue */ 341),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/*!*******************************************!*\
  !*** ./client/views/dashboard/Review.vue ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Review.vue */ 342),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-49b7c249"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Review.vue */ 346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/*!******************************************************!*\
  !*** ./client/views/dashboard/profile/Locations.vue ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Locations.vue */ 347),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-64387717"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Locations.vue */ 348),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/*!********************************************************!*\
  !*** ./client/views/dashboard/ReviewerApplication.vue ***!
  \********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReviewerApplication.vue */ 349),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0d4b636a"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReviewerApplication.vue */ 350),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/*!*****************************************************!*\
  !*** ./client/views/dashboard/ReviewerRequests.vue ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReviewerRequests.vue */ 351),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-78473c1a"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReviewerRequests.vue */ 352),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/*!****************************************************!*\
  !*** ./client/views/dashboard/ReviewerRequest.vue ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ReviewerRequest.vue */ 353),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5e99aa29"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ReviewerRequest.vue */ 354),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 199 */
/*!**********************************************!*\
  !*** ./client/views/dashboard/EmailLogs.vue ***!
  \**********************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EmailLogs.vue */ 355),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7912cd8a"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EmailLogs.vue */ 356),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/*!**************************************************!*\
  !*** ./client/views/dashboard/EmailActivity.vue ***!
  \**************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EmailActivity.vue */ 357),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-755f9d2c"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EmailActivity.vue */ 359),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/*!**********************************!*\
  !*** ./client/views/Success.vue ***!
  \**********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Success.vue */ 360),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-37d46d46"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Success.vue */ 364),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/*!**********************************!*\
  !*** ./client/views/Request.vue ***!
  \**********************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Request.vue */ 365),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-743b55e9"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Request.vue */ 366),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */,
/* 204 */
/*!*******************************!*\
  !*** ./client/models/meta.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  home: {
    title: 'Ensure quality dental care',
    meta: {
      description: 'Ensure quality dental care'
    }
  },

  infoDentists: {
    title: 'VeriTooth for Dentists',
    meta: {
      description: 'The dental industry is in trouble, and we need your help. There isn\u2019t a way to demonstrate quality while also building trust with patients. Find out VeriTooth is changing that.'
    }
  },

  infoReviewers: {
    title: 'Become a Verified Reviewer',
    meta: {
      description: 'You can play a critical role is solving a dental industry wide problem. Patients don\u2019t have a solid way to assess the quality of work they received. Find out how you can help change that.'
    }
  },

  dashboard: {
    title: 'Dashboard',
    meta: {
      description: 'User dashboard'
    }
  },

  register: {
    title: 'Register',
    meta: {
      description: 'Sign up to VeriTooth'
    }
  },

  login: {
    title: 'Sign In',
    meta: {
      description: 'Sign into VeriTooth'
    }
  },

  notFound: {
    title: 'Not Found',
    meta: {
      description: 'This page was not found.',
      noIndex: true
    }
  },

  terms: {
    title: 'T&Cs',
    meta: {
      // description: `Terms page description`,
      noIndex: true
    }
  },

  privacy: {
    title: 'Privacy Policy',
    meta: {
      // description: `Privacy policy description`,
      noIndex: true
    }
  }
});

/***/ }),
/* 205 */
/*!*********************************************!*\
  !*** ./client/components/modules/Block.vue ***!
  \*********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Block.vue */ 233),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3f33dee1"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Block.vue */ 234),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/*!**************************************************!*\
  !*** ./client/components/modules/DetailList.vue ***!
  \**************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DetailList.vue */ 331),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6fef8eeb"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DetailList.vue */ 332),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/*!*****************************************!*\
  !*** ./client/components/ui/Footer.vue ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Footer.vue */ 229),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4120d3dc"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Footer.vue */ 230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/*!*************************************!*\
  !*** ./client/services/dateTime.js ***!
  \*************************************/
/*! exports provided: toDateString, toDateTimeString */
/*! exports used: toDateString, toDateTimeString */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toDateString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toDateTimeString; });


var toDateString = function toDateString(date) {
  var options = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  };
  var event = new Date(date);
  var formattedDate = event.toLocaleDateString('en-US', options);
  return formattedDate !== 'Invalid Date' ? formattedDate : date;
};

var toDateTimeString = function toDateTimeString(date) {
  var event = new Date(date);
  var formattedDate = event.toLocaleTimeString('en-US');
  return formattedDate !== 'Invalid Date' ? formattedDate : date;
};

/***/ }),
/* 209 */
/*!*********************************************!*\
  !*** ./client/components/modules/Table.vue ***!
  \*********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Table.vue */ 337),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d6a664bc"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Table.vue */ 338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/*!*********************************************************!*\
  !*** ./client/assets/images/dashboard/success-tick.svg ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/dashboard/success-tick.8c1ad28c.svg";

/***/ }),
/* 211 */
/*!***************************************************!*\
  !*** ./client/components/pages/home/Dentists.vue ***!
  \***************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dentists.vue */ 243),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5bda401e"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dentists.vue */ 244),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/*!************************************************!*\
  !*** ./client/components/pages/home/Block.vue ***!
  \************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Block.vue */ 250),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-dcf4f0c8"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Block.vue */ 254),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/*!***************************************************!*\
  !*** ./client/assets/images/home/our-mission.svg ***!
  \***************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/home/our-mission.94e01370.svg";

/***/ }),
/* 214 */
/*!*********************************************!*\
  !*** ./client/assets/images/icons/tick.svg ***!
  \*********************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/icons/tick.6dc7affe.svg";

/***/ }),
/* 215 */
/*!*******************************************************!*\
  !*** ./client/assets/images/home/dentists-page-3.svg ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/home/dentists-page-3.0a3f2cb5.svg";

/***/ }),
/* 216 */
/*!*******************************************************!*\
  !*** ./client/assets/images/home/dentists-page-2.svg ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/home/dentists-page-2.bc1cb8c4.svg";

/***/ }),
/* 217 */
/*!*******************************************************!*\
  !*** ./client/assets/images/home/dentists-page-4.svg ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/home/dentists-page-4.25f9b886.svg";

/***/ }),
/* 218 */
/*!*******************************************************!*\
  !*** ./client/assets/images/home/dentists-page-1.svg ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/home/dentists-page-1.10d85378.svg";

/***/ }),
/* 219 */
/*!***********************************************************!*\
  !*** ./client/assets/images/info/icon-tooth-computer.svg ***!
  \***********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/info/icon-tooth-computer.4be8b783.svg";

/***/ }),
/* 220 */
/*!*********************************************************!*\
  !*** ./client/assets/images/info/icon-tooth-search.svg ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/info/icon-tooth-search.71097ced.svg";

/***/ }),
/* 221 */
/*!****************************************************!*\
  !*** ./client/assets/images/info/icon-doctors.svg ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/info/icon-doctors.837c9976.svg";

/***/ }),
/* 222 */
/*!****************************************************************************!*\
  !*** ./client/assets/images/info/american-association-of-endodontists.svg ***!
  \****************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/info/american-association-of-endodontists.bb147f72.svg";

/***/ }),
/* 223 */
/*!**********************************************************!*\
  !*** ./client/assets/images/rootCanalFaq/rubber-dam.png ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/rootCanalFaq/rubber-dam.ba8f6afc.png";

/***/ }),
/* 224 */
/*!************************************************!*\
  !*** ./client/models/dashboard/userDetails.js ***!
  \************************************************/
/*! exports provided: patientDetails, dentistDetails, address, dentistLocation */
/*! exports used: address, dentistDetails, dentistLocation, patientDetails */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return patientDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dentistDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return address; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dentistLocation; });

var patientDetails = {
  // title: {
  //   type: `select`,
  //   label: `Title`,
  //   labelHidden: true,
  //   placeholder: `Select title`,
  //   readonly: true,
  //   value: `Dr`,
  // items: [
  //   `Dr`,
  //   `Mr`,
  //   `Miss`,
  //   `Mrs`,
  //   `Ms`,
  // ],
  //   heading: {
  //     heading: `About`,
  //     level: `h5`,
  //   },
  // },
  first_name: {
    type: "text",
    label: "First Name",
    labelHidden: true,
    placeholder: "First Name"
  },
  last_name: {
    type: "text",
    label: "Last Name",
    labelHidden: true,
    placeholder: "Last Name"
  },
  email: {
    type: "text",
    label: "Email Address",
    labelHidden: true,
    placeholder: "Email Address"
  }
};

var dentistDetails = {
  first_name: {
    type: "text",
    label: "First Name",
    labelHidden: true,
    placeholder: "First Name"
  },
  last_name: {
    type: "text",
    label: "Last Name",
    labelHidden: true,
    placeholder: "Last Name"
  },
  email: {
    type: "text",
    label: "Email Address",
    labelHidden: true,
    placeholder: "Email Address"
  },
  license_number: {
    type: "text",
    labelHidden: true,
    label: "Dentist ID",
    placeholder: "License Number"
  },
  phone_number: {
    type: "tel",
    label: "Phone Number",
    labelHidden: true,
    placeholder: "Main phone number"
  },
  specialty: { // WHY: Spelling error consistent with backend
    type: "select",
    label: "Select Speciality",
    labelHidden: true,
    placeholder: "Select Speciality",
    items: []
  }
};

var address = {
  address_1: {
    type: "text",
    label: "Address Line One",
    labelHidden: true,
    placeholder: "Address Line One",
    heading: {
      heading: "Address Information",
      level: "h5"
    }
  },
  address_2: {
    type: "text",
    label: "Address Line Two",
    labelHidden: true,
    placeholder: "Address Line Two"
  },
  city: {
    type: "text",
    label: "City",
    labelHidden: true,
    placeholder: "City"
  },
  state: {
    type: "text",
    label: "State",
    labelHidden: true,
    placeholder: "State"
  },
  zipcode: {
    type: "text",
    label: "ZIP",
    labelHidden: true,
    placeholder: "ZIP"
  }
};

var dentistLocation = {
  name: {
    type: "text",
    label: "Clinic Name",
    labelHidden: true,
    placeholder: "Clinic Name",
    heading: {
      heading: "Clinic/Hospital/Practice Information",
      level: "h5"
    }
  },
  address_1: {
    type: "text",
    label: "Address Line One",
    labelHidden: true,
    placeholder: "Address Line One"
  },
  address_2: {
    type: "text",
    label: "Address Line Two",
    labelHidden: true,
    placeholder: "Address Line Two"
  },
  city: {
    type: "text",
    label: "City",
    labelHidden: true,
    placeholder: "City"
  },
  state: {
    type: "text",
    label: "State",
    labelHidden: true,
    placeholder: "State"
  },
  zipcode: {
    type: "text",
    label: "ZIP",
    labelHidden: true,
    placeholder: "ZIP"
  }
};

/***/ }),
/* 225 */
/*!*********************************!*\
  !*** ./client/models/review.js ***!
  \*********************************/
/*! exports provided: ratingsMap, statusMap, fields */
/*! exports used: fields, ratingsMap, statusMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ratingsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return statusMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_array__ = __webpack_require__(/*! services/array */ 2);


// Services



var ratingsMap = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '5',
  7: '5',
  8: '8',
  9: '9',
  10: '10'
};

var statusMap = {
  1: 'Started',
  2: 'Waiting for dentist upload',
  3: 'X-rays uploaded',
  4: 'Review complete',
  5: 'Validated',
  6: 'Rejected'
};

var ratingItems = [];

Object(__WEBPACK_IMPORTED_MODULE_0_services_array__["b" /* arrayLoop */])(ratingsMap, function (i) {
  ratingItems.push({
    option: '' + i,
    value: parseInt(i, 10)
  });
});

var fields = {
  reviewer: {
    was_rubber_dam_used: {
      label: 'Rubber Dam Used',
      type: 'radio',
      items: [{
        option: 'Yes',
        value: 1
      }, {
        option: 'No',
        value: 2
      }, {
        option: 'Unable to tell',
        value: 3
      }],
      validations: {
        required: true
      }
    },
    conservative_access_prep: {
      label: 'Conservative Access Prep',
      type: 'radio',
      items: [{
        option: 'Yes',
        value: 1
      }, {
        option: 'No',
        value: 2
      }, {
        option: 'Unable to tell',
        value: 3
      }],
      validations: {
        required: true
      }
    },
    all_canal_cleaned_and_shaped: {
      label: 'All Canals Cleaned and Shaped',
      type: 'radio',
      items: [{
        option: 'Yes',
        value: 1
      }, {
        option: 'No',
        value: 2
      }, {
        option: 'Unable to tell',
        value: 3
      }],
      validations: {
        required: true
      }
    },
    canal_cleaned_and_shaped: {
      label: 'Canals Cleaned and Shaped to the Apex',
      type: 'radio',
      items: [{
        option: 'Yes',
        value: 1
      }, {
        option: 'No',
        value: 2
      }, {
        option: 'Unable to tell',
        value: 3
      }],
      validations: {
        required: true
      }
    },
    adequate_root_density: {
      label: 'Adequate root filling density',
      type: 'radio',
      items: [{
        option: 'Yes',
        value: 1
      }, {
        option: 'No',
        value: 2
      }, {
        option: 'Unable to tell',
        value: 3
      }],
      validations: {
        required: true
      }
    },
    perforation: {
      label: 'Signs of perforation',
      type: 'radio',
      items: [{
        option: 'Yes',
        value: 1
      }, {
        option: 'No',
        value: 2
      }, {
        option: 'Unable to tell',
        value: 3
      }],
      validations: {
        required: true
      }
    },
    separated_instrument: {
      label: 'Signs of separated instrument',
      type: 'radio',
      items: [{
        option: 'Yes',
        value: 1
      }, {
        option: 'No',
        value: 2
      }, {
        option: 'Unable to tell',
        value: 3
      }],
      validations: {
        required: true
      }
    },
    rating: {
      intro: {
        copy: 'Based on what you see and the AAE criteria, on a scale of 1-10 what is the likelihood this tooth will need re-treatment?\n        <br>\n        <br>\n        1 = It likely needs extraction based on damage \n        <br>\n        <br>\n        5 = Will likely need retreatment\n        <br>\n        <br>\n        10 = Good quality and should be fine\n        <br>\n        <br>\n        Please only review based on the evidence in the radiographs submitted.  While we know that radiographs don\'t show everything and there may be unseen issues like missed canals, unless there is clear evidence of an issue, please assume that it is not a problem.',
        size: 'small'
      },
      type: 'radio',
      items: ratingItems,
      validations: {
        required: true
      }
    },
    reviewer_notes: {
      type: 'textarea',
      label: 'Notes',
      labelHidden: true,
      placeholder: 'Please provide any additional comments'
    }
  }
};

/***/ }),
/* 226 */
/*!****************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/404.vue ***!
  \****************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/404.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Models


// Modules


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-not-found',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_2_models_meta__["a" /* default */].notFound.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_1_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_2_models_meta__["a" /* default */].notFound.meta)
  },

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_3_modules_Button___default.a
  },

  // Data
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['isAuthenticated']))
});

/***/ }),
/* 227 */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d24ed9c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/404.vue ***!
  \***********************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--not-found"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h1', {
    staticClass: "h1 mb0"
  }, [_vm._v("Uh oh!")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v("Page not found…")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "link": _vm.isAuthenticated ? "dashboard" : "home",
      "button": "primary",
      "label": ("Back " + (_vm.isAuthenticated ? "to your dashboard" : "home"))
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 228 */
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Home.vue ***!
  \*****************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/Home.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer__ = __webpack_require__(/*! ui/Footer */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ui_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_home_Faqs__ = __webpack_require__(/*! pages/home/Faqs */ 231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_home_Faqs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_home_Faqs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_home_Instructions__ = __webpack_require__(/*! pages/home/Instructions */ 236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_home_Instructions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_home_Instructions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_home_Dentists__ = __webpack_require__(/*! pages/home/Dentists */ 211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_home_Dentists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_home_Dentists__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_home_Hero__ = __webpack_require__(/*! pages/home/Hero */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_home_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_home_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_home_OurMission__ = __webpack_require__(/*! pages/home/OurMission */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_home_OurMission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_home_OurMission__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Models


// Services


// Ui


// Pages




// import PagesHomeWho from 'pages/home/Who';
// import PagesHomeWhy from 'pages/home/Why';

// import PagesHomeComingSoon from 'pages/home/ComingSoon';

// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-home',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].home.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_1_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].home.meta)
  },

  // Components
  components: {
    UiFooter: __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default.a
  },

  // Data
  data: function data() {
    return {
      components: {
        PagesHomeHero: __WEBPACK_IMPORTED_MODULE_6_pages_home_Hero___default.a,
        PagesHomeInstructions: __WEBPACK_IMPORTED_MODULE_4_pages_home_Instructions___default.a,
        // PagesHomeWho,
        // PagesHomeWhy,
        PagesHomeOurMission: __WEBPACK_IMPORTED_MODULE_7_pages_home_OurMission___default.a,
        // PagesHomeComingSoon,
        PagesHomeFaqs: __WEBPACK_IMPORTED_MODULE_3_pages_home_Faqs___default.a,
        PagesHomeDentists: __WEBPACK_IMPORTED_MODULE_5_pages_home_Dentists___default.a
      }
    };
  }
});

/***/ }),
/* 229 */
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/Footer.vue ***!
  \***************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/Footer.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Logo__ = __webpack_require__(/*! modules/Logo */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Logo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-footer',
  components: {
    ModuleLink: __WEBPACK_IMPORTED_MODULE_0_modules_Link___default.a,
    ModuleLogo: __WEBPACK_IMPORTED_MODULE_1_modules_Logo___default.a
  },

  data: function data() {
    return {
      links: [
      // {
      //   slug: `faq`,
      //   name: `FAQ`,
      // },
      {
        slug: 'privacy',
        name: 'Privacy Policy',
        external: true
      }, {
        slug: 'terms',
        name: 'Terms of Service',
        external: true
      }, {
        slug: 'understanding-your-report',
        name: 'Understanding your report'
      }, {
        slug: 'mailto:support@veritooth.com',
        name: 'Contact us'
      }]
    };
  }
});

/***/ }),
/* 230 */
/*!**********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4120d3dc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Footer.vue ***!
  \**********************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "block bg-white c-black footer"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: "/"
      }
    }
  }, [_c('module-logo', {
    attrs: {
      "small": true
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "footer__nav"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      key: link.id,
      staticClass: "footer__list"
    }, [_c('module-link', {
      staticClass: "footer__link ttu tdn fw-extrabold link",
      attrs: {
        "color": "secondary",
        "link": link.slug,
        "label": link.name,
        "external": link.external ? link.external : false
      }
    })], 1)
  }))], 1)])
},staticRenderFns: []}

/***/ }),
/* 231 */
/*!***********************************************!*\
  !*** ./client/components/pages/home/Faqs.vue ***!
  \***********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Faqs.vue */ 232),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2071da5e"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Faqs.vue */ 235),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/home/Faqs.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/home/Faqs.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Block__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-faqs',

  // Components
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_0_modules_Block___default.a
  },

  data: function data() {
    return {
      heading: 'Frequently Asked Questions',
      faqs: [{
        question: 'Are my X-rays safe with VeriTooth?',
        answer: 'The VeriTooth process is safe, secure, and confidential. Your request and files are scrubbed of any identifying information and submitted to qualified dentists for an unbiased review. All data is stored in a secure environment.'
      }, {
        question: 'Who reviews my VeriTooth request?',
        answer: 'The VeriTooth review team consists of a group of dentists and dental specialists who want to highlight quality and transparency in the dental industry. All reviewers\u2019 credentials have been validated by VeriTooth and their reviews are regularly checked by industry peers. In addition to trusted experts, VeriTooth has pulled together research and best practices that all reviewers use to verify the quality of the work. These best practices have been adopted by both the ADA (American Dental Association) and the AAE (American Association of Endodontists), experts in root canals.'
      }, {
        question: 'Is an X-ray enough to prove good/bad dentistry?',
        answer: 'In short, no. An x-ray is not enough to determine the overall care a patient receives. By reviewing a before and after x-ray VeriTooth is basically performing a "spot check." Nothing replaces a full consultation and the x-ray definitely doesn\u2019t show everything. The x-rays are one data point to help patients and dentists jointly assess quality.'
      }, {
        question: 'What about other procedures?',
        answer: 'Right now VeriTooth is launching with a focus on root canals. But we definitely plan to offer additional review capabilities in the future including crowns, fillings and extractions.'
      }, {
        question: 'Why is VeriTooth free?',
        answer: 'VeriTooth is currently testing our service with patients and doctor\u2019s offices to identify any potential issues before we launch more publicly in the coming months.'
      }]
    };
  }
});

/***/ }),
/* 233 */
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Block.vue ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Block.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "module-block",

  // Props
  props: {
    block: String,
    cover: Boolean,
    center: Boolean,
    slug: String,
    trigger: Boolean,
    tag: {
      type: String,
      default: "section"
    },
    grow: Boolean,
    angle: Number,
    image: String
  },

  // Data
  computed: {
    angleSet: function angleSet() {
      var angle = this.angle;

      if (!angle || angle > 10 || angle < -10) {
        return {};
      }

      var reversed = angle < 0;

      return {
        angle: reversed ? angle * -1 : angle,
        reversed: reversed
      };
    }
  }
});

/***/ }),
/* 234 */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f33dee1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Block.vue ***!
  \**************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tag || 'section', {
    tag: "component",
    class: [
      'block',
      ("block--" + (_vm.block || 'accent')),
      _vm.angleSet.angle ? ("angle-block--" + (_vm.angleSet.angle) + (_vm.angleSet.reversed ? "-reversed" : "")) : "",
      {
        'block--cover': _vm.cover,
        'block--center': _vm.center,
        'block--grow': _vm.grow,
      } ]
  }, [(_vm.image) ? _c('b', {
    class: [
      "block__bg"
    ],
    style: ({
      backgroundImage: ("url('" + _vm.image + "')"),
    })
  }) : _vm._e(), _vm._v(" "), (_vm.slug) ? _c('span', {
    staticClass: "anchor",
    attrs: {
      "id": _vm.slug
    }
  }, [(_vm.trigger) ? _c('span', {
    attrs: {
      "data-header-trigger": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 235 */
/*!****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2071da5e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Faqs.vue ***!
  \****************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-faq",
    attrs: {
      "block": "lightest"
    }
  }, [_c('div', {
    staticClass: "home-faq__inner group group--first-last"
  }, [_c('h2', {
    staticClass: "h2 heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.faqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "home-faq__block"
    }, [_c('h4', {
      staticClass: "h4 heading home-faq__question"
    }, [_vm._v(_vm._s(faq.question))]), _vm._v(" "), _c('p', {
      staticClass: "p faq__answer"
    }, [_vm._v(" " + _vm._s(faq.answer))])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 236 */
/*!*******************************************************!*\
  !*** ./client/components/pages/home/Instructions.vue ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Instructions.vue */ 237),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-04a46ae6"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Instructions.vue */ 242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 237 */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/home/Instructions.vue + 1 modules ***!
  \*****************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/home/Instructions.vue (referenced with cjs require) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Block.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Button.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/vuex/dist/vuex.esm.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./client/components/modules/Block.vue
var Block = __webpack_require__(205);
var Block_default = /*#__PURE__*/__webpack_require__.n(Block);

// EXTERNAL MODULE: ./client/components/modules/Button.vue
var Button = __webpack_require__(10);
var Button_default = /*#__PURE__*/__webpack_require__.n(Button);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(5);

// EXTERNAL MODULE: ./client/router/index.js
var router = __webpack_require__(11);

// CONCATENATED MODULE: ./client/services/router.js




var router_reverseRoute = function reverseRoute(name) {
  var _router$resolve = router["a" /* default */].resolve(name),
      location = _router$resolve.location;

  return location.path;
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/home/Instructions.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules





// Images
var Instructions_images = {
  xray: __webpack_require__(/*! images/instructions/xray.svg */ 238),
  request: __webpack_require__(/*! images/instructions/request.svg */ 239),
  opinion: __webpack_require__(/*! images/instructions/opinion.svg */ 240),
  arrowRight: __webpack_require__(/*! images/icons/arrow-right.svg */ 241)
};

/* harmony default export */ var Instructions = __webpack_exports__["default"] = ({
  name: 'home-instructions',

  // Components
  components: {
    ModuleBlock: Block_default.a,
    ModuleButton: Button_default.a
  },

  // Data
  data: function data() {
    return {
      images: Instructions_images,
      instructionSteps: [{
        image: Instructions_images.xray,
        alt: '1',
        heading: 'You Request Your X\u2011Rays',
        copy: 'Once the patient creates an account, VeriTooth will email the dentist for a digital copy of the X rays. This is typically provided at no cost to the patient.'
      }, {
        image: Instructions_images.request,
        alt: '2',
        heading: 'Your Dentist Submits Your X\u2011Rays',
        copy: 'The dental office will be provided a link to upload the x-rays to a secure location for review. All personal information will be "scrubbed" to ensure patient privacy is protected.'
      }, {
        image: Instructions_images.opinion,
        alt: '3',
        heading: 'A Specialist Verifies The Work',
        copy: 'An impartial and qualified dental expert will compare the x-rays to clearly defined criteria for quality dental care as defined by the ADA (American Dental Association) and AAE (American Association of Endodontists)'
      }]
    };
  },


  computed: Object(vuex_esm["c" /* mapGetters */])('auth', ['isAuthenticated']),

  methods: {
    reverseRoute: router_reverseRoute
  }

});

/***/ }),
/* 238 */
/*!****************************************************!*\
  !*** ./client/assets/images/instructions/xray.svg ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/instructions/xray.782f0480.svg";

/***/ }),
/* 239 */
/*!*******************************************************!*\
  !*** ./client/assets/images/instructions/request.svg ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/instructions/request.3d9e69e3.svg";

/***/ }),
/* 240 */
/*!*******************************************************!*\
  !*** ./client/assets/images/instructions/opinion.svg ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/instructions/opinion.087589da.svg";

/***/ }),
/* 241 */
/*!****************************************************!*\
  !*** ./client/assets/images/icons/arrow-right.svg ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/icons/arrow-right.1c980f49.svg";

/***/ }),
/* 242 */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a46ae6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Instructions.vue ***!
  \************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-instructions",
    attrs: {
      "block": "lightest"
    }
  }, [_c('h2', {
    staticClass: "h2 home-instructions__heading mt0"
  }, [_vm._v("The process is safe, simple and secure!")]), _vm._v(" "), _c('div', {
    staticClass: "home-instructions__inner group group--last"
  }, [_c('div', {
    staticClass: "home-instructions__steps"
  }, _vm._l((_vm.instructionSteps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "home-instructions__step"
    }, [_c('div', {
      staticClass: "home-instructions__icon"
    }, [_c('img', {
      attrs: {
        "src": step.image,
        "alt": step.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "home-instructions__content"
    }, [_c('h4', {
      staticClass: "home-instructions__heading h4 fw-bold"
    }, [_vm._v(_vm._s(step.heading))]), _vm._v(" "), _c('p', {
      staticClass: "p"
    }, [_vm._v(_vm._s(step.copy))])]), _vm._v(" "), (index <= _vm.instructionSteps.length - 2) ? _c('div', {
      staticClass: "home-instructions__arrow"
    }, [_c('img', {
      attrs: {
        "src": _vm.images.arrowRight,
        "alt": "Next Step"
      }
    })]) : _vm._e()])
  })), _vm._v(" "), _c('module-button', {
    staticClass: "home-instructions__button",
    attrs: {
      "button": "primary",
      "link": _vm.isAuthenticated ? "request" : "register-patient",
      "query": _vm.isAuthenticated ? {} : {
        redirect: _vm.reverseRoute("register-patient")
      },
      "size": "l",
      "label": "Start My Request"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 243 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/home/Dentists.vue ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/home/Dentists.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_scroll__ = __webpack_require__(/*! services/scroll */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Form__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Modules



// Images
var images = {
  pages: {
    'four': __webpack_require__(/*! images/home/dentists-page-3.svg */ 215),
    'three': __webpack_require__(/*! images/home/dentists-page-2.svg */ 216),
    'two': __webpack_require__(/*! images/home/dentists-page-4.svg */ 217),
    'one': __webpack_require__(/*! images/home/dentists-page-1.svg */ 218)
  }
};

// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-dentists',

  // Compononts
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_2_modules_Block___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_3_modules_Form___default.a
  },

  // Data
  data: function data() {
    return {
      animationClass: false,
      images: images,
      heading: 'Are you a Dentist or Endodontist and want to help?',
      copy: ['Join the growing team of experts who want to highlight quality in the dental field. We\'re always looking for more reviewers, advisors and thought leaders. Please sign up now and we\'ll send you information on how you can get involved.']
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['isAuthenticated']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel'])),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('auth', ['requestLogout']), {
    animation: function animation() {
      this.animationClass = !this.animationClass;
    },
    action: function action() {
      var model = this.getModel('register-dentist');

      sessionStorage.setItem('dentist_email', model.dentistEmail || '');

      if (this.isAuthenticated) {
        this.requestLogout({
          noRedirect: true
        });
      }

      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, 500);
      });
    },
    success: function success() {
      var _this = this;

      setTimeout(function () {
        _this.$router.push({
          name: 'register-dentist'
        });
      }, 500);
    },
    fail: function fail(_fail) {
      console.warn(_fail);
    }
  }),

  // Lifecycle
  mounted: function mounted() {
    var _this2 = this;

    Object(__WEBPACK_IMPORTED_MODULE_1_services_scroll__["a" /* createScroll */])('dentists-papers', {
      el: this.$el,
      move: function move(e) {
        if (e.top.topPercent >= -50) {
          _this2.animationClass = true;
        } else if (e.top.topPercent < -100) {
          _this2.animationClass = false;
        }
      }
    });
  },
  destroyed: function destroyed() {
    Object(__WEBPACK_IMPORTED_MODULE_1_services_scroll__["b" /* destroyScroll */])('dentists-papers');
  }
});

/***/ }),
/* 244 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bda401e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Dentists.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-dentists",
    attrs: {
      "block": "light"
    }
  }, [_c('div', {
    staticClass: "home-dentists__inner group group--first-last"
  }, [_c('div', {
    class: [
      "home-dentists__image",
      ("home-dentists__image--" + (_vm.animationClass ? "open" : "closed")) ]
  }, [_c('div', {
    staticClass: "home-dentists__image-wrapper"
  }, _vm._l((_vm.images.pages), function(image, index) {
    return _c('img', {
      key: index,
      class: [
        "home-dentists__paper",
        ("home-dentists__paper--" + index) ],
      attrs: {
        "src": image
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "home-dentists__content"
  }, [_c('h2', {
    staticClass: "h3 mt0 home-dentists__heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.copy), function(p, index) {
    return _c('p', {
      key: index,
      staticClass: "p",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "home-dentists__form"
  }, [_c('module-form', {
    attrs: {
      "form-id": "register-dentist",
      "fields": {
        dentistEmail: {
          type: "email",
          label: "Email",
          labelHidden: true,
          placeholder: "Enter Your Email",
        },
      },
      "button": "primary",
      "submit": "Sign up now",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)], 2)])])
},staticRenderFns: []}

/***/ }),
/* 245 */
/*!***********************************************!*\
  !*** ./client/components/pages/home/Hero.vue ***!
  \***********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Hero.vue */ 246),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-756cc88a"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Hero.vue */ 247),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/home/Hero.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/home/Hero.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Form__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-hero',

  // Components
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_2_modules_Block___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_3_modules_Form___default.a
  },

  // Data
  data: function data() {
    return {
      hero: {
        heading: 'Ensure quality dental care',
        content: ['How do you judge the clinical quality of a root canal?', 'We created VeriTooth as a way to help patients and dentists validate the quality of work patients receive.', '<b>Let the work speak for itself</b>', 'VeriTooth essentially performs a "spot check" on your x-rays to confirm if the work was done within dental industry standards and guidelines.  All work is reviewed by an independent specialist and your identity is hidden.  It\u2019s completely secure, unbiased, and impartial']
      }
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['isAuthenticated']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('review', ['reviewNomenclature']), {
    items: function items() {
      var items = [];

      Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(this.reviewNomenclature.procedure || [], function (i, v) {
        items.push({
          option: v.name,
          value: v.id
        });
      });

      return items;
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('review', ['getNomenclature']), {
    action: function action() {
      var _this = this;

      var model = this.getModel('hero-procedure');
      sessionStorage.setItem('procedure', model.procedure);

      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, 500);

        setTimeout(function () {
          if (!_this.isAuthenticated) {
            _this.$router.push({
              name: 'register-patient',
              query: {
                redirect: 'request'
              }
            });
          } else {
            _this.$router.push({
              name: 'request'
            });
          }
        }, 1000);
      });
    }
  }),

  // Lifecycle
  created: function created() {
    this.getNomenclature();
  }
});

/***/ }),
/* 247 */
/*!****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756cc88a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Hero.vue ***!
  \****************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-hero",
    attrs: {
      "block": "transparent"
    }
  }, [_c('div', {
    staticClass: "home-hero__inner group group--first group--last"
  }, [_c('div', {
    staticClass: "home-hero__content"
  }, [_c('h1', {
    staticClass: "home-hero__heading h1 mt0 fw-semibold",
    domProps: {
      "innerHTML": _vm._s(_vm.hero.heading)
    }
  }), _vm._v(" "), _vm._l((_vm.hero.content), function(copy, index) {
    return _c('p', {
      key: index,
      staticClass: "home-hero__copy p",
      domProps: {
        "innerHTML": _vm._s(copy)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "home-hero__get-started"
  }, [_c('div', {
    staticClass: "home-hero__form"
  }, [_c('h4', {
    staticClass: "h4 mt0"
  }, [_vm._v("Get your dental work verified now")]), _vm._v(" "), _c('module-form', {
    attrs: {
      "form-id": "hero-procedure",
      "fields": {
        procedure: {
          label: "Procedure Type",
          labelHidden: true,
          type: "select",
          placeholder: "Select your procedure",
          items: _vm.items,
        },
      },
      "button": "primary",
      "button-size": "m",
      "submit": "Continue",
      "action": _vm.action
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 248 */
/*!*****************************************************!*\
  !*** ./client/components/pages/home/OurMission.vue ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OurMission.vue */ 249),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ca063abe"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OurMission.vue */ 255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/home/OurMission.vue ***!
  \***************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/home/OurMission.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_home_Block__ = __webpack_require__(/*! pages/home/Block */ 212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_home_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_home_Block__);
//
//
//
//
//
//

// Modules


// Images
var images = {
  ourMission: __webpack_require__(/*! images/home/our-mission.svg */ 213),
  tick: __webpack_require__(/*! images/icons/tick.svg */ 214)
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-our-mission',

  // Compononts
  components: {
    PagesHomeBlock: __WEBPACK_IMPORTED_MODULE_0_pages_home_Block___default.a
  },

  // Data
  data: function data() {
    return {
      block: {
        slug: 'why',
        block: 'lightest',
        image: {
          image: images.ourMission,
          alt: 'Our Mission'
        },
        content: {
          heading: 'Our Mission',
          subheading: 'Help us highlight quality in the dental industry',
          copy: ['How can you find a good quality dentist and trust the work he/she does? Online reviews cover things like cost, timeliness and the office environment. At VeriTooth we go deeper to actually assess the quality of the dental work itself.', 'Dentists spend over 8 years learning their profession. And dentistry is a science with clear guidelines for what is and isn\u2019t quality care. These guidelines were defined by the AAE (American Association of Endodontists), the ADA (American Dental Association) recognized experts in root canal. We\'ve input those criteria into the platform and use them to help validate the quality of work provided.', 'Now both patients and dentists can have a transparent conversation about quality dental care.']
        }
      }
    };
  }
});

/***/ }),
/* 250 */
/*!**********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/home/Block.vue ***!
  \**********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/home/Block.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_HomeContent__ = __webpack_require__(/*! modules/HomeContent */ 251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_HomeContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_HomeContent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-block',

  // Compononts
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_0_modules_Block___default.a,
    ModuleHomeContent: __WEBPACK_IMPORTED_MODULE_1_modules_HomeContent___default.a
  },

  // Props
  props: {
    block: Object
  }
});

/***/ }),
/* 251 */
/*!***************************************************!*\
  !*** ./client/components/modules/HomeContent.vue ***!
  \***************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HomeContent.vue */ 252),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-60de1d6e"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HomeContent.vue */ 253),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/HomeContent.vue ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/HomeContent.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "module-home-content",

  props: {
    content: Object
  }
});

/***/ }),
/* 253 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60de1d6e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/HomeContent.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-block__content"
  }, [_c('h2', {
    staticClass: "h2 home-block__heading mt0"
  }, [_vm._v("\n    " + _vm._s(_vm.content.heading) + "\n  ")]), _vm._v(" "), (_vm.content.subheading) ? _c('h3', {
    staticClass: "h3 home-block__subheading fw-semibold"
  }, [_vm._v("\n    " + _vm._s(_vm.content.subheading) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.content.copy), function(paragraph, index) {
    return _c('p', {
      key: index,
      class: [
        "p",
        index + 1 === _vm.content.copy.length ? "mb0" : "" ]
    }, [_vm._v("\n    " + _vm._s(paragraph) + "\n  ")])
  }), _vm._v(" "), (_vm.content.list) ? _c('div', {
    staticClass: "home-block__list"
  }, [_c('ul', _vm._l((_vm.content.list), function(point, index) {
    return _c('li', {
      key: index,
      staticClass: "home-block__list-item"
    }, [(_vm.content.bullet) ? _c('img', {
      attrs: {
        "src": _vm.content.bullet,
        "alt": "bullet"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(point))])])
  }))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 254 */
/*!*****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcf4f0c8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/Block.vue ***!
  \*****************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    class: [
      ("" + (_vm.block.slug)),
      "home-block" ],
    attrs: {
      "block": _vm.block.block
    }
  }, [_c('div', {
    class: [
      "home-block__inner",
      _vm.block.reversed ? "home-block--reversed" : "",
      _vm.block.large ? "home-block--large" : "",
      ("home-block--" + (_vm.block.block)), !_vm.block.large ? "group group--first-last-small" : "" ]
  }, [_c('div', {
    class: [
      "home-block__image",
      _vm.block.large ? "home-block__image--large" : "",
      ("home-block__image--" + (_vm.block.block)) ],
    style: (("backgroundImage: url(" + (_vm.block.image.image) + ")"))
  }), _vm._v(" "), _c('module-home-content', {
    attrs: {
      "content": _vm.block.content
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 255 */
/*!**********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca063abe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/home/OurMission.vue ***!
  \**********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pages-home-block', {
    attrs: {
      "block": _vm.block
    }
  })
},staticRenderFns: []}

/***/ }),
/* 256 */
/*!************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aa37216"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue ***!
  \************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--home"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _vm._l((_vm.components), function(component, index) {
    return _c(component, {
      key: index,
      tag: "component"
    })
  }), _vm._v(" "), _c('ui-footer')], 2)
},staticRenderFns: []}

/***/ }),
/* 257 */
/*!******************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Terms.vue ***!
  \******************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/Terms.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models_content_terms_md__ = __webpack_require__(/*! models/content/terms.md */ 258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models_content_terms_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_models_content_terms_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models_content_privacy_md__ = __webpack_require__(/*! models/content/privacy.md */ 261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models_content_privacy_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_models_content_privacy_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ui_Footer__ = __webpack_require__(/*! ui/Footer */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ui_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ui_Footer__);
//
//
//
//
//
//
//
//
//
//
//

// Models




// Services


// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-terms',

  // Meta data
  metaInfo: function metaInfo() {
    return {
      title: __WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */][this.$route.name].title,
      meta: Object(__WEBPACK_IMPORTED_MODULE_3_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */][this.$route.name].meta)
    };
  },


  // Components
  components: {
    UiFooter: __WEBPACK_IMPORTED_MODULE_4_ui_Footer___default.a
  },

  // Data
  data: function data() {
    return {
      map: {
        terms: __WEBPACK_IMPORTED_MODULE_1_models_content_terms_md___default.a,
        privacy: __WEBPACK_IMPORTED_MODULE_2_models_content_privacy_md___default.a
      }
    };
  },

  computed: {
    content: function content() {
      return this.map[this.$route.name];
    }
  }
});

/***/ }),
/* 258 */
/*!****************************************!*\
  !*** ./client/models/content/terms.md ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! !vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./terms.md */ 259);

/***/ }),
/* 259 */
/*!**********************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./client/models/content/terms.md ***!
  \**********************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-19bdf508"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./terms.md */ 260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/*!*************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19bdf508"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./client/models/content/terms.md ***!
  \*************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('p', [_c('strong', [_vm._v("Terms and Conditions of Use")])]), _vm._v(" "), _c('p', [_vm._v("PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY BEFORE USING THIS SITE.")]), _vm._v(" "), _c('p', [_vm._v("By using this site, you signify your assent to these Terms and Conditions. If you do not agree to all of these Terms and Conditions of use, do not use this site!")]), _vm._v(" "), _c('p', [_vm._v("Veritooth, LLC. (\"Veritooth\") may revise and update these Terms and Conditions at any time. Your continued usage of the Veritooth website (\"Veritooth Site,\" or the \"Site,\") will mean you accept those changes.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("The Site Does Not Provide Medical Advice")])]), _vm._v(" "), _c('p', [_vm._v("The contents of the Veritooth Site, such as text, graphics, images, information obtained from Veritooth's licensors, and other material contained on the Veritooth Site (\"Content\") are for informational purposes only. The Content is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of something you have read on the Veritooth Site!")]), _vm._v(" "), _c('p', [_vm._v("If you think you may have a medical emergency, call your doctor or 911 immediately. Veritooth does not recommend or endorse any specific tests, physicians, products, procedures, opinions, or other information that may be mentioned on the Site. Reliance on any information provided by Veritooth, Veritooth employees, others appearing on the Site at the invitation of Veritooth, or other visitors to the Site is solely at your own risk.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Children's Privacy")])]), _vm._v(" "), _c('p', [_vm._v("We are committed to protecting the privacy of children. You should be aware that this Site is not intended or designed to attract children under the age of 13. We do not collect personally identifiable information from any person we actually know is a child under the age of 13.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Use of Materials")])]), _vm._v(" "), _c('p', [_vm._v("All materials posted on this website are protected by the copyright laws in the United States and in foreign countries.  Veritooth authorizes you to view or download a single copy of the material on the Veritooth Site solely for your personal, noncommercial use if you include the copyright notice located at the end of the material, for example: \"©2016, Veritooth, LLC. All rights reserved\" and other copyright and proprietary rights notices that are contained in the Content. Any special rules for the use of certain software and other items accessible on the Veritooth Site may be included elsewhere within the Site and are incorporated into these Terms and Conditions by reference.")]), _vm._v(" "), _c('p', [_vm._v("Title to the materials remains with Veritooth or its licensors. Any use of the materials not expressly permitted by these Terms and Conditions is a breach of these Terms and Conditions and may violate copyright, trademark, and other laws. Content and features are subject to change or termination without notice in the editorial discretion of Veritooth. All rights not expressly granted herein are reserved to Veritooth and its licensors. Certain content on this site is licensed under U.S. Patent No. 6,585,516.")]), _vm._v(" "), _c('p', [_vm._v("If you violate any of these Terms and Conditions, your permission to use the materials automatically terminates and you must immediately destroy any copies you have made of any portion of the materials.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Liability of Veritooth and Its Licensors")])]), _vm._v(" "), _c('p', [_vm._v("The use of the Veritooth Site and the Content is at your own risk.")]), _vm._v(" "), _c('p', [_vm._v("When using the Veritooth Site, information will be transmitted over a medium that may be beyond the control and jurisdiction of Veritooth and its suppliers. Accordingly, Veritooth assumes no liability for or relating to the delay, failure, interruption, or corruption of any data or other information transmitted in connection with use of the Veritooth Site.")]), _vm._v(" "), _c('p', [_vm._v("The Veritooth Site and the content are provided on an \"as is\" basis. VERITOOTH, ITS LICENSORS, AND ITS SUPPLIERS, TO THE FULLEST EXTENT PERMITTED BY LAW, DISCLAIM ALL WARRANTIES, EITHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT OF THIRD PARTIES' RIGHTS, AND FITNESS FOR PARTICULAR PURPOSE. Without limiting the foregoing, Veritooth, its licensors, and its suppliers make no representations or warranties about the following:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("The accuracy, reliability, completeness, currentness, or timeliness of the Content, software, text, graphics, links, or communications provided on or through the use of the Veritooth Site or Veritooth.")]), _vm._v(" "), _c('li', [_vm._v("The satisfaction of any government regulations requiring disclosure of information on prescription drug products or the approval or compliance of any software tools with regard to the Content contained on the Veritooth Site.")])]), _vm._v(" "), _c('p', [_vm._v("In no event shall Veritooth, its licensors, its suppliers, or any third parties mentioned on the Veritooth Site be liable for any damages (including, without limitation, incidental and consequential damages, personal injury/wrongful death, lost profits, or damages resulting from lost data or business interruption) resulting from the use of or inability to use the Veritooth Site or the Content, whether based on warranty, contract, tort, or any other legal theory, and whether or not Veritooth, its licensors, its suppliers, or any third parties mentioned on the Veritooth Site are advised of the possibility of such damages. Veritooth, its licensors, its suppliers, or any third parties mentioned on the Veritooth Site shall be liable only to the extent of actual damages incurred by you, not to exceed U.S. $1000. Veritooth, its licensors, its suppliers, or any third parties mentioned on the Veritooth Site are not liable for any personal injury, including death, caused by your use or misuse of the Site, Content, or Public Areas (as defined below). Any claims arising in connection with your use of the Site, any Content, or the Public Areas must be brought within one (1) year of the date of the event giving rise to such action occurred. Remedies under these Terms and Conditions are exclusive and are limited to those expressly provided for in these Terms and Conditions.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("User Submissions")])]), _vm._v(" "), _c('p', [_vm._v("The personal information you submit to Veritooth is governed by the Veritooth Privacy Policy. To the extent there is an inconsistency between this Agreement and the Veritooth Privacy Policy, this Agreement shall govern.")]), _vm._v(" "), _c('p', [_vm._v("The Site contains functionality (including blogs, message boards, postings, user reviews, etc.) that allows users to upload content to the Site (collectively \"Public Areas\") and users may also upload content via our official brand presence on social media platforms and branded hashtags (including, without limitation Facebook, Twitter, Google Plus, YouTube, Instagram, and Pinterest, collectively \"Social Media Platforms\"). You agree that you will not upload or transmit any communications or content of any type to the Public Areas or Social Media Platforms that infringe or violate any rights of any party. By submitting communications or content to the Public Areas or Social Media Platforms, you agree that such submission is non-confidential for all purposes. It is important to note that Veritooth is not responsible for the operation, terms of use or policies of any Social Media Platform. Before using any Social Media Platform you should review its terms of use and policies, including its privacy policy.")]), _vm._v(" "), _c('p', [_vm._v("If you make any such submission you agree that you will not send or transmit to Veritooth by email, (including through the email addresses listed on the \"Contact Us\" page) any communication or content that infringes or violates any rights of any party. If you submit any business information, idea, concept or invention to Veritooth by email, you agree such submission is non-confidential for all purposes.")]), _vm._v(" "), _c('p', [_vm._v("If you make any submission to a Public Area or a Social Media Platform or if you submit any business information, idea, concept or invention to Veritooth by email, you automatically grant-or warrant that the owner of such content or intellectual property has expressly granted-Veritooth a royalty-free, perpetual, irrevocable, world-wide nonexclusive license to use, reproduce, create derivative works from, modify, publish, edit, translate, distribute, perform, and display the communication or content in any media or medium, or any form, format, or forum now known or hereafter developed. Veritooth may sublicense its rights through multiple tiers of sublicenses. If you wish to keep any business information, ideas, concepts or inventions private or proprietary, do not submit them to the Public Areas or Social Media Platforms or to Veritooth by email. We try to answer every email in a timely manner, but are not always able to do so.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("User Submissions — Image, Video, Audio Files")])]), _vm._v(" "), _c('p', [_vm._v("You agree to only post or upload media (like photos, videos or audio) on the Veritooth site or a Social Media Platform that you have taken yourself or that you have all rights to transmit and license and which do not violate trademark, copyright, privacy or any other rights of any other person. Photos or videos taken by others are usually copyrighted by the owner.")]), _vm._v(" "), _c('p', [_vm._v("To protect your privacy, you agree that you will not submit any media that contains Personally Identifiable Information (like name, phone number, email address or web site URL) of you or of anyone else. Uploading media like images or video of other people without their permission is strictly prohibited.")]), _vm._v(" "), _c('p', [_vm._v("By uploading any media on the Veritooth site or a Social Media Platform, you warrant that you have permission from all persons appearing in your media for you to make this contribution and grant rights described herein. Never post a picture or video of or with someone else unless you have their explicit permission.")]), _vm._v(" "), _c('p', [_vm._v("It is strictly prohibited to upload media of any kind that contain expressions of hate, abuse, offensive images or conduct, obscenity, pornography, sexually explicit or any material that could give rise to any civil or criminal liability under applicable law or regulations or that otherwise may be in conflict with these Terms and Conditions, the Veritooth Advertising Policy and the Veritooth Privacy Policy.")]), _vm._v(" "), _c('p', [_vm._v("You agree that you will not upload any material that contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer software or this Web site.")]), _vm._v(" "), _c('p', [_vm._v("By uploading any media on the Veritooth site or a Social Media Platform like a photo or video, (a) you grant to Veritooth a perpetual, non-exclusive, worldwide, royalty-free license to use, copy, print, display, reproduce, modify, publish, post, transmit and distribute the media and any material included in the media; (b) you certify that any person pictured in the submitted media (or, if a minor, his/her parent/legal guardian) authorizes Veritooth to use, copy, print, display, reproduce, modify, publish, post, transmit and distribute the media and any material included in such media; and (c) you agree to indemnify Veritooth and its affiliates, directors, officers and employees and hold them harmless from any and all claims and expenses, including attorneys' fees, arising from the media and/or your failure to comply with these the terms described in this document.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth reserves the right to review all media prior to submission to the site and to remove any media for any reason, at any time, without prior notice, at our sole discretion")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Passwords")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth has several tools that allow you to record and store information. You are responsible for taking all reasonable steps to ensure that no unauthorized person shall have access to your Veritooth passwords or accounts. It is your sole responsibility to (1) control the dissemination and use of sign-in name, screen name and passwords; (2) authorize, monitor, and control access to and use of your Veritooth account and password; (3) promptly inform Veritooth if you believe your account or password has been compromised or if there is any other reason you need to deactivate a password. To send us an email, use the \"Contact Us\" links located at the bottom of every page of our site. You grant Veritooth and all other persons or entities involved in the operation of the Site the right to transmit, monitor, retrieve, store, and use your information in connection with the operation of the Site. Veritooth cannot and does not assume any responsibility or liability for any information you submit, or your or third parties' use or misuse of information transmitted or received using Veritooth tools and services.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Veritooth Community and Member to Member Areas (\"Public Areas\") and Social Media Platforms")])]), _vm._v(" "), _c('p', [_vm._v("If you use a Public Area, such as message boards, blogs, user reviews or other member communities, or post on any Social Media Platform, you are solely responsible for your own communications, the consequences of posting those communications, and your reliance on any communications found in the Public Areas or on the Social Media Platforms. Veritooth and its licensors are not responsible for the consequences of any communications in the Public Areas or on Social Media Platforms. In cases where you feel threatened or believe someone else is in danger, you should contact your local law enforcement agency immediately. If you think you may have a medical emergency, call your doctor or 911 immediately.")]), _vm._v(" "), _c('p', [_vm._v("In consideration of being allowed to use the Public Areas and Social Media Platforms, you agree that the following actions shall constitute a material breach of these Terms and Conditions:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Using a Public Area or Social Media Platform for any purpose in violation of local, state, national, or international laws;")]), _vm._v(" "), _c('li', [_vm._v("Posting material that infringes on the intellectual property rights of others or on the privacy or publicity rights of others;")]), _vm._v(" "), _c('li', [_vm._v("Posting material that is unlawful, obscene, defamatory, threatening, harassing, abusive, slanderous, hateful, or embarrassing to any other person or entity as determined by Veritooth in its sole discretion;")]), _vm._v(" "), _c('li', [_vm._v("Posting advertisements or solicitations of business;")]), _vm._v(" "), _c('li', [_vm._v("After receiving a warning, continuing to disrupt the normal flow of dialogue, or posting comments that are not related to the topic being discussed (unless it is clear the discussion is free-form);")]), _vm._v(" "), _c('li', [_vm._v("Posting chain letters or pyramid schemes;")]), _vm._v(" "), _c('li', [_vm._v("Impersonating another person;")]), _vm._v(" "), _c('li', [_vm._v("Distributing viruses or other harmful computer code;")]), _vm._v(" "), _c('li', [_vm._v("Harvesting, scraping or otherwise collecting information about others, including email addresses, without their identification for posting or viewing comments;")]), _vm._v(" "), _c('li', [_vm._v("Allowing any other person or entity to use your identification for posting or viewing comments;")]), _vm._v(" "), _c('li', [_vm._v("Posting the same note more than once or \"spamming\"; or")]), _vm._v(" "), _c('li', [_vm._v("Engaging in any other conduct that restricts or inhibits any other person from using or enjoying the Public Area, Social Media Platform or the Site, or which, in the judgment of Veritooth, exposes Veritooth or any of its customers or suppliers to any liability or detriment of any type.")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth Reserves the Right (but is Not Obligated) to Do Any or All of the Following:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Record the dialogue in public chat rooms.")]), _vm._v(" "), _c('li', [_vm._v("Investigate an allegation that a communication(s) do(es) not conform to the terms of this section and determine in its sole discretion to remove or request the removal of the communication(s).")]), _vm._v(" "), _c('li', [_vm._v("Remove communications which are abusive, illegal, or disruptive, or that otherwise fail to conform with these Terms and Conditions.")]), _vm._v(" "), _c('li', [_vm._v("Terminate a user's access to any or all Public Areas and/or the Veritooth Site upon any breach of these Terms and Conditions.")]), _vm._v(" "), _c('li', [_vm._v("Monitor, edit, or disclose any communication in the Public Areas or on a Social Media Platform.")]), _vm._v(" "), _c('li', [_vm._v("Edit or delete any communication(s) posted on the Veritooth Site, regardless of whether such communication(s) violate these standards.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Veritooth or its licensors have no liability or responsibility to users of the Veritooth Site or any other person or entity for performance or nonperformance of the aforementioned activities")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Advertisements, Searches, and Links to Other Sites")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth may provide links to third-party web sites. Veritooth also may select certain sites as priority responses to search terms you enter and Veritooth may agree to allow advertisers to respond to certain search terms with advertisements or sponsored content. Veritooth does not recommend and does not endorse the content on any third-party websites. Veritooth is not responsible for the content of linked third-party sites, sites framed within the Veritooth Site, third-party sites provided as search results, or third-party advertisements, and does not make any representations regarding their content or accuracy. Your use of third-party websites is at your own risk and subject to the terms and conditions of use for such sites. Veritooth does not endorse any product, service, or treatment advertised on the Veritooth Site.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Indemnity")])]), _vm._v(" "), _c('p', [_vm._v("You agree to defend, indemnify, and hold Veritooth, its officers, directors, employees, agents, licensors, and suppliers, harmless from and against any claims, actions or demands, liabilities and settlements including without limitation, reasonable legal and accounting fees, resulting from, or alleged to result from, your violation of these Terms and Conditions.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("General")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth is based in California, in the United States of America with principal offices in California. Veritooth makes no claims that Veritooth or any Content are appropriate or may be downloaded outside of the United States. Access to the Content may not be legal by certain persons or in certain countries. If you access the Veritooth Site from outside the United States, you do so at your own risk and are responsible for compliance with the laws of your jurisdiction.")]), _vm._v(" "), _c('p', [_vm._v("The following provisions survive the expiration or termination of this Agreement for any reason whatsoever: Liability, User Submissions, User Submissions – image, video, audio files, Indemnity, Jurisdiction, and Complete Agreement.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jurisdiction")])]), _vm._v(" "), _c('p', [_vm._v("You expressly agree that exclusive jurisdiction for any dispute with Veritooth, or in any way relating to your use of the Veritooth Site, resides in the courts of the State of California and you further agree and expressly consent to the exercise of personal jurisdiction in the courts of the State of California in connection with any such dispute including any claim involving Veritooth or its affiliates, subsidiaries, employees, contractors, officers, directors, telecommunication providers, and content providers.")]), _vm._v(" "), _c('p', [_vm._v("These Terms and Conditions are governed by the internal substantive laws of the State of California, without respect to its conflict of laws principles. If any provision of these Terms and Conditions is found to be invalid by any court having competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of these Terms and Conditions, which shall remain in full force and effect. No waiver of any of these Terms and Conditions shall be deemed a further or continuing waiver of such term or condition or any other term or condition.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Notice and Takedown Procedures; and Copyright Agent")])]), _vm._v(" "), _c('p', [_vm._v("If you believe any materials accessible on or from the Site infringe your copyright, you may request removal of those materials (or access thereto) from this web site by contacting Veritooth's copyright agent (identified below) and providing the following information:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Identification of the copyrighted work that you believe to be infringed. Please describe the work, and where possible include a copy or the location (e.g., URL) of an authorized version of the work.")]), _vm._v(" "), _c('li', [_vm._v("Identification of the material that you believe to be infringing and its location. Please describe the material, and provide us with its URL or any other pertinent information that will allow us to locate the material.")]), _vm._v(" "), _c('li', [_vm._v("Your name, address, telephone number and (if available) e-mail address.")]), _vm._v(" "), _c('li', [_vm._v("A statement that you have a good faith belief that the complained of use of the materials is not authorized by the copyright owner, its agent, or the law.")]), _vm._v(" "), _c('li', [_vm._v("A statement that the information that you have supplied is accurate, and indicating that \"under penalty of perjury,\" you are the copyright owner or are authorized to act on the copyright owner's behalf.")]), _vm._v(" "), _c('li', [_vm._v("A signature or the electronic equivalent from the copyright holder or authorized representative.")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth's agent for copyright issues relating to this web site is as follows:")]), _vm._v(" "), _c('p', [_vm._v("Veritooth, LLC")]), _vm._v(" "), _c('p', [_vm._v("Attn: Office of Privacy")]), _vm._v(" "), _c('p', [_vm._v("support@veritooth.com")]), _vm._v(" "), _c('p', [_vm._v("In an effort to protect the rights of copyright owners, Veritooth maintains a policy for the termination, in appropriate circumstances, of subscribers and account holders of the Site who are repeat infringers.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Complete Agreement")])]), _vm._v(" "), _c('p', [_vm._v("Except as expressly provided in a particular \"legal notice\" on the Veritooth Site, these Terms and Conditions and the Veritooth Privacy Policy constitute the entire agreement between you and Veritooth with respect to the use of the Veritooth Site, and Content.")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your cooperation. We hope you find the Veritooth.com Site helpful and convenient to use! Questions or comments regarding this website, including any reports of non-functioning links, should be submitted to support@veritooth.com.")])])
}]}

/***/ }),
/* 261 */
/*!******************************************!*\
  !*** ./client/models/content/privacy.md ***!
  \******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! !vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./privacy.md */ 262);

/***/ }),
/* 262 */
/*!************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./client/models/content/privacy.md ***!
  \************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7eaf505b"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./privacy.md */ 263),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eaf505b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./client/models/content/privacy.md ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('p', [_c('strong', [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('p', [_vm._v("This privacy policy applies to the Veritooth web site. Our contact information is:")]), _vm._v(" "), _c('p', [_vm._v("support@veritooth.com")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("GENERAL INTRODUCTORY INFORMATION")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth understands how important the privacy of personal information is to our users. This Privacy Policy will tell you what information we collect about you and about your use of Veritooth and its services. It will explain the choices you have about how your personal information is used and how we protect that information. We urge you to read this Privacy Policy carefully.")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy applies to websites owned and operated by Veritooth that are intended for use by consumers (non-professionals) for non-commercial personal, family or household purposes and including the mobile optimized versions of these sites and our Mobile Device Applications or \"Apps\" (we refer to these sites and Apps collectively as the \"Veritooth Sites\"). We refer to the Veritooth Sites and Apps, along with the information and services made available to you through the Veritooth Sites and Apps, as the \"Services.\"  By using the Veritooth Sites and Apps you consent to the data practices described in this Privacy Policy.")]), _vm._v(" "), _c('p', [_vm._v("Except where noted, statements in this Privacy Policy with respect to the Veritooth Sites also apply to the Apps. If you do not want us to collect, use or disclose information about you and your use of the Services as described in this Privacy Policy, then you should not use the Services. By using the Services, you must agree to the Veritooth Terms of Use, which is the contract between us and users of the Services.  By accepting the Veritooth Terms of Use, you confirm that you have read and understand this Privacy Policy and the Veritooth Cookie Policy and you acknowledge that we will store, use and otherwise process your information in the United States where we are located.")]), _vm._v(" "), _c('p', [_vm._v("References to \"Veritooth,\" \"we\" or \"us\" mean Veritooth LLC, including any company that Veritooth LLC controls. Veritooth may share information among its subsidiaries or websites that it owns or controls, but information collected under this Privacy Policy is always protected under the terms of this Privacy Policy. Except as otherwise noted in this Privacy Policy, Veritooth LLC is the data controller responsible for the processing of your personal information as described in this Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("PURPOSES FOR COLLECTING INFORMATION")])]), _vm._v(" "), _c('p', [_vm._v("Collecting information provides not only benefits to us as we figure out new services and develop best practices for the site but also specific benefits to our website visitors and by providing this information, our staff or authorized third-parties as outlined in our Terms of Service can contact you regarding your post or otherwise follow-up if necessary. The following are reasons that we may collect and maintain your data:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Verifying submissions and reports as such circumstances or need may arise – Veritooth does not verify the accuracy of any post or reviewing doctor. Please see our "), _c('strong', [_vm._v("Terms of Service")]), _vm._v(" for more information;")]), _vm._v(" "), _c('li', [_vm._v("To provide, improve and create new Services;")]), _vm._v(" "), _c('li', [_vm._v("Providing advertising information for products and services that may be of interest to you;")]), _vm._v(" "), _c('li', [_vm._v("Sending you emails that may pertain to your rights (such as information regarding a subpoena for your identifying author information) or to provide you information about news, tips, resources, etc.;")]), _vm._v(" "), _c('li', [_vm._v("Website and system administration;")]), _vm._v(" "), _c('li', [_vm._v("Research and development;")]), _vm._v(" "), _c('li', [_vm._v("Preserving social history as governed by existing US law or policy (archiving information in the public interest);")]), _vm._v(" "), _c('li', [_vm._v("Users filing a report, submission or rebuttal may opt-in if they would be willing to be contacted by the media, a consumer advocate, other medical professional, or lawyer to help further their cause or to help with an investigation against a business or an individual;")]), _vm._v(" "), _c('li', [_vm._v("To provide you and people with similar demographic characteristics and interests with more relevant content including advertising both on and off the Veritooth Sites and Apps;")]), _vm._v(" "), _c('li', [_vm._v("To offer lead generation services;")]), _vm._v(" "), _c('li', [_vm._v("To detect and defend against fraud and other threats to the Services and our users;")]), _vm._v(" "), _c('li', [_vm._v("To identify issues with the Services;")]), _vm._v(" "), _c('li', [_vm._v("To conduct research and measurement activities, including those described below; and")]), _vm._v(" "), _c('li', [_vm._v("To administer your account")])]), _vm._v(" "), _c('p', [_vm._v("In addition, Veritooth may use personal information about you for other purposes that are disclosed to you at the time we collect the information and/or with your consent.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth may combine your personal information and other information collected about your use of the Services, and also supplement with information from external sources for the purposes described in this Privacy Policy. For example, information that Veritooth collects about you may be combined by Veritooth with other information available to Veritooth through third parties for research and measurement purposes, including measuring the effectiveness of content, advertising or programs. This information from other sources may include age, gender, demographic, geographic, personal interests, product purchase activity or other information. We may report aggregate information, which is not able to be identified back to an individual user of the Veritooth Sites, to our current or prospective advertisers and other business partners.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth will not sell your personal information to third parties for their use without your consent.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Information Collected About You")])]), _vm._v(" "), _c('p', [_vm._v("Some of our Services do not retain your personal information, while others store your personal information in accordance with this Privacy Policy. Even if you do not register with or provide any personal information to Veritooth, we collect information about your use of the Veritooth Sites and Apps and the Services. We may also acquire information about our users from external sources.  If you believe that one of your contacts has provided us with your personal information and you would like to request that it be removed from our database, please use the Contact Us link provided at the bottom of every page of the Veritooth Sites.")]), _vm._v(" "), _c('p', [_vm._v("When you use the Services, we collect information as follows:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Registration")])]), _vm._v(" "), _c('p', [_vm._v("While you may use most of the Services without registering, certain Services do require that you register with Veritooth for them to function properly. If you choose to register or update an existing account with Veritooth or access certain Services, you may be required to provide certain personal information, such as your name, address, telephone number, gender, email address and date of birth, and a username and password to access your Veritooth account. You are responsible for ensuring the accuracy of the personal information that you submit to Veritooth.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Email Newsletters")])]), _vm._v(" "), _c('p', [_vm._v("At registration and at various times as you use the Veritooth Sites, you will be given the option of providing us with personal information in order to receive informational/promotional newsletters – such as a newsletter– via email from Veritooth and/or directly from third parties. From time to time Veritooth may offer users of third party websites to the opportunity to subscribe to our newsletters through those websites. If you elect to subscribe to one of our newsletters on a third party website, the operator of that website will provide us with the personal information you have provided in connection with the subscription request, which we may use in accordance with this Privacy Policy as though you had provided it directly to Veritooth. In Veritooth Message Boards, if you turn on the email notification for posts you have created or participated in, you'll receive an email when there has been any activity on those posts. If you later decide you no longer want to receive email updates, you can turn it off by navigating to the Email Alerts section in your Message Board settings.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Market Research")])]), _vm._v(" "), _c('p', [_vm._v("From time to time, Veritooth may conduct online research surveys on behalf of itself and third parties through email invitations, pop-up surveys and online focus groups. When participating in a survey, we may require you to provide your location, age and if there's a sweepstakes associated with the market research survey, your name and contact information for purposes of sweepstakes administration. The information you submit in a survey may be used by Veritooth for research and measurement purposes, as described below, including to measure the effectiveness of content, advertising or programs. The personal information you provide in connection with a sweepstakes entry will be used for the sole purpose of administering the sweepstakes and as required by applicable law. We will not knowingly invite individuals who are under the age of 13 to participate in market research surveys. Market research surveys conducted by or on behalf of Veritooth will contain a link to this Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Veritooth Message Boards and Other Public Forums")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth features message board areas and other public forums where users with similar interests including with respect to certain medical conditions can share information and support one another or where users can post questions for experts to answer. Our message boards are open to the public and should not be considered private.")]), _vm._v(" "), _c('p', [_vm._v("Any information (including personal information) you share in any online message board or other forum is by design open to the public and is not private. You should think carefully before posting any personal information in any public forum. What you post can be seen, disclosed to or collected by third parties and may be used by others in ways we cannot control or predict, including to contact you for unauthorized purposes. As with any public forum on any site, the information you post may also show up in third-party search engines.")]), _vm._v(" "), _c('p', [_vm._v("If you mistakenly post personal information in our message board areas and would like it removed, you can send us an email to request that we remove it by using the Contact Us link on every page of the Veritooth Sites. In some cases, we may not be able to remove your personal information.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Emails You Send to Veritooth")])]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy does not apply to information, content, business information, ideas, concepts or inventions that you send to Veritooth by email. If you want to keep content or business information, ideas, concepts or inventions private or proprietary, do not send them in an email to Veritooth.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Services and Device Information")])]), _vm._v(" "), _c('p', [_vm._v("When you access and use the Services, Veritooth automatically collects and stores in its server logs information from your browser or mobile device such as your IP address or unique device identifier, browser information (including referring URL), your preferences and settings, cookies and information about the content you have viewed and actions taken (e.g., search queries, ad engagement, clicks and the associated dates and times). Veritooth may also collect device-specific information when you install and use an App including your device model, operating system information, advertising ID (which is a unique, user-resettable identification number for advertising associated with a mobile device) and App version and usage information. When enabled by you, we collect precise location information provided by your mobile device, which you may disable through the device settings.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Cookies and Other Tracking Technologies")])]), _vm._v(" "), _c('p', [_vm._v("We and our partners use cookies to collect information about your use of the Services. \"Cookies\" are small data files assigned to your browser when you visit a Veritooth Site which enable recognition of your browser and collect and store information about your use of the Services, as described above. In addition to cookies, we and our partners use other tracking technologies that collect information about your use of the Services, including mobile identifiers and \"web beacons\" which are small graphic files (sometimes called \"clear GIFs\" or \"web pixels\") embedded in a web page or email typically used to monitor activity and send relevant information back to a home server (which can belong to the host site, a network advertiser or some other third party).")]), _vm._v(" "), _c('p', [_vm._v("Our advertising service partners may use cookies and other tracking technologies to collect information about your use of the Veritooth Sites, including content you have viewed. These third parties may use this information to help Veritooth deliver advertising on the Veritooth Sites and on other third party websites based on your browsing activity on the Veritooth Sites. Veritooth may further tailor the advertising on the Veritooth Sites and these other third party websites based on additional information to the extent known by Veritooth or these third parties. Two of the third parties that Veritooth works with are Google and Facebook. In addition to using the information it collects performing services for Veritooth, Google may also use such information as described in its privacy policy. To see how Google may use information collected through our use of the Google services on the Veritooth Sites visit https://www.google.com/policies/privacy/partners.  While Facebook does not provide any personal information to Veritooth, Facebook may use information that it has about you and that it collects performing services for Veritooth (which may be associated with personal information that Facebook has about you) as described in its privacy policy available at https://www.facebook.com/about/privacy.")]), _vm._v(" "), _c('p', [_vm._v("We also work with third party ad networks to display advertising on our Veritooth Sites and on third party websites. Our ad network vendors use technologies to collect information about your activities on the Veritooth Sites and in our flagship Veritooth App to provide you cookie-based targeted advertising on our Veritooth Sites and on third party websites based upon your browsing activity and your interests.")]), _vm._v(" "), _c('p', [_vm._v("For more information about our how cookies and other tracking technologies are used in connection with the Services, please read our Cookie Policy.")]), _vm._v(" "), _c('p', [_vm._v("When you download and install one of our Apps onto your mobile device we assign a random number to your App installation. This number cannot be used to identify you personally, and we cannot identify you personally unless you choose to become a registered user of the App. We use this random number in a manner similar to our use of cookies as described in this Privacy Policy and in our Cookie Policy. Unlike cookies, the random number is assigned to your installation of the App itself and not a browser, because the App does not work through your browser. Therefore the random number cannot be removed through settings. If you do not want us to use the random number for the purposes for which we use cookies, please do not use the Apps. Our use of cookies and other tracking technologies on our mobile optimized sites and our Veritooth App are similar to our use on our desktop sites. Your choices to reject cookies, use the Network Advertising Initiative and the opt-out mechanism described below in the section \"Your Choices and Rights\".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("WHO HAS ACCESS TO THE INFORMATION WE COLLECT?")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Veritooth Subsidiaries and Corporate Affiliates")])]), _vm._v(" "), _c('p', [_vm._v("We may share your information with our subsidiaries, affiliates and companies acquired by or merged with us and our affiliates. In the event of a corporate change in control resulting from, for example, a sale to, or merger with, another entity, or in the event of a sale of assets or a bankruptcy, Veritooth reserves the right to transfer your personal information to the new party in control or the party acquiring assets. In the event of such a change, your personal information will continue to be treated in accordance with this Privacy Policy unless any changes to the Privacy Policy are made in accordance with the section below that discusses \"Changes to This Privacy Policy.\"")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Companies and Contractors that Work with Veritooth")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth works with third party companies and contractors that help us provide the Services and to otherwise assist in the operation of the Veritooth Sites and Apps, including those that provide services relating to technology, data analysis, research, email management and deployment, sweepstakes and contest administration, advertising and marketing and/or content. Veritooth contractors sometimes have limited access to your information in the course of providing products or services to Veritooth. We contractually require that our contractors not use or disclose your information for any purpose other than providing the limited service or function for Veritooth.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Third Party Advertisers and Third Party Websites")])]), _vm._v(" "), _c('p', [_vm._v("We may share information that we have about you, such as a cookie ID or IP address, with third party advertising service providers who may use this information, on our behalf, to help Veritooth deliver advertising on the Veritooth Sites as well as on third party websites, as further described in our Cookie Policy.")]), _vm._v(" "), _c('p', [_vm._v("Certain content, services and advertisements offered to you through the Veritooth Sites are served on, or contain links to, websites hosted and operated by a company other than Veritooth (\"Third Party Websites\"). Veritooth does not share your personal information with these Third Party Websites without your consent, but you should be aware that any information you disclose to these Third Party Websites once you access these Third Party Websites is not subject to this Privacy Policy. Veritooth does not endorse and is not responsible for the privacy practices of these Third Party Websites. You should review the privacy policy posted on the Third Party Website to understand how that Third Party Website collects and uses your information. Veritooth makes an effort to make it obvious to you when you leave a Veritooth Site and enter a Third Party Website, either by requiring you to click on a link or by notifying you on the Veritooth Site before you visit the third party site. In addition, if you see a phrase such as \"Powered by\" or \"in association with\" followed by the name of a company other than Veritooth, then you are on a website hosted by a company other than Veritooth.  When you use a co-branded service (a service operated with a partner of Veritooth, such as Veritooth Lab Testing), or register or otherwise provide information on a co-branded site, where applicable, we may pass the collected information back to that partner, which may include third party service providers whose services are embedded into and/or appear within the Services.")]), _vm._v(" "), _c('p', [_vm._v("We may also include social widgets on the Veritooth Sites which enable you to interact with the associated social media services, e.g., to share an article. These widgets may collect browsing data which may be received by the third party that provided the widget, and are controlled by these third parties. You may be able to manage your privacy preferences directly with the applicable social network platform.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Compliance with Law, Regulation, and Law Enforcement Requests")])]), _vm._v(" "), _c('p', [_vm._v("To cooperate with government and law enforcement officials and private parties to enforce and comply with law, we may release personal information to third parties: (1) to comply with legal requirements such as a law, regulation, search warrant, subpoena or court order; (2) when we believe in good faith that disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a government request; or (3) in special cases, such as in response to a physical threat to you or others, to protect property or defend or assert legal rights. In addition, we may disclose personal information as described below..")]), _vm._v(" "), _c('p', [_vm._v("If you believe that our website has collected incorrect information or if you would like to dispute any information, please contact us using the address at the top of this page.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("COLLECTION OF YOUR PERSONAL INFORMATION")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth may collect personally identifiable information, including but not limited to, your name, address, phone number, and e-mail address. If you purchase Veritooth's products and services, we may in connection with those products and services, create a publicly visible profile that includes your name/company name and photographs. In addition, we may collect billing and credit card information. This information is used to complete the purchase transaction. Veritooth may also collect anonymous demographic information, which is not unique to you, such as your age and gender. We may gather additional personal or non-personal information in the future or as published on our website by a third-party.")]), _vm._v(" "), _c('p', [_vm._v("Information about your computer/device hardware and software may be automatically collected by Veritooth. This information can include: your IP address, browser type, domain names, access times and referring website addresses. This information is used for the operation of the service, to maintain quality of the service, and to provide general statistics regarding use of the Veritooth website.")]), _vm._v(" "), _c('p', [_vm._v("Please keep in mind that if you directly disclose personally identifiable information or personally sensitive data through Veritooth's public message boards, this information may be collected and used by others and we cannot control that data.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth encourages you to review the privacy statements of websites you choose to link to from Veritooth so that you can understand how those websites collect, use and share your information. Veritooth is not responsible for the privacy statements or other content on websites outside of the Veritooth website. Clicking on any third-party link is done at your own risk.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("USE OF YOUR PERSONAL INFORMATION")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth collects and uses your personal information to provide, maintain, protect and improve upon its products, services, and the operation of its website. This includes, but is not limited to, keeping records of your communication with Veritooth and using your e-mail address to inform you about upcoming changes or improvements to our services.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth may also use your personally identifiable information to inform you of other products or services available from Veritooth and its affiliates. Veritooth may also contact you via e-mail or other through other modes of communication with surveys to conduct research about your opinion of current services or of potential new services that may be offered.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth may, from time to time, contact you on behalf of external business partners about a particular offering that may be of interest to you. In those cases, your unique personally identifiable information (e-mail, name, address, telephone number) is transferred to the third party. Veritooth may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to Veritooth, and they are required to maintain the confidentiality of your information.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth may keep track of the websites and pages our users visit within Veritooth, in order to determine what Veritooth services are the most popular. This data is used to deliver customized content and advertising within Veritooth to customers whose behavior indicates that they are interested in a particular subject area.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth will disclose your personal information, without notice, as outlined herein or as described in our Terms of Service. Outside of that, Veritooth will disclose your personal information if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on Veritooth or the site; (b) protect and defend the rights or property of Veritooth; and, (c) act under exigent circumstances to protect the personal safety of users of Veritooth, or the public.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("USE OF COOKIES")])]), _vm._v(" "), _c('p', [_vm._v("The Veritooth website may use \"cookies\" and other technologies to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.")]), _vm._v(" "), _c('p', [_vm._v("One of the primary purposes of cookies is to provide a convenience feature to save you time. The purpose of a cookie is to tell the web server that you have returned to a specific page. For example, if you personalize Veritooth pages, or register with Veritooth site or services, a cookie helps Veritooth to recall your specific information on subsequent visits. This simplifies the process of recording your personal information, such as billing addresses, shipping addresses, and so on. When you return to the same Veritooth website, the information you previously provided can be retrieved, so you can easily use the Veritooth features that you customized.")]), _vm._v(" "), _c('p', [_vm._v("You have the ability to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of the Veritooth services or websites you visit.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("SECURITY OF YOUR PERSONAL INFORMATION")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth makes efforts to secure your personal information from unauthorized access, use or disclosure. When personal information (such as a credit card number) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol.")]), _vm._v(" "), _c('p', [_vm._v("Despite Veritooth's efforts to protect your personal information, there is always some risk that an unauthorized third party may find a way around our security systems or that transmissions of your information over the Internet may be intercepted.")]), _vm._v(" "), _c('p', [_vm._v("We will retain your personal information as long as your account is active or as needed to provide you Services. At any time you can remove your personal information or instruct us to remove it, but you should be aware that it is not technologically possible to remove each and every record of the information you have provided to Veritooth from our servers. See \"Your Choices and Rights\" below for more information on how you can update or remove your personal information. We will also retain your personal information as necessary to comply with legal obligations, resolve disputes and enforce our agreements.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("CHILDREN UNDER THIRTEEN")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth does not knowingly collect personally identifiable information from children under the age of thirteen (13). Veritooth's Terms of Service require that all users be fourteen (14) years of age or older. If you are under the age of thirteen, you must ask your parent or guardian for permission to use this website.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("APPLICATION")])]), _vm._v(" "), _c('p', [_vm._v("Our Privacy Policy applies to all of the services offered by Veritooth but excludes services that have a separate privacy policy without an incorporation of this Privacy Policy. This Privacy Policy does not apply to services offered by other companies or individuals including products or sites that may be displayed to you in on Veritooth or other sites linked from our services. Our Privacy Policy does not cover the information or other companies and organizations who advertise our services, and who may use cookies or other technologies to serve and offer relevant advertising.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("TRANSFERRING PERSONAL DATA FROM THE EU TO THE US")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth is operated in the United States. Information that we collect is, to the best of our knowledge, controlled and processed in the United States. Veritooth does not actively target citizens of the countries applicable to GDPR though people may have used Veritooth to complain about perceived wrongdoings of people, and/or in connection with businesses, located in one or more the GDPR countries. Veritooth, through display on Veritooth, permanently archives this data as a matter of public interest, free expression, historical research and the exercise of and defense of any potential legal claims.")]), _vm._v(" "), _c('p', [_vm._v("Veritooth is engaging in geo-blocking efforts due to GDPR and we no longer allow citizens of countries that are applicable to GDPR to use our website. If any citizen of a country that is bound by GDPR is using this site, they are doing so without our consent and assume the risks, including accepting our data collection practices by doing so without any liability to Veritooth. In other words, we aren't going to be liable because you choose to break the rules.")]), _vm._v(" "), _c('p', [_vm._v("The United States has not sought nor received a finding of \"adequacy\" from the European Union under Article 45 of the GDPR. Any data that we are collecting and/or processing we deem to be done with your consent; to perform a contract with you; or to fulfill a compelling legitimate interest of Veritooth and/or to the public that we do not believe outweigh your rights and freedoms. Veritooth tries to apply suitable safeguards to protect the privacy and security of your personal data and to use it only consistent with your relationship with Veritooth through the use of the Veritooth website, it's mission, and the practices as described in the Terms of Service and this Privacy Policy.")]), _vm._v(" "), _c('p', [_vm._v("Based upon the foregoing, and while we take reasonable measures under US law to protect the data, Veritooth's position is that it not subject to GDPR.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("DATA STORAGE AND RETENTION")])]), _vm._v(" "), _c('p', [_vm._v("Your personal data, and data provided by you about others, is stored by Veritooth on its servers and/or on the servers of third-party vendors that Veritooth engages, located in the United States. Veritooth retains the data permanently (although there is a possibility that some data maybe lost due to technological transitions or other accidental errors). This is due to Veritooth's need to preserve historical evidence in the event of litigation, to provide historical data where relevant, including the consumer facing information, to provide information that is of legitimate interest to the public just as court records are and to promote free expression. If you do not consent to this permanent storage of such information, do not use Veritooth.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("OPT-OUT & UNSUBSCRIBE")])]), _vm._v(" "), _c('p', [_vm._v("We respect your privacy and give you an opportunity to opt-out of receiving announcements of certain information. Typically such opt-out options are present on the communications sent to you by email themselves. Alternatively, users may opt-out of receiving any or all marketing communications from Veritooth by contacting us here:")]), _vm._v(" "), _c('p', [_vm._v("Web page: www.Veritooth.com")]), _vm._v(" "), _c('p', [_vm._v("Email: support@veritooth.com with the Subject Box Titled \"VERITOOTH - OPT OUT/UNSUBSCRIBE\"")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("CHANGES TO THIS POLICY")])]), _vm._v(" "), _c('p', [_vm._v("We reserve the right to change or modify this Privacy Policy and any of our Services at any time and any changes will be effective upon being posted unless we advise otherwise. If we make any material changes to this Privacy Policy we will notify you by means of a notice on the Veritooth Sites and/or by email to our registered users (sent to the email address specified when you register) prior to the change becoming effective. By continuing to use the Services after changes are made to this Privacy Policy, you agree to such changes.  We encourage you to periodically review this Privacy Policy for the latest information on our privacy practices. If you do not accept the terms of this Privacy Policy, we ask that you do not register with us and that you do not use the Veritooth Sites. Please exit the Veritooth Sites immediately if you do not agree to the terms of this Privacy Policy.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("CONTACT INFORMATION")])]), _vm._v(" "), _c('p', [_vm._v("Veritooth welcomes your questions or comments regarding this Privacy Policy. If you believe that Veritooth has not adhered to this Privacy Policy, please contact Veritooth at:")]), _vm._v(" "), _c('p', [_vm._v("Veritooth, LLC")]), _vm._v(" "), _c('p', [_vm._v("Email: support@veritooth.com")])])
}]}

/***/ }),
/* 264 */
/*!*************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61559961"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Terms.vue ***!
  \*************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--terms"
  }, [_c(_vm.content, {
    tag: "component",
    staticClass: "group group--first-last typeset typeset--terms links"
  }), _vm._v(" "), _c('ui-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 265 */
/*!*************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/InfoDentists.vue ***!
  \*************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/InfoDentists.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer__ = __webpack_require__(/*! ui/Footer */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ui_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_infoDentists_Hero__ = __webpack_require__(/*! pages/infoDentists/Hero */ 266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_infoDentists_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_infoDentists_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_infoDentists_Instructions__ = __webpack_require__(/*! pages/infoDentists/Instructions */ 270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_infoDentists_Instructions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_infoDentists_Instructions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_infoDentists_OurMission__ = __webpack_require__(/*! pages/infoDentists/OurMission */ 273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_infoDentists_OurMission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_infoDentists_OurMission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists__ = __webpack_require__(/*! pages/home/Dentists */ 211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Models


// Services


// Ui


// Pages





// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-info-dentists',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].infoDentists.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_1_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].infoDentists.meta)
  },

  // Components
  components: {
    UiFooter: __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default.a
  },

  // Data
  data: function data() {
    return {
      components: {
        PagesDentistsHero: __WEBPACK_IMPORTED_MODULE_3_pages_infoDentists_Hero___default.a,
        PagesDentistsInstructions: __WEBPACK_IMPORTED_MODULE_4_pages_infoDentists_Instructions___default.a,
        PagesDentistsMission: __WEBPACK_IMPORTED_MODULE_5_pages_infoDentists_OurMission___default.a,
        PagesDentistSignup: __WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists___default.a
      }
    };
  }
});

/***/ }),
/* 266 */
/*!*******************************************************!*\
  !*** ./client/components/pages/infoDentists/Hero.vue ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Hero.vue */ 267),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-764db3fc"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Hero.vue */ 269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/infoDentists/Hero.vue ***!
  \*****************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/infoDentists/Hero.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Form__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-hero',

  // Components
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_0_modules_Block___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_1_modules_Form___default.a
  },

  // Data
  data: function data() {
    return {
      hero: {
        heading: 'Let the work speak for itself',
        image: __webpack_require__(/*! images/info/icon-tooth-magnifying.svg */ 268),
        content: ['You spent years perfecting your trade and attend CE courses annually, all with a           focus on delivering quality dental care. However, patient reviews focus on wait times,           office d\xE9cor, friendliness and cost. While these things matter to patients, what about           the work itself? Dentists need a way to demonstrate quality and let the work speak for itself.', '<b>Build your business on quality</b>', 'With VeriTooth you can demonstrate quality dentistry to new and existing patients.']
      }
    };
  }
});

/***/ }),
/* 268 */
/*!*************************************************************!*\
  !*** ./client/assets/images/info/icon-tooth-magnifying.svg ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/info/icon-tooth-magnifying.5164a1f3.svg";

/***/ }),
/* 269 */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-764db3fc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoDentists/Hero.vue ***!
  \************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-hero",
    attrs: {
      "block": "transparent"
    }
  }, [_c('div', {
    staticClass: "home-hero__inner group group--first group--last"
  }, [_c('div', {
    staticClass: "home-hero__content"
  }, [_c('h1', {
    staticClass: "home-hero__heading h1 mt0 fw-semibold",
    domProps: {
      "innerHTML": _vm._s(_vm.hero.heading)
    }
  }), _vm._v(" "), _vm._l((_vm.hero.content), function(copy, index) {
    return _c('p', {
      key: index,
      staticClass: "home-hero__copy p",
      domProps: {
        "innerHTML": _vm._s(copy)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "home-hero__image tac"
  }, [_c('img', {
    staticClass: "mw-100",
    attrs: {
      "src": _vm.hero.image,
      "alt": ""
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 270 */
/*!***************************************************************!*\
  !*** ./client/components/pages/infoDentists/Instructions.vue ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Instructions.vue */ 271),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-fd1e9bb2"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Instructions.vue */ 272),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/infoDentists/Instructions.vue ***!
  \*************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/infoDentists/Instructions.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Block__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules


// Images
var images = {
  computer: __webpack_require__(/*! images/info/icon-tooth-computer.svg */ 219),
  tooth: __webpack_require__(/*! images/info/icon-tooth-search.svg */ 220),
  people: __webpack_require__(/*! images/info/icon-doctors.svg */ 221),
  aaoe: __webpack_require__(/*! images/info/american-association-of-endodontists.svg */ 222)
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'info-dentists-instructions',

  // Components
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_0_modules_Block___default.a
  },

  // Data
  data: function data() {
    return {
      images: images,
      instructionSteps: [{
        image: images.computer,
        alt: 'Icon - Online Verification',
        heading: 'Online Verification',
        copy: 'VeriTooth provides your dental office with a secure location to upload your                 radiographs for review by a specialist. All patient and dentist information is                 hidden to protect your privacy and ensure an unbiased review.'
      }, {
        image: images.tooth,
        alt: 'Icon - Impartial Industry Expertise',
        heading: 'Impartial Industry Expertise',
        copy: 'An impartial qualified dental expert will then review the radiographs against industry defined standards.                 For example, he/she will verify a root canal using the <a class="link link--secondary tdn" ' + 'href="https://www.aae.org/" target="_blank">AAE</a> (American Association of Endodontists) <a class="link link--secondary tdn" ' + 'href="https://f3f142zs0k2w1kg84k5p9i1o-wpengine.netdna-ssl.com/specialty/wp-content/uploads/' + ('sites/2/2018/04/TreatmentStandards_Whitepaper.pdf" target="_blank">Standard of Treatment criteria</a>.                 You\'ll then receive an email with a summary of the review.<br /><br />                <img src="' + images.aaoe + '" alt="Icon - American Association of Endodontist" />')
      }, {
        image: images.people,
        alt: 'Icon - Demonstrated Quality',
        heading: 'Demonstrated Quality',
        copy: 'VeriTooth also takes these quality scores from all our reviews to build a directory of local dental care providers.                 Now you can not only demonstrate great customer service, you can also demonstrate great clinical skill to current                 and perspective patients.'
      }]
    };
  }
});

/***/ }),
/* 272 */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd1e9bb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoDentists/Instructions.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-instructions",
    attrs: {
      "block": "lightest"
    }
  }, [_c('h2', {
    staticClass: "h2 home-instructions__heading mt0"
  }, [_vm._v("You play a critical role in driving quality in dentistry")]), _vm._v(" "), _c('div', {
    staticClass: "home-instructions__inner group group--last"
  }, [_c('div', {
    staticClass: "home-instructions__steps"
  }, _vm._l((_vm.instructionSteps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "home-instructions__step"
    }, [_c('div', {
      staticClass: "home-instructions__icon"
    }, [_c('img', {
      attrs: {
        "src": step.image,
        "alt": step.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "home-instructions__content"
    }, [_c('h4', {
      staticClass: "home-instructions__heading h4 fw-bold"
    }, [_vm._v(_vm._s(step.heading))]), _vm._v(" "), _c('p', {
      staticClass: "p",
      domProps: {
        "innerHTML": _vm._s(step.copy)
      }
    })])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 273 */
/*!*************************************************************!*\
  !*** ./client/components/pages/infoDentists/OurMission.vue ***!
  \*************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OurMission.vue */ 274),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7d040622"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OurMission.vue */ 275),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/infoDentists/OurMission.vue ***!
  \***********************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/infoDentists/OurMission.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_home_Block__ = __webpack_require__(/*! pages/home/Block */ 212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_home_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_home_Block__);
//
//
//
//
//
//

// Modules


// Images
var images = {
  ourMission: __webpack_require__(/*! images/home/our-mission.svg */ 213),
  tick: __webpack_require__(/*! images/icons/tick.svg */ 214)
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-our-mission',

  // Compononts
  components: {
    PagesHomeBlock: __WEBPACK_IMPORTED_MODULE_0_pages_home_Block___default.a
  },

  // Data
  data: function data() {
    return {
      block: {
        slug: 'why',
        block: 'lightest',
        image: {
          image: images.ourMission,
          alt: 'Our Mission'
        },
        content: {
          heading: 'Building trust through transparency.',
          copy: ['VeriTooth was created to help dentists and patients verify the quality of the work             that patients receive. We strive to provide tools for you to demonstrate quality to             your patients. It\'s completely secure, unbiased, and impartial.']
        }
      }
    };
  }
});

/***/ }),
/* 275 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d040622"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoDentists/OurMission.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pages-home-block', {
    attrs: {
      "block": _vm.block
    }
  })
},staticRenderFns: []}

/***/ }),
/* 276 */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0f639d8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/InfoDentists.vue ***!
  \********************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--dentists"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _vm._l((_vm.components), function(component, index) {
    return _c(component, {
      key: index,
      tag: "component"
    })
  }), _vm._v(" "), _c('ui-footer')], 2)
},staticRenderFns: []}

/***/ }),
/* 277 */
/*!**************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/InfoReviewers.vue ***!
  \**************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/InfoReviewers.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer__ = __webpack_require__(/*! ui/Footer */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ui_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_infoReviewers_Hero__ = __webpack_require__(/*! pages/infoReviewers/Hero */ 278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_infoReviewers_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_infoReviewers_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_infoReviewers_Instructions__ = __webpack_require__(/*! pages/infoReviewers/Instructions */ 281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_infoReviewers_Instructions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_infoReviewers_Instructions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_infoReviewers_OurMission__ = __webpack_require__(/*! pages/infoReviewers/OurMission */ 284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_infoReviewers_OurMission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_infoReviewers_OurMission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists__ = __webpack_require__(/*! pages/home/Dentists */ 211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Models


// Services


// Ui


// Pages





// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-info-reviewer',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].infoReviewers.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_1_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].infoReviewers.meta)
  },

  // Components
  components: {
    UiFooter: __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default.a
  },

  // Data
  data: function data() {
    return {
      components: {
        PagesReviewerHero: __WEBPACK_IMPORTED_MODULE_3_pages_infoReviewers_Hero___default.a,
        PagesReviewerInstructions: __WEBPACK_IMPORTED_MODULE_4_pages_infoReviewers_Instructions___default.a,
        PagesReviewerMission: __WEBPACK_IMPORTED_MODULE_5_pages_infoReviewers_OurMission___default.a,
        PagesReviewerSignup: __WEBPACK_IMPORTED_MODULE_6_pages_home_Dentists___default.a
      }
    };
  }
});

/***/ }),
/* 278 */
/*!********************************************************!*\
  !*** ./client/components/pages/infoReviewers/Hero.vue ***!
  \********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Hero.vue */ 279),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6afe0228"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Hero.vue */ 280),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/*!******************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/infoReviewers/Hero.vue ***!
  \******************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/infoReviewers/Hero.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Form__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home-hero',

  // Components
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_1_modules_Block___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_2_modules_Form___default.a
  },

  // Data
  data: function data() {
    return {
      hero: {
        heading: 'Building Trust Through Transparency',
        // image: require(`images/info/icon-illustration-tooth-check.svg`),
        content: ['The dental industry is in trouble, and we need your help. There is a wide variety of           quality in clinical work done today. However, patients assess quality based on           non-clinical experiences like wait times, office d\xE9cor, doctor friendliness and           procedure cost.  While these things matter to patients, what about the work itself?           The dental industry needs a way to demonstrate quality and continue to build trust with patients.', '<b>Build your business on quality</b>', 'With VeriTooth you can help verify quality clinical work; building trust with patients and promoting high quality work in dentistry.']
      }
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel'])),

  methods: {
    action: function action() {
      var model = this.getModel('register-dentist');

      sessionStorage.setItem('dentist_email', model.dentistEmail || '');

      if (this.isAuthenticated) {
        this.requestLogout({
          noRedirect: true
        });
      }

      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, 500);
      });
    },
    success: function success() {
      var _this = this;

      setTimeout(function () {
        _this.$router.push({
          name: 'register-dentist'
        });
      }, 500);
    },
    fail: function fail(_fail) {
      console.warn(_fail);
    }
  }

});

/***/ }),
/* 280 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afe0228"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoReviewers/Hero.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-hero",
    attrs: {
      "block": "transparent"
    }
  }, [_c('div', {
    staticClass: "home-hero__inner group group--first group--last"
  }, [_c('div', {
    staticClass: "home-hero__content"
  }, [_c('h1', {
    staticClass: "home-hero__heading h1 mt0 fw-semibold",
    domProps: {
      "innerHTML": _vm._s(_vm.hero.heading)
    }
  }), _vm._v(" "), _vm._l((_vm.hero.content), function(copy, index) {
    return _c('p', {
      key: index,
      staticClass: "home-hero__copy p",
      domProps: {
        "innerHTML": _vm._s(copy)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "home-hero__get-started"
  }, [_c('div', {
    staticClass: "home-hero__form"
  }, [_c('h4', {
    staticClass: "h4 mt0"
  }, [_vm._v("Are you a Dentist or Endodontist and want to help?")]), _vm._v(" "), _c('module-form', {
    attrs: {
      "form-id": "register-dentist",
      "fields": {
        dentistEmail: {
          type: "email",
          label: "Email",
          labelHidden: true,
          placeholder: "Enter Your Email",
        },
      },
      "button": "primary",
      "button-size": "m",
      "submit": "Sign up now",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 281 */
/*!****************************************************************!*\
  !*** ./client/components/pages/infoReviewers/Instructions.vue ***!
  \****************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Instructions.vue */ 282),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1bb61453"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Instructions.vue */ 283),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/*!**************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/infoReviewers/Instructions.vue ***!
  \**************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/infoReviewers/Instructions.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Block__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules


// Images
var images = {
  computer: __webpack_require__(/*! images/info/icon-tooth-computer.svg */ 219),
  tooth: __webpack_require__(/*! images/info/icon-tooth-search.svg */ 220),
  people: __webpack_require__(/*! images/info/icon-doctors.svg */ 221),
  aaoe: __webpack_require__(/*! images/info/american-association-of-endodontists.svg */ 222)
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'info-dentists-instructions',

  // Components
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_0_modules_Block___default.a
  },

  // Data
  data: function data() {
    return {
      images: images,
      instructionSteps: [{
        image: images.computer,
        alt: 'Icon - VeriTooth Online verification',
        heading: 'VeriTooth Online verification',
        copy: 'VeriTooth provides dentists and patients a simple and secure environment to upload radiographs for                 an expert review by a specialist. All patient and dentist information is hidden to protect privacy and ensure an unbiased review.'
      }, {
        image: images.tooth,
        alt: 'Icon - Your Impartial Industry Expertise',
        heading: 'Your Impartial Industry Expertise',
        copy: 'An impartial qualified dental expert will do a short review of the radiographs against industry defined standards.                 For example, you can verify a root canal using the <a class="link link--secondary tdn" ' + 'href="https://www.aae.org/" target="_blank">AAE</a> (American Association of Endodontists) <a class="link link--secondary tdn" ' + 'href="https://f3f142zs0k2w1kg84k5p9i1o-wpengine.netdna-ssl.com/specialty/wp-content/uploads/' + ('sites/2/2018/04/TreatmentStandards_Whitepaper.pdf" target="_blank">Standard of Treatment criteria</a>.                 Reviews only take a minute and your identity is hidden from the patient and dentist. It\u2019s completely anonymous.<br /><br />                <img src="' + images.aaoe + '" alt="Icon - American Association of Endodontist" />')
      }, {
        image: images.people,
        alt: 'Icon - Demonstrated Quality',
        heading: 'Demonstrated Quality',
        copy: 'Now patients will get clear feedback on the quality of the dental work without impacting dentist\u2019s relationships.                 VeriTooth also takes these quality scores from all our reviews to build a directory of local dental care providers.                 Finally, dentists can prove their good quality and patients can make a more informed choice.'
      }]
    };
  }
});

/***/ }),
/* 283 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb61453"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoReviewers/Instructions.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-instructions",
    attrs: {
      "block": "lightest"
    }
  }, [_c('h2', {
    staticClass: "h2 home-instructions__heading mt0"
  }, [_vm._v("You play a critical role in driving quality in dentistry")]), _vm._v(" "), _c('div', {
    staticClass: "home-instructions__inner group group--last"
  }, [_c('div', {
    staticClass: "home-instructions__steps"
  }, _vm._l((_vm.instructionSteps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "home-instructions__step"
    }, [_c('div', {
      staticClass: "home-instructions__icon"
    }, [_c('img', {
      attrs: {
        "src": step.image,
        "alt": step.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "home-instructions__content"
    }, [_c('h4', {
      staticClass: "home-instructions__heading h4 fw-bold"
    }, [_vm._v(_vm._s(step.heading))]), _vm._v(" "), _c('p', {
      staticClass: "p",
      domProps: {
        "innerHTML": _vm._s(step.copy)
      }
    })])])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 284 */
/*!**************************************************************!*\
  !*** ./client/components/pages/infoReviewers/OurMission.vue ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OurMission.vue */ 285),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6b54034e"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OurMission.vue */ 286),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/*!************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/infoReviewers/OurMission.vue ***!
  \************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/infoReviewers/OurMission.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_home_Block__ = __webpack_require__(/*! pages/home/Block */ 212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pages_home_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pages_home_Block__);
//
//
//
//
//
//

// Modules


// Images
var images = {
  ourMission: __webpack_require__(/*! images/home/our-mission.svg */ 213),
  tick: __webpack_require__(/*! images/icons/tick.svg */ 214)
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-our-mission',

  // Compononts
  components: {
    PagesHomeBlock: __WEBPACK_IMPORTED_MODULE_0_pages_home_Block___default.a
  },

  // Data
  data: function data() {
    return {
      block: {
        slug: 'why',
        block: 'lightest',
        image: {
          image: images.ourMission,
          alt: 'Our Mission'
        },
        content: {
          heading: 'Building trust through transparency.',
          copy: ['VeriTooth was created to help dentists and patients verify the quality of ' + 'the work that patients receive. It\u2019s our vision to transform the dental ' + 'industry by shining a light on high quality work and helping patients get better outcomes.']
        }
      }
    };
  }
});

/***/ }),
/* 286 */
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b54034e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoReviewers/OurMission.vue ***!
  \*******************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pages-home-block', {
    attrs: {
      "block": _vm.block
    }
  })
},staticRenderFns: []}

/***/ }),
/* 287 */
/*!*********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89a8494c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/InfoReviewers.vue ***!
  \*********************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--dentists"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _vm._l((_vm.components), function(component, index) {
    return _c(component, {
      key: index,
      tag: "component"
    })
  }), _vm._v(" "), _c('ui-footer')], 2)
},staticRenderFns: []}

/***/ }),
/* 288 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/UnderstandingYourReport.vue ***!
  \************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/UnderstandingYourReport.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer__ = __webpack_require__(/*! ui/Footer */ 207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ui_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_understandingYourReport_Hero__ = __webpack_require__(/*! pages/understandingYourReport/Hero */ 289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pages_understandingYourReport_Hero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pages_understandingYourReport_Hero__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_understandingYourReport_Info__ = __webpack_require__(/*! pages/understandingYourReport/Info */ 292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pages_understandingYourReport_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pages_understandingYourReport_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_understandingYourReport_RootCanalFaq__ = __webpack_require__(/*! pages/understandingYourReport/RootCanalFaq */ 295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pages_understandingYourReport_RootCanalFaq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pages_understandingYourReport_RootCanalFaq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_understandingYourReport_BlueCallToAction__ = __webpack_require__(/*! pages/understandingYourReport/BlueCallToAction */ 305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_understandingYourReport_BlueCallToAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_understandingYourReport_BlueCallToAction__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Models


// Services


// Ui


// Pages





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-understanding-your-report',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].home.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_1_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].home.meta)
  },

  components: {
    UiFooter: __WEBPACK_IMPORTED_MODULE_2_ui_Footer___default.a
  },

  data: function data() {
    return {
      components: {
        Hero: __WEBPACK_IMPORTED_MODULE_3_pages_understandingYourReport_Hero___default.a,
        Info: __WEBPACK_IMPORTED_MODULE_4_pages_understandingYourReport_Info___default.a,
        Faq: __WEBPACK_IMPORTED_MODULE_5_pages_understandingYourReport_RootCanalFaq___default.a,
        BlueCallToAction: __WEBPACK_IMPORTED_MODULE_6_pages_understandingYourReport_BlueCallToAction___default.a
      }
    };
  }
});

/***/ }),
/* 289 */
/*!******************************************************************!*\
  !*** ./client/components/pages/understandingYourReport/Hero.vue ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Hero.vue */ 290),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3af64e3d"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Hero.vue */ 291),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/*!****************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/understandingYourReport/Hero.vue ***!
  \****************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/understandingYourReport/Hero.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_scroll__ = __webpack_require__(/*! services/scroll */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Block__ = __webpack_require__(/*! modules/Block */ 205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Form__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Services


// Modules



// Images
var images = {
  pages: {
    'four': __webpack_require__(/*! images/home/dentists-page-3.svg */ 215),
    'three': __webpack_require__(/*! images/home/dentists-page-2.svg */ 216),
    'two': __webpack_require__(/*! images/home/dentists-page-4.svg */ 217),
    'one': __webpack_require__(/*! images/home/dentists-page-1.svg */ 218)
  }
};

// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'understanding-your-report-hero',

  // Compononts
  components: {
    ModuleBlock: __WEBPACK_IMPORTED_MODULE_1_modules_Block___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_2_modules_Form___default.a
  },

  // Data
  data: function data() {
    return {
      animationClass: false,
      images: images,
      heading: 'Understanding Your VeriTooth Report',
      copy: ['Knowing the difference between a good and bad root canal is challenging. ' + 'But we\u2019re trying to make it a bit easier for you. Your VeriTooth report ' + 'provides a snapshot, comparing the x-rays your dentist provided against ' + 'specific criteria as defined by the <a class="link link--secondary tdn" ' + 'href="https://www.aae.org/" target="_blank">AAE (American Association of Endodontics)</a>.', 'The following article includes an introduction into how experts arrived at ' + 'the findings of your report and what they were looking for.']
    };
  },


  // Methods
  methods: {
    animation: function animation() {
      this.animationClass = !this.animationClass;
    }
  },

  // Lifecycle
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_0_services_scroll__["a" /* createScroll */])('dentists-papers', {
      el: this.$el,
      move: function move(e) {
        if (e.top.topPercent >= -50) {
          _this.animationClass = true;
        } else if (e.top.topPercent < -100) {
          _this.animationClass = false;
        }
      }
    });
  },
  destroyed: function destroyed() {
    Object(__WEBPACK_IMPORTED_MODULE_0_services_scroll__["b" /* destroyScroll */])('dentists-papers');
  }
});

/***/ }),
/* 291 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af64e3d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/Hero.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-understanding-report",
    attrs: {
      "block": "transparent"
    }
  }, [_c('div', {
    staticClass: "home-understanding-report__inner group group--first-last"
  }, [_c('div', {
    staticClass: "home-dentists__content"
  }, [_c('h1', {
    staticClass: "home-hero__heading h1 mt0 fw-semibold"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.copy), function(p, index) {
    return _c('p', {
      key: index,
      staticClass: "p",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    class: [
      "home-dentists__image",
      ("home-dentists__image--" + (_vm.animationClass ? "open" : "closed")) ]
  }, [_c('div', {
    staticClass: "home-dentists__image-wrapper"
  }, _vm._l((_vm.images.pages), function(image, index) {
    return _c('img', {
      key: index,
      class: [
        "home-dentists__paper",
        ("home-dentists__paper--" + index) ],
      attrs: {
        "src": image
      }
    })
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 292 */
/*!******************************************************************!*\
  !*** ./client/components/pages/understandingYourReport/Info.vue ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Info.vue */ 293),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6a7568f1"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Info.vue */ 294),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/*!****************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/understandingYourReport/Info.vue ***!
  \****************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/understandingYourReport/Info.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sections: [{
        title: "Your Dental Work",
        copy: ["Dentists are medical experts in their field, and we pay a lot of money for their knowledge, " + "expertise, and experience.  We don\u2019t want to suggest that this is easy nor is it black-and-white. " + "Dentistry involves years of practice and expert judgement.", "However, x-rays are one great way to verify the quality of work a patient has received. " + "Dental organizations (<a class=\"link link--secondary tdn\" " + "href=\"https://www.aae.org/\" target=\"_blank\">AAE</a> and <a class=\"link link--secondary tdn\" " + "href=\"https://www.ada.org/\" target=\"_blank\">ADA</a>) have defined the standards for good dental care. All " + "dental care professionals learned these standards in years of training and education. Your " + "VeriTooth report shines a light on a few key standards as a spot check."]
      }, {
        title: "The Standards",
        copy: ["While dentistry is a great deal more than simple criteria, these are some standard ways " + "dental work can be checked for quality.  If these things were not done or done poorly it " + "can lead to all kinds of future problems including infection, cracked teeth, tooth loss " + "or even greater health risks.", "Expert reviewers took the following standards into consideration when verifying your x-ray:"]
      }]
    };
  }
});

/***/ }),
/* 294 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7568f1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/Info.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "group group--first-last-small"
  }, _vm._l((_vm.sections), function(content, index) {
    return _c('div', {
      key: index,
      staticClass: "mt2"
    }, [_c('h3', {
      staticClass: "h3 mt0"
    }, [_vm._v(_vm._s(content.title))]), _vm._v(" "), _vm._l((content.copy), function(paragraph, index) {
      return _c('p', {
        key: index,
        staticClass: "p mw-100",
        domProps: {
          "innerHTML": _vm._s(paragraph)
        }
      })
    })], 2)
  }))])
},staticRenderFns: []}

/***/ }),
/* 295 */
/*!**************************************************************************!*\
  !*** ./client/components/pages/understandingYourReport/RootCanalFaq.vue ***!
  \**************************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RootCanalFaq.vue */ 296),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6c549c40"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RootCanalFaq.vue */ 304),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/*!************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/understandingYourReport/RootCanalFaq.vue ***!
  \************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/understandingYourReport/RootCanalFaq.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      checkImage: __webpack_require__(/*! images/icons/check-green.svg */ 297),
      faqs: [{
        title: "Rubber Dam used?",
        body: "A Rubber Dam is considered the standard of care and should " + "be used in all instances.  It may be awkward, but this protects the " + "area the doctor is working on and greatly reduces the potential for future infection.",
        image: __webpack_require__(/*! images/rootCanalFaq/rubber-dam.png */ 223)
      }, {
        title: "Conservative access prep?",
        body: "Has the dentist drilled the small hole needed, or a much bigger hole " + "than is typically required? A bigger hole not only damages your tooth more, " + "it also increases your risk of future problems.",
        image: __webpack_require__(/*! images/rootCanalFaq/appropriate-access-prep.png */ 298)
      }, {
        title: "All canals cleaned and shaped?",
        body: "Did you know there is not a standard number of canals for each tooth? " + "So finding all the canals can be a challenge. Did the dentist treat each of the " + "canals of your tooth or did he/she miss one.  Missing a canal can leave an opening " + "for future infections and require another procedure in the future.",
        image: __webpack_require__(/*! images/rootCanalFaq/all-canals-treated.png */ 299)
      }, {
        title: "Canals cleaned and shaped to the apex?",
        body: "The filling should go to the tip of your root. Not filling enough (under-fill) " + "can leave space for harmful bacteria to grow. A filling that goes beyond the root tip " + "(over-fill) can cause damage to the bone, sinus, or even nerve damage in severe cases. " + "Over or under filling increases the chances that you'll need to have another procedure down the road.",
        image: __webpack_require__(/*! images/rootCanalFaq/canals-cleaned2.png */ 300)
      }, {
        title: "Adequate root filling density?",
        body: "The canals should be filled without leaving any spaces between the walls of the " + "tooth. Spaces can leave room for bacteria and toxins that eventually cause an infection, " + "often requiring another root canal.",
        image: __webpack_require__(/*! images/rootCanalFaq/adequate-root-filling-density.png */ 301)
      }, {
        title: "Signs of perforation?",
        body: "Dentists are human and sometimes make mistakes. We\u2019re simply looking to see if " + "the dentist drilled out the side of your tooth. Yep, it happens.",
        image: __webpack_require__(/*! images/rootCanalFaq/perforation1.png */ 302)
      }, {
        title: "Sign of separated instrument?  ",
        body: "Sometimes a dentist can break off a piece of the small drill bit or file in your tooth. " + "These tools are very delicate and must be used with great care.  Ideally the dentist will get " + "the broken piece out.  If it\u2019s not possible to get it out, did the dentist at least tell you about this?",
        image: __webpack_require__(/*! images/rootCanalFaq/signs-of-seperated-instrument.png */ 303)
      }]
    };
  }
});

/***/ }),
/* 297 */
/*!****************************************************!*\
  !*** ./client/assets/images/icons/check-green.svg ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/icons/check-green.cb983f2d.svg";

/***/ }),
/* 298 */
/*!***********************************************************************!*\
  !*** ./client/assets/images/rootCanalFaq/appropriate-access-prep.png ***!
  \***********************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/rootCanalFaq/appropriate-access-prep.4c6b0a23.png";

/***/ }),
/* 299 */
/*!******************************************************************!*\
  !*** ./client/assets/images/rootCanalFaq/all-canals-treated.png ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/rootCanalFaq/all-canals-treated.55b38edf.png";

/***/ }),
/* 300 */
/*!***************************************************************!*\
  !*** ./client/assets/images/rootCanalFaq/canals-cleaned2.png ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/rootCanalFaq/canals-cleaned2.5ed14776.png";

/***/ }),
/* 301 */
/*!*****************************************************************************!*\
  !*** ./client/assets/images/rootCanalFaq/adequate-root-filling-density.png ***!
  \*****************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/rootCanalFaq/adequate-root-filling-density.9a93297b.png";

/***/ }),
/* 302 */
/*!************************************************************!*\
  !*** ./client/assets/images/rootCanalFaq/perforation1.png ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/rootCanalFaq/perforation1.467fc5de.png";

/***/ }),
/* 303 */
/*!*****************************************************************************!*\
  !*** ./client/assets/images/rootCanalFaq/signs-of-seperated-instrument.png ***!
  \*****************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/assets/images/rootCanalFaq/signs-of-seperated-instrument.88b48cee.png";

/***/ }),
/* 304 */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c549c40"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/RootCanalFaq.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block block--light"
  }, [_c('div', {
    staticClass: "home-block--light group group--first-last-small"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Root Canals")]), _vm._v(" "), _vm._l((_vm.faqs), function(faq, index) {
    return _c('div', {
      key: index,
      staticClass: "root-canal-faq mt2"
    }, [_c('div', {
      staticClass: "root-canal-faq__content-wrap"
    }, [_c('img', {
      staticClass: "root-canal-faq__green-check",
      attrs: {
        "src": _vm.checkImage,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "faq-content"
    }, [_c('h3', {
      staticClass: "h3 mt0 fw-semibold"
    }, [_vm._v(_vm._s(faq.title))]), _vm._v(" "), _c('p', {
      staticClass: "p"
    }, [_vm._v(_vm._s(faq.body))])])]), _vm._v(" "), _c('img', {
      staticClass: "root-canal-faq__illustration",
      attrs: {
        "src": faq.image,
        "alt": ""
      }
    })])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 305 */
/*!******************************************************************************!*\
  !*** ./client/components/pages/understandingYourReport/BlueCallToAction.vue ***!
  \******************************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../node_modules/vue-loader/lib/style-compiler/index?{"id":"data-v-4570d4cc","scoped":true,"hasInlineConfig":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BlueCallToAction.vue */ 306)

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BlueCallToAction.vue */ 308),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4570d4cc"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BlueCallToAction.vue */ 309),
  /* scopeId */
  "data-v-4570d4cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4570d4cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/pages/understandingYourReport/BlueCallToAction.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(/*! !../../../../node_modules/css-loader?sourceMap&-autoprefixer!../../../../node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4570d4cc","scoped":true,"hasInlineConfig":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BlueCallToAction.vue */ 307);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(/*! ../../../../node_modules/vue-style-loader/lib/addStylesClient.js */ 175)("d6dd52a8", content, true);

/***/ }),
/* 307 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4570d4cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/pages/understandingYourReport/BlueCallToAction.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ 174)();
// imports


// module
exports.push([module.i, "h3.h3[data-v-4570d4cc]{color:#fff}.block-blue[data-v-4570d4cc]{background-color:#003a70;color:#fff}", "", {"version":3,"sources":["/./client/components/pages/understandingYourReport/BlueCallToAction.vue"],"names":[],"mappings":"AACA,uBACE,UAAe,CAChB,AACD,6BACE,yBAA0B,AAC1B,UAAe,CAChB","file":"BlueCallToAction.vue","sourcesContent":["\nh3.h3[data-v-4570d4cc] {\n  color: #FFFFFF;\n}\n.block-blue[data-v-4570d4cc] {\n  background-color: #003A70;\n  color: #FFFFFF;\n}\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 308 */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/understandingYourReport/BlueCallToAction.vue ***!
  \****************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/understandingYourReport/BlueCallToAction.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "blue-call-to-action",
  data: function data() {
    return {
      content: [{
        title: "Not Enough Information?",
        body: "With some items, the reviewer may have indicated the x-ray does not have enough information to " + "confirm the specific criteria. This can be because a poor x-ray image was taken. It can also " + "happen when the angle of the image makes it difficult to see some things. For example, an " + "additional canal may be hidden behind one or the access opening can be hidden by the crown. " + "In these cases an additional image may be needed. Some dental offices have more advanced " + "machines that take a comprehensive 3D image to make sure nothing is missed.  "
      }, {
        title: "What Next?",
        body: "It's important to understand that your review is a comparison of the submitted x-rays " + "against industry standards. If your report looks positive, then you now have an additional " + "data point to help you appreciate the quality of work provided. If you\u2019re report appears to show " + "some issues, we recommend you start by discussing this with your dentist. He/She may know about " + "your case beyond what your VeriTooth reviewer was able to see in the submitted x-rays. Dentists " + "spend years perfecting their trade and care deeply about the quality of their work. In our " + "conversations with dentists, most welcome the discussion and appreciate their patients " + "taking an interest in quality work.  "
      }]
    };
  }
});

/***/ }),
/* 309 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4570d4cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/BlueCallToAction.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block block-blue"
  }, [_c('div', {
    staticClass: "home-block group group--first-last-small"
  }, _vm._l((_vm.content), function(block, index) {
    return _c('span', {
      key: index,
      staticClass: "mt-2"
    }, [_c('h3', {
      staticClass: "h3"
    }, [_vm._v(_vm._s(block.title))]), _vm._v(" "), _c('p', {
      staticClass: "p mw-100"
    }, [_vm._v(_vm._s(block.body))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 310 */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c4e6e5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/UnderstandingYourReport.vue ***!
  \*******************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--home"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _vm._l((_vm.components), function(component, index) {
    return _c(component, {
      key: index,
      tag: "component"
    })
  }), _vm._v(" "), _c('ui-footer')], 2)
},staticRenderFns: []}

/***/ }),
/* 311 */
/*!**********************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/TrackLink.vue ***!
  \**********************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/TrackLink.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(/*! axios */ 50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(/*! config */ 6);
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'track-link',
  components: {
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_0_modules_Spinner___default.a
  },
  beforeCreate: function beforeCreate() {
    var link = this.$route.params.redirect || false;
    var payload = this.$route.params.payload || false;

    if (payload && link) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2_config__["a" /* default */].api + '/link', {
        payload: payload,
        link: link
      }).then(function () {
        // pass
      }).catch(function () {
        // pass
      });

      window.location = link;
    }
    return this.$router.replace({
      name: 'notFound'
    });
  }
});

/***/ }),
/* 312 */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35919082"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/TrackLink.vue ***!
  \*****************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--link"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }, [_c('module-spinner', {
    attrs: {
      "active": true,
      "floating": true
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 313 */
/*!******************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Login.vue ***!
  \******************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/Login.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Auth__ = __webpack_require__(/*! ui/Auth */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ui_Auth__);
//
//
//
//
//
//
//
//
//
//
//

// Models


// Services


// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-login',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].login.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_1_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].login.meta)
  },

  // Components
  components: {
    UiAuth: __WEBPACK_IMPORTED_MODULE_2_ui_Auth___default.a
  }
});

/***/ }),
/* 314 */
/*!*************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe01037a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Login.vue ***!
  \*************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--auth main--login"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "slug": "login",
      "submit": "Sign In"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 315 */
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Logout.vue ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/Logout.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(/*! config */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 5);
//
//
//
//
//
//
//
//


// Vuex


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-logout',

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('auth', ['requestLogout'])),

  // Lifecycle
  created: function created() {
    this.requestLogout({
      noRedirect: true
    }).then(function () {
      setTimeout(function () {
        window.location = __WEBPACK_IMPORTED_MODULE_0_config__["a" /* default */].wp;
      }, 600);
    });
  }
});

/***/ }),
/* 316 */
/*!**************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27fd5ac0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Logout.vue ***!
  \**************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Successfully logged out!")])])])
}]}

/***/ }),
/* 317 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/register/RegisterDentist.vue ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/register/RegisterDentist.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ui_Auth__ = __webpack_require__(/*! ui/Auth */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ui_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ui_Auth__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Models


// Services


// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-register-dentist',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_1_models_meta__["a" /* default */].register.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_2_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_1_models_meta__["a" /* default */].register.meta)
  },

  // Components
  components: {
    UiAuth: __WEBPACK_IMPORTED_MODULE_3_ui_Auth___default.a
  },

  // Data
  data: function data() {
    return {
      terms: ['By signing up you agree to the VeriTooth ', '<a href="/terms" target="_blank">T&Cs</a> and <a href="/policy" target="_blank">Privacy Policy</a>']
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['showTour'])),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('forms', ['updateValue']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('auth', ['activateTour'])),

  // Lifecycle
  mounted: function mounted() {
    var _this = this;

    // this.activateTour(true);
    if (this.$route.name === 'register-dentist') {
      this.activateTour('dentist');
    } else if (this.$route.name === 'register-reviewer') {
      this.activateTour('reviewer');
    }
    this.$nextTick(function () {
      _this.updateValue({
        form: 'registerDentist',
        field: 'tour_taken',
        value: true
      });
    });
    var email = sessionStorage.getItem('dentist_email') || this.$route.query.email || false;

    if (email) {
      this.$nextTick(function () {
        _this.updateValue({
          form: 'registerDentist',
          field: 'email',
          value: email
        });
      });

      sessionStorage.removeItem('dentist_email');
    }
  }
});

/***/ }),
/* 318 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c67c2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/register/RegisterDentist.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--register main--register-dentist"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "title": "Create Your Dentist Account",
      "slug": "registerDentist",
      "copy": "Create your account to join the growing team of experts demonstrating quality in dentistry.  Your account will allow you to submit your patient’s radiographs for review and track their progress.  You can also request to become an independent reviewer of other’s work.",
      "terms": _vm.terms,
      "submit": "Create Account"
    }
  }, [_c('div', {
    attrs: {
      "slot": "top-link"
    },
    slot: "top-link"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v("Already have an account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('br'), _vm._v("Not a dentist? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register-patient'
      }
    }
  }, [_vm._v("Register as a Patient")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "before-submit"
    },
    slot: "before-submit"
  }, [_c('p', {
    staticClass: "mt0 mb0 small"
  }, [_vm._v("By signing up you agree to the VeriTooth")]), _vm._v(" "), _c('p', {
    staticClass: "mt0 small"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'terms'
      },
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      },
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 319 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/register/RegisterPatient.vue ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/register/RegisterPatient.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Auth__ = __webpack_require__(/*! ui/Auth */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ui_Auth__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Models


// Services


// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-register',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].register.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_1_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_0_models_meta__["a" /* default */].register.meta)
  },

  // Components
  components: {
    UiAuth: __WEBPACK_IMPORTED_MODULE_2_ui_Auth___default.a
  }
});

/***/ }),
/* 320 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cfbe2cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/register/RegisterPatient.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--register main--register-patient"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "title": "Create Your VeriTooth Account",
      "slug": "registerPatient",
      "copy": "Create your account to request your dental records and get feedback on the work. Once your account is set up you can request your records from your dentist and get notified of reviews.",
      "submit": "Create Account"
    }
  }, [_c('div', {
    attrs: {
      "slot": "top-link"
    },
    slot: "top-link"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v("Already have an account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('br'), _vm._v("Are you a dentist? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register-dentist'
      }
    }
  }, [_vm._v("Register as a Dentist")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "before-submit"
    },
    slot: "before-submit"
  }, [_c('p', {
    staticClass: "mt0 mb0 small"
  }, [_vm._v("By signing up you agree to the VeriTooth")]), _vm._v(" "), _c('p', {
    staticClass: "mt0 small"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'terms'
      },
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      },
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 321 */
/*!***********************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/auth/Reset.vue ***!
  \***********************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/auth/Reset.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ui_Auth__ = __webpack_require__(/*! ui/Auth */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ui_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ui_Auth__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-register',

  // Components
  components: {
    UiAuth: __WEBPACK_IMPORTED_MODULE_1_ui_Auth___default.a
  },

  // Data
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel']), {
    model: function model() {
      return this.getModel('reset');
    }
  })
});

/***/ }),
/* 322 */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afe04fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Reset.vue ***!
  \******************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--reset"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "success-copy": ("Reset instructions were sent to <strong>" + (_vm.model.email || "the email you provided") + "</strong>."),
      "title": "Forgotten Password",
      "copy": "Enter the address associated with your account. We’ll send you instructions on how to reset your password.",
      "slug": "reset"
    }
  }, [_c('span', {
    attrs: {
      "slot": "link"
    },
    slot: "link"
  }, [_vm._v("Remembered your password? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 323 */
/*!*************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/auth/Confirm.vue ***!
  \*************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/auth/Confirm.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ui_Auth__ = __webpack_require__(/*! ui/Auth */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ui_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ui_Auth__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-register',

  // Components
  components: {
    UiAuth: __WEBPACK_IMPORTED_MODULE_1_ui_Auth___default.a
  },

  // Data
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getStatus']), {
    status: function status() {
      return this.getStatus('confirm');
    }
  })
});

/***/ }),
/* 324 */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55cc37a2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Confirm.vue ***!
  \********************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--confirm"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "title": "Reset Password",
      "copy": "Enter your new password.",
      "success-copy": "Password reset!",
      "slug": "confirm"
    }
  }, [_c('span', {
    attrs: {
      "slot": "link"
    },
    slot: "link"
  }, [_vm._v(_vm._s(_vm.status.success ? "" : "Remembered your password?") + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 325 */
/*!**********************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Dashboard.vue ***!
  \**********************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/Dashboard.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models_meta__ = __webpack_require__(/*! models/meta */ 204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models_auth__ = __webpack_require__(/*! models/auth */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_meta__ = __webpack_require__(/*! services/meta */ 42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Icon__ = __webpack_require__(/*! modules/Icon */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_dashboard_Navigation__ = __webpack_require__(/*! pages/dashboard/Navigation */ 326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pages_dashboard_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pages_dashboard_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ui_Tooltip__ = __webpack_require__(/*! ui/Tooltip */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ui_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ui_Tooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Models



// Services


// Modules





// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-dashboard',

  // Meta data
  metaInfo: {
    title: __WEBPACK_IMPORTED_MODULE_1_models_meta__["a" /* default */].dashboard.title,
    meta: Object(__WEBPACK_IMPORTED_MODULE_3_services_meta__["a" /* createMeta */])(__WEBPACK_IMPORTED_MODULE_1_models_meta__["a" /* default */].dashboard.meta)
  },

  // Components
  components: {
    ModuleIcon: __WEBPACK_IMPORTED_MODULE_4_modules_Icon___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_5_modules_Link___default.a,
    UiTooltip: __WEBPACK_IMPORTED_MODULE_7_ui_Tooltip___default.a,
    PagesDashboardNavigation: __WEBPACK_IMPORTED_MODULE_6_pages_dashboard_Navigation___default.a
  },

  // Data
  data: function data() {
    return {
      showNav: false,
      windowWidth: 0,
      toggleText: ''
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('app', ['appState']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('dashboard', ['dashboardTransitionState']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['user', 'userRole', 'userIsRole', 'showTour']), {
    inReviewCycle: function inReviewCycle() {
      return this.userRole.role === 3 && this.$route.name === 'dashboard-review';
    },
    dataComplete: function dataComplete() {
      var _this = this;

      var finished = false;

      var basicInfo = ['first_name', 'last_name'];
      var profileInfo = ['license_number', 'phone_number', 'specialty'];

      if (this.user.role === 1) {
        basicInfo.every(function (value) {
          return _this.user[value];
        }) ? finished = true : finished = false;
      }
      if (this.user.role === 2 || this.user.role === 3) {
        basicInfo.every(function (value) {
          return _this.user[value];
        }) ? profileInfo.every(function (value) {
          return _this.user.profile[value];
        }) ? finished = true : finished = false : finished = false;
      }
      return finished;
    },
    tourPath: function tourPath() {
      return __WEBPACK_IMPORTED_MODULE_2_models_auth__["h" /* tourPaths */][this.showTour] || [];
    }
  }),
  watch: {
    $route: function $route() {
      this.toggleDashboard(false);
    },
    dashboardTransitionState: function dashboardTransitionState(state) {
      this.setToggleText(state);
    }
  },

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('app', ['openLoader', 'updatePage', 'closeLoader']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('dashboard', ['toggleDashboard']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('modals', ['closeModal']), {
    infoCTAVisible: function infoCTAVisible() {
      return this.showTour && this.user.role === 1 && this.offTourStep === 1 || this.showTour && this.user.role === 2 && this.user.profile.tour_taken && !!this.getOffTourStep();
    },
    notOnStepPage: function notOnStepPage() {
      var tourStep = this.getOffTourStep();
      return this.$route.name !== this.tourPath[tourStep];
    },
    offTourStep: function offTourStep(step) {
      var stepCount = this.getOffTourStep();
      return stepCount === step;
    },
    getOffTourStep: function getOffTourStep() {
      // Profile Information
      if (!this.dataComplete) {
        return 1;
      }

      // Location Information
      if (this.dataComplete && this.user.locationsCount < 1) {
        return 2;
      }

      if (this.dataComplete && this.user.locationsCount > 0 && this.user.profile.has_applied_for_reviewer_privileges === false && this.showTour === 'reviewer') {
        return 3;
      }

      return 0;
    },
    notOnPage: function notOnPage(name) {
      return this.$route.name !== name;
    },
    onLeave: function onLeave() {
      this.openLoader();
      this.closeModal();
    },
    onLoad: function onLoad() {
      this.updatePage();

      if (this.appState.init) {
        this.closeLoader();
      }
    },
    setToggleText: function setToggleText(state) {
      if (state === 'hidden') this.toggleText = 'Show';else if (state === 'show') this.toggleText = 'Hide';
    }
  }),

  // Lifecycle
  created: function created() {
    this.setToggleText(this.dashboardTransitionState);
  }
});

/***/ }),
/* 326 */
/*!**********************************************************!*\
  !*** ./client/components/pages/dashboard/Navigation.vue ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Navigation.vue */ 327),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-76e31f2e"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Navigation.vue */ 328),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/*!********************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/dashboard/Navigation.vue + 1 modules ***!
  \********************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/pages/dashboard/Navigation.vue (referenced with cjs require) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Icon.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Link.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/ui/Tooltip.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/vuex/dist/vuex.esm.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(5);

// CONCATENATED MODULE: ./client/models/dashboard/navigation.js
var dashboardPanels = {

  // Patient
  patient: {
    title: "Patient",
    role: [1],
    links: [{
      title: "My Requests",
      link: "dashboard-requests"
    }]
  },
  dentist: {
    title: "Doctor",
    role: [2, 3],
    links: [{
      title: "My Procedures and X-Ray Requests",
      link: "dashboard-requests"
    }, {
      title: "My Location(s)",
      link: "dashboard-dentist-locations"
    }]
  },

  // Reviewer
  reviewer: {
    title: "Reviewer",
    role: [3],
    links: [{
      title: "Reviews",
      link: "dashboard-reviews"
    }]
  },

  // Admin
  admin: {
    title: "Admin",
    role: [42],
    links: [
    // {
    //   title: `Procedure Reviews`,
    //   link: `dashboard-requests`,
    // },
    // {
    //   title: `VeriTooth Dentists`,
    //   // link: `admin-veritooth-dentists`,
    // },
    // {
    //   title: `VeriTooth Patients`,
    //   // link: `admin-veritooth-patients`,
    // },
    {
      title: "Reviewer Verification",
      link: "admin-reviewer-requests"
    }, {
      title: "Email Logs",
      link: "admin-email-logs"
    }]
  },

  // Profile
  profile: {
    title: "Profile",
    role: true,
    links: [{
      title: "My Information",
      link: "dashboard-profile-info"
    }, {
      title: "Password",
      link: "dashboard-profile-password"
    }]
  }
};

/* harmony default export */ var navigation = (dashboardPanels);
// EXTERNAL MODULE: ./client/components/ui/Tooltip.vue
var Tooltip = __webpack_require__(44);
var Tooltip_default = /*#__PURE__*/__webpack_require__.n(Tooltip);

// EXTERNAL MODULE: ./client/components/modules/Icon.vue
var Icon = __webpack_require__(8);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);

// EXTERNAL MODULE: ./client/components/modules/Link.vue
var Link = __webpack_require__(7);
var Link_default = /*#__PURE__*/__webpack_require__.n(Link);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/pages/dashboard/Navigation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Models


// UI


// Modules



// Export
/* harmony default export */ var Navigation = __webpack_exports__["default"] = ({
  name: 'ui-dashboard-navigation',

  // Components
  components: {
    ModuleIcon: Icon_default.a,
    ModuleLink: Link_default.a,
    UiTooltip: Tooltip_default.a
  },
  // Data
  data: function data() {
    return {
      panels: navigation
    };
  },

  computed: Object.assign({}, Object(vuex_esm["c" /* mapGetters */])('auth', ['user', 'userRole', 'userIsRole']), Object(vuex_esm["c" /* mapGetters */])('dashboard', ['dashboardTransitionState']))
});

/***/ }),
/* 328 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e31f2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/dashboard/Navigation.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: [
      'd-nav',
      ("d-nav--" + _vm.dashboardTransitionState) ]
  }, [_c('div', {
    staticClass: "d-nav__wrapper"
  }, [_c('div', {
    staticClass: "d-nav__panels"
  }, _vm._l((_vm.panels), function(panel, index) {
    return (_vm.userIsRole(panel.role)) ? _c('div', {
      key: index,
      staticClass: "d-nav__panel"
    }, [_c('p', {
      staticClass: "h6 d-nav__heading",
      domProps: {
        "innerHTML": _vm._s(panel.title)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "d-nav__list"
    }, _vm._l((panel.links), function(link, index) {
      return _c('li', {
        key: index,
        staticClass: "p"
      }, [_c('module-link', {
        staticClass: "d-nav__link",
        attrs: {
          "link": link.link
        }
      }, [_vm._v(_vm._s(link.title))])], 1)
    }))]) : _vm._e()
  })), _vm._v(" "), _c('span', {
    staticClass: "p d-nav__logout"
  }, [_c('module-link', {
    staticClass: "dashboard__link",
    attrs: {
      "link": "logout",
      "label": "Log out",
      "icon": "logout",
      "icon-negative": true,
      "no-underline": true
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 329 */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145ebaee"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Dashboard.vue ***!
  \*****************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--dashboard"
  }, [_c('span', {
    staticClass: "d-nav__toggle no-select",
    on: {
      "click": function($event) {
        _vm.toggleDashboard()
      }
    }
  }, [_c('span', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "p"
  }, [_vm._v(_vm._s((_vm.toggleText + " Dashboard")))])])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard group"
  }, [_c('pages-dashboard-navigation'), _vm._v(" "), _c('b', {
    class: [
      "d-nav__underlay",
      {
        'd-nav__underlay--active': _vm.dashboardTransitionState === "show" || _vm.dashboardTransitionState === "in",
      }
    ]
  }), _vm._v(" "), _c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loader",
      "mode": "out-in"
    },
    on: {
      "appear": function($event) {
        _vm.onLoad()
      },
      "enter": function($event) {
        _vm.onLoad()
      },
      "leave": function($event) {
        _vm.onLeave()
      }
    }
  }, [_c('div', {
    staticClass: "dashboard__panel"
  }, [(_vm.infoCTAVisible() && _vm.notOnStepPage()) ? _c('ui-tooltip', {
    attrs: {
      "level": "tip"
    }
  }, [_c('span', {
    staticClass: "info-request-cta",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [(_vm.user.role === 1 && _vm.offTourStep(1)) ? [_c('p', [_vm._v("Your profile hasn't been completed yet. Please update your information "), _c('module-link', {
    attrs: {
      "link": "dashboard-profile-info"
    }
  }, [_c('strong', [_vm._v("here")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.showTour === "reviewer") ? [_c('h4', [_vm._v("You're on your way to becoming a reviewer!")]), _vm._v(" "), _c('ul', {
    staticClass: "info-request-cta__step-counter"
  }, [_c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(1)
    }]
  }, [_vm._v("1: Enter your profile information on your "), _c('module-link', {
    attrs: {
      "link": "dashboard-profile-info"
    }
  }, [_c('strong', [_vm._v("profile page")])])], 1), _vm._v(" "), _c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(2)
    }]
  }, [_vm._v("2: Add a location to your "), _c('module-link', {
    attrs: {
      "link": "dashboard-dentist-locations"
    }
  }, [_c('strong', [_vm._v("location page")])])], 1), _vm._v(" "), _c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(3)
    }]
  }, [_vm._v("3: Apply to become a reviewer on the "), _c('module-link', {
    attrs: {
      "link": "dashboard-reviewer-application"
    }
  }, [_c('strong', [_vm._v("reviewer applicaton page")])])], 1)])] : _vm._e(), _vm._v(" "), (_vm.showTour === "dentist") ? [_c('h4', [_vm._v("Your profile hasn't been completed yet. Please update your information.")]), _vm._v(" "), _c('ul', {
    staticClass: "info-request-cta__step-counter"
  }, [_c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(1)
    }]
  }, [_vm._v("1: Enter your profile information on your "), _c('module-link', {
    attrs: {
      "link": "dashboard-profile-info"
    }
  }, [_c('strong', [_vm._v("profile page")])])], 1), _vm._v(" "), _c('li', {
    class: ['info-request-cta__off-tour-step', {
      'info-request-cta__off-tour-step--active': _vm.offTourStep(2)
    }]
  }, [_vm._v("2: Add a location to your "), _c('module-link', {
    attrs: {
      "link": "dashboard-dentist-locations"
    }
  }, [_c('strong', [_vm._v("location page")])])], 1)])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath
  })], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 330 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/profile/MyInfo.vue ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/profile/MyInfo.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_string__ = __webpack_require__(/*! services/string */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models_dashboard_userDetails__ = __webpack_require__(/*! models/dashboard/userDetails */ 224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_DetailList__ = __webpack_require__(/*! modules/DetailList */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_DetailList__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services



// Models


// Modules




// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-my-information',

  // Components
  components: {
    ModuleForm: __WEBPACK_IMPORTED_MODULE_4_modules_Form___default.a,
    ModuleButton: __WEBPACK_IMPORTED_MODULE_5_modules_Button___default.a,
    ModuleDetailList: __WEBPACK_IMPORTED_MODULE_6_modules_DetailList___default.a
  },

  data: function data() {
    return {
      editDetails: false,
      patientForm: Object.assign({}, __WEBPACK_IMPORTED_MODULE_3_models_dashboard_userDetails__["d" /* patientDetails */], __WEBPACK_IMPORTED_MODULE_3_models_dashboard_userDetails__["a" /* address */]),
      doctorForm: Object.assign({}, __WEBPACK_IMPORTED_MODULE_3_models_dashboard_userDetails__["b" /* dentistDetails */]),
      profileFields: ['license_number', 'phone_number', 'specialty']
      // requiredData: [
      //   `first_name`,
      //   `last_name`,
      // ],
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel', 'getStatus']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['user', 'userRole', 'userIsRole', 'showTour']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('review', ['reviewNomenclatureBySlug', 'reviewNomenclatureBySlugAndId']), {
    model: function model() {
      return this.getModel('dashboard-info');
    },
    dataComplete: function dataComplete() {
      var _this = this;

      var finished = true;

      var requiredData = ['first_name', 'last_name'];

      if (this.userIsRole([2, 3])) {
        requiredData = [].concat(_toConsumableArray(requiredData), ['license_number', 'phone_number', 'specialty']);
      }

      Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(requiredData, function (i, key) {
        var field = _this.user[key];

        if (Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["a" /* arrayIncludes */])(_this.profileFields, key)) field = _this.user.profile[key];

        if (!field) finished = false;
      });

      return finished;
    },
    fields: function fields() {
      if (this.userIsRole([1])) {
        return this.patientForm;
      }

      var fields = this.doctorForm;

      fields.specialty.items = this.reviewNomenclatureBySlug('specialties');

      return fields;
    },
    aboutItems: function aboutItems() {
      var user = this.user || {};

      var items = {
        'First Name': user.first_name,
        'Last Name': user.last_name,
        'Email Address': user.email
      };

      if (this.userIsRole([2, 3])) {
        var profile = user.profile || {};

        items = Object.assign({}, items, {
          'License Number': profile.license_number || null,
          'Main Phone Number': profile.phone_number || null,
          'Speciality': this.reviewNomenclatureBySlugAndId('specialties', profile.specialty) || null
        });
      }

      return items;
    },
    addressItems: function addressItems() {
      var user = this.user;

      if (!this.userIsRole([1])) return null;

      return {
        'Address Line One': user.address_line_1,
        'Address Line Two': user.address_line_2,
        'City': user.city,
        'ZIP': user.zip
      };
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('forms', ['updateValue']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('auth', ['requestUpdateUser']), {
    toggleEdit: function toggleEdit() {
      var _this2 = this;

      if (this.editDetails) {
        this.editDetails = false;
      } else {

        Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(this.fields, function (key) {
          var field = _this2.user[key];

          if (Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["a" /* arrayIncludes */])(_this2.profileFields, key)) field = _this2.user.profile[key];

          _this2.fields[key].value = field || null;
        });

        this.$nextTick(function () {
          return _this2.editDetails = true;
        });
      }
    },
    action: function action() {
      var model = this.model;

      if (this.userIsRole([2, 3])) {
        model.profile = {};

        Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(this.profileFields, function (i, key) {
          key === 'phone_number' ? model.profile[key] = Object(__WEBPACK_IMPORTED_MODULE_2_services_string__["a" /* americanizePhoneNumber */])(model[key]) : model.profile[key] = model[key];
        });
      }

      return this.requestUpdateUser(this.model);
    },
    success: function success() {
      var _this3 = this;

      if (this.showTour) {
        this.$router.push({
          name: 'dashboard-dentist-locations'
        });
      } else {
        setTimeout(function () {
          _this3.toggleEdit();
        }, 1000);
      }
    },
    fail: function fail(_fail) {
      console.warn(_fail);
    }
  })
});

/***/ }),
/* 331 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/DetailList.vue ***!
  \************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/DetailList.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "module-detail-list",

  // Props
  props: {
    title: {
      type: String
    },
    items: {
      type: Object
    }
  }
});

/***/ }),
/* 332 */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fef8eeb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/DetailList.vue ***!
  \*******************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "m-detail-list" ]
  }, [(_vm.title) ? _c('h3', {
    staticClass: "h4"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('dl', {
    staticClass: "m-detail-list__field p"
  }, [_vm._l((_vm.items), function(definition, term, index) {
    return [_c('dt', {
      key: ("dt-" + index),
      staticClass: "m-detail-list__title fw-bold",
      domProps: {
        "innerHTML": _vm._s(term)
      }
    }), _vm._v(" "), _c('dd', {
      key: ("dd-" + index),
      staticClass: "m-detail-list__detail",
      domProps: {
        "innerHTML": _vm._s(definition || "…")
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 333 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694db4de"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/profile/MyInfo.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("My Information")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Please let us know about your detailed information:")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editDetails) ? _c('module-form', {
    key: "info-form",
    attrs: {
      "form-id": "dashboard-info",
      "fields": _vm.fields,
      "button-size": "m",
      "button": "primary",
      "submit": "Save Changes",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }, [_c('module-button', {
    attrs: {
      "slot": "submit-extras",
      "button": "tertiary",
      "size": "m",
      "type": "button",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleEdit()
      }
    },
    slot: "submit-extras"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editDetails) ? _c('div', {
    key: "info-details"
  }, [(_vm.aboutItems) ? _c('module-detail-list', {
    attrs: {
      "title": "About",
      "items": _vm.aboutItems
    }
  }) : _vm._e(), _vm._v(" "), (_vm.addressItems) ? _c('module-detail-list', {
    attrs: {
      "title": "Address Information",
      "items": _vm.addressItems
    }
  }) : _vm._e(), _vm._v(" "), _c('module-button', {
    attrs: {
      "size": "m",
      "level": "secondary",
      "button": "secondary",
      "label": "Edit my details"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleEdit()
      }
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 334 */
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/profile/Password.vue ***!
  \***************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/profile/Password.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models_auth_index__ = __webpack_require__(/*! models/auth/index */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Form__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Models


// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-password',

  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_2_modules_Button___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_3_modules_Form___default.a
  },

  // Data
  data: function data() {
    return {
      resetPassword: __WEBPACK_IMPORTED_MODULE_1_models_auth_index__["g" /* resetPassword */],
      submitted: false
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel']), {
    model: function model() {
      return this.getModel('dashboard-password');
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('auth', ['requestUpdatePassword']), {
    action: function action() {
      return this.requestUpdatePassword(this.model);
    },
    success: function success() /*success*/{
      var _this = this;

      setTimeout(function () {
        _this.submitted = true;
      }, 1000);
    },
    fail: function fail(_fail) {
      console.warn(_fail);
    },
    showForm: function showForm() {
      this.submitted = false;
    }
  })
});

/***/ }),
/* 335 */
/*!**********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64e6591c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/profile/Password.vue ***!
  \**********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.submitted) ? _c('div', {
    staticClass: "dashboard-password"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Something about reseting your password")]), _vm._v(" "), _c('module-form', {
    attrs: {
      "form-id": "dashboard-password",
      "fields": _vm.resetPassword,
      "button-size": "m",
      "button": "primary",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1) : _c('div', {
    staticClass: "dashboard-password"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Your password has been reset")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Something about reseting your password")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "level": "secondary",
      "label": "Got It",
      "button": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showForm()
      }
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 336 */
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/Requests.vue ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/Requests.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_dateTime__ = __webpack_require__(/*! services/dateTime */ 208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models_review__ = __webpack_require__(/*! models/review */ 225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Table__ = __webpack_require__(/*! modules/Table */ 209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_Table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Models


// Modules





// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-requests',

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_3_modules_Button___default.a,
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_4_modules_Spinner___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_5_modules_Link___default.a,
    ModuleTable: __WEBPACK_IMPORTED_MODULE_6_modules_Table___default.a
  },

  // Data
  data: function data() {
    return {
      loading: true
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['user', 'userRole', 'userIsRole', 'showTour']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('review', ['reviewRequests', 'reviewRequestsLength', 'reviewRequestsTotal', 'reviewNomenclatureBySlugAndId']), {
    content: function content() {
      var map = {
        1: {
          title: 'My Requests'
        },
        2: {
          title: 'My Procedures and X-Ray Requests',
          copy: 'Requests for X-Rays from procedures you have carried out on patients.'
        },
        3: {
          title: 'My Procedures and X-Ray Requests',
          copy: 'Requests for X-Rays from procedures you have carried out on patients.'
        },
        42: {
          title: 'Procedure Reviews',
          copy: 'Here you can peer-review submissions from dentists and approve or deny them.'
        }
      };

      return map[this.userRole.role] || {};
    },
    columns: function columns() {
      var _this = this;

      var status = {
        heading: 'Status',
        value: function value(request) {
          return __WEBPACK_IMPORTED_MODULE_2_models_review__["c" /* statusMap */][request.state];
        }
      };

      var name = {
        heading: 'Procedure',
        // value: request => (request.procedure || {}).name,
        value: function value(request) {
          return _this.reviewNomenclatureBySlugAndId('procedure', request.procedure) || {};
        }
      };

      var rating = {
        heading: 'Rating',
        value: function value(request) {
          var review = request.review || {};

          return review.rating ? review.rating + '/10' : false;
        }
      };

      var date = {
        heading: 'Submitted On',
        value: function value(request) {
          return Object(__WEBPACK_IMPORTED_MODULE_1_services_dateTime__["a" /* toDateString */])((request || {}).created_at || '');
        }
      };

      var link = {
        heading: 'Link',
        hidden: true,
        align: 'right',
        value: function value() {
          return {
            is: __WEBPACK_IMPORTED_MODULE_3_modules_Button___default.a,
            bind: {
              label: 'Submit review',
              button: 'primary',
              size: 's',
              icon: 'arrow-right'
            }
          };
        }
      };

      var patient = [status, name, rating, date, link];

      var doctor = [status, name, rating, date, link];

      var reviewer = [status, name, rating, date, link];

      var admin = [status, name, {
        heading: 'Reviewed By',
        value: function value(request) {
          return request.is_answered ? '{{ Dentist }}' : null;
        }
      }, {
        heading: 'Reviewed On',
        value: function value(request) {
          return request.is_answered ? '{{ date }}' : null;
        }
      },
      // id,
      link];

      var columns = {
        1: patient,
        2: doctor,
        3: reviewer,
        42: admin
      };

      return columns[this.userRole.role] || [];
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('review', ['getReviewRequests', 'getReviewRequestsDoctor']), {
    getReviews: function getReviews() {
      return this.getReviewRequests();
    },
    getNextPage: function getNextPage() {
      var _this2 = this;

      if (this.loading) return false;

      this.loading = true;

      setTimeout(function () {
        _this2.getReviews(_this2.reviewRequests.next).then(function () {
          return _this2.loading = false;
        });
      }, 300);
    },
    onRowClick: function onRowClick(id, row) {
      this.$router.push({
        name: this.userRole.role >= 2 && row.state < 3 ? 'request-complete' : 'dashboard-review',
        params: {
          id: id
        }
      });
    },
    startReviewing: function startReviewing() {
      this.$router.push({
        name: 'dashboard-next-review'
      });
    },
    getRowTitle: function getRowTitle(row) {
      // If am reviewer then do not show this stuff as its PII
      if (this.userRole.role === 3) {
        return '';
      }
      var doctor = row.doctor || {
        email: '',
        first_name: '',
        last_name: ''
      };

      var full_name = [doctor.first_name, doctor.last_name].join(' ');
      return (full_name + ' <' + doctor.email + '>').trim();
    }
  }),

  // Lifecycle
  created: function created() {
    var _this3 = this;

    this.getReviews().then(function () {
      return _this3.loading = false;
    });
  }
});

/***/ }),
/* 337 */
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Table.vue ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Table.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_icons_spinner_svg_inline__ = __webpack_require__(/*! images/icons/spinner.svg?inline */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_icons_spinner_svg_inline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_images_icons_spinner_svg_inline__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Services


// Inline


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-table',

  // Components
  components: {
    InlineImageIconsSpinner: __WEBPACK_IMPORTED_MODULE_1_images_icons_spinner_svg_inline___default.a
  },

  // Props
  props: {
    columns: {
      type: Array
    },
    rows: {
      type: [Array, Object]
    },
    rowClick: {
      type: Boolean
    },
    rowTitle: {
      type: Function
    }
  },

  // Data
  computed: {
    rowsSet: function rowsSet() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0_services_array__["c" /* isArray */])(this.rows)) return this.rows;

      var rows = {};
      Object(__WEBPACK_IMPORTED_MODULE_0_services_array__["b" /* arrayLoop */])(this.rows || [], function (i, row) {
        return rows[i] = row;
      });
      return rows;
    }
  },

  // Methods
  methods: {
    getCellClass: function getCellClass(_ref) {
      var type = _ref.type,
          column = _ref.column,
          index = _ref.index;

      return ['m-table__cell', 'm-table__cell--' + type, 'm-table__cell--' + index, column.align ? 'm-table__cell--align-' + column.align : ''];
    },
    onRowClick: function onRowClick(e, id, row) {
      if (!this.rowClick) return false;

      this.$emit('row-click', id, row);
    },
    getRowTitle: function getRowTitle(row) {
      return typeof this.rowTitle === 'function' ? this.rowTitle(row) : '';
    }
  }
});

/***/ }),
/* 338 */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6a664bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Table.vue ***!
  \**************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "m-table",
      {
        'm-table--clickable': _vm.rowClick,
      } ]
  }, [_c('table', {
    staticClass: "m-table__table"
  }, [_c('thead', {
    staticClass: "m-table__head small"
  }, [_c('tr', _vm._l((_vm.columns), function(column, index) {
    return _c('td', {
      key: index,
      class: _vm.getCellClass({
        type: "heading",
        column: column,
        index: index,
      }),
      domProps: {
        "innerHTML": _vm._s(!column.hidden ? column.heading : " ")
      }
    })
  }))]), _vm._v(" "), _c('tbody', {
    staticClass: "m-table__body small"
  }, _vm._l((_vm.rows), function(row, id) {
    return _c('tr', {
      key: id,
      class: [
        "m-table__row",
        "m-table__row--body" ],
      attrs: {
        "title": _vm.getRowTitle(row)
      },
      on: {
        "click": function($event) {
          _vm.onRowClick($event, id, row)
        }
      }
    }, _vm._l((_vm.columns), function(column, index) {
      return _c('td', {
        key: index,
        class: _vm.getCellClass({
          type: "body",
          column: column,
          index: index,
        })
      }, [(typeof(column.value) === "function" && (column.value(row) || {}).is) ? _c(column.value(row).is, _vm._b({
        tag: "component"
      }, 'component', column.value(row).bind || {}, false)) : [_vm._v(_vm._s((typeof(column.value) === "function" ? column.value(row) : column.value) || "-"))]], 2)
    }))
  }))])])
},staticRenderFns: []}

/***/ }),
/* 339 */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7b33b16"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/Requests.vue ***!
  \**************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-requests"
  }, [_c('module-spinner', {
    attrs: {
      "active": _vm.loading && _vm.reviewRequestsTotal === 0,
      "floating": true
    }
  }), _vm._v(" "), (_vm.userIsRole([1])) ? _c('module-button', {
    staticClass: "mt0 mb",
    attrs: {
      "button": "primary",
      "size": "m",
      "label": "Start New Request",
      "link": "request"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.title) ? _c('h1', {
    class: [
      "h3",
      {
        'mt0': !_vm.userIsRole([1, 2]),
      }
    ],
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.copy) ? _c('p', {
    staticClass: "p",
    domProps: {
      "innerHTML": _vm._s(_vm.content.copy)
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.reviewRequestsTotal > 0) ? _c('div', {
    key: "requests-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.reviewRequests.results,
      "row-click": true,
      "row-title": _vm.getRowTitle
    },
    on: {
      "row-click": _vm.onRowClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-requests__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.reviewRequestsLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.reviewRequestsTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.reviewRequests.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNextPage($event)
      }
    }
  }) : _vm._e()], 1)], 1) : (_vm.reviewRequestsTotal === 0 && !_vm.loading && _vm.userIsRole([1])) ? _c('div', {
    key: "no-requests"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("You have no requests. Please request a new "), _c('module-link', {
    attrs: {
      "link": "request",
      "label": "review here",
      "color": "secondary"
    }
  }), _vm._v(".")], 1)]) : (_vm.reviewRequestsTotal === 0 && !_vm.loading && _vm.userIsRole([2, 3])) ? _c('p', {
    staticClass: "fw-bold"
  }, [_vm._v("No current X-Ray upload requests")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 340 */
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/Reviews.vue ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/Reviews.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-reviews',

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_0_modules_Button___default.a
  },

  methods: {
    startReviewing: function startReviewing() {
      this.$router.push({
        name: 'dashboard-next-review'
      });
    }
  }
});

/***/ }),
/* 341 */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e27b00c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/Reviews.vue ***!
  \*************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "h3"
  }, [_vm._v("Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Here is where you can review procedures submitted by patients.")]), _vm._v(" "), _c('module-button', {
    staticClass: "mt0 mb",
    attrs: {
      "button": "primary",
      "size": "m",
      "label": "Start Reviewing"
    },
    nativeOn: {
      "click": function($event) {
        _vm.startReviewing($event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 342 */
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/Review.vue ***!
  \*****************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/Review.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_dateTime__ = __webpack_require__(/*! services/dateTime */ 208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_models_review__ = __webpack_require__(/*! models/review */ 225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_modules_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_DetailList__ = __webpack_require__(/*! modules/DetailList */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_modules_DetailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_Modal__ = __webpack_require__(/*! modules/Modal */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_modules_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_Thumbnail__ = __webpack_require__(/*! modules/Thumbnail */ 343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_Thumbnail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_modules_Thumbnail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ui_ExpandButton__ = __webpack_require__(/*! ui/ExpandButton */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ui_ExpandButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_ui_ExpandButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ui_Expander__ = __webpack_require__(/*! ui/Expander */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ui_Expander___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_ui_Expander__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ui_Tooltip__ = __webpack_require__(/*! ui/Tooltip */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ui_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_ui_Tooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Models


// Modules








// UI




// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'review',

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_4_modules_Button___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_5_modules_Form___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_6_modules_Link___default.a,
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_7_modules_Spinner___default.a,
    ModuleDetailList: __WEBPACK_IMPORTED_MODULE_8_modules_DetailList___default.a,
    ModuleModal: __WEBPACK_IMPORTED_MODULE_9_modules_Modal___default.a,
    ModuleThumbnail: __WEBPACK_IMPORTED_MODULE_10_modules_Thumbnail___default.a,
    ExpandButton: __WEBPACK_IMPORTED_MODULE_11_ui_ExpandButton___default.a,
    Expander: __WEBPACK_IMPORTED_MODULE_12_ui_Expander___default.a,
    UiTooltip: __WEBPACK_IMPORTED_MODULE_13_ui_Tooltip___default.a
  },

  // Data
  data: function data() {
    return {
      loading: true,
      request: {},
      status: '',
      overlay: '',
      fields: __WEBPACK_IMPORTED_MODULE_3_models_review__["a" /* fields */],
      hideForm: false

    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['user', 'userRole', 'userIsRole']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('review', ['reviewNomenclatureBySlugAndId']), {
    model: function model() {
      return this.getModel('submit-review');
    },
    id: function id() {
      return this.$route.params.id;
    },
    procedure: function procedure() {
      return this.request.procedure || {};
    },
    reason: function reason() {
      return this.request.reason || {};
    },
    diagnosis: function diagnosis() {
      return this.request.diagnosis || {};
    },
    review: function review() {
      var review = this.request.review || {};

      review.ratingMapped = __WEBPACK_IMPORTED_MODULE_3_models_review__["b" /* ratingsMap */][review.rating];

      return review;
    },
    reviewer: function reviewer() {
      var reviewer = this.review.reviewer || {};

      var firstName = reviewer.first_name || '';
      var lastName = reviewer.last_name || '';
      var fullName = '' + firstName + (firstName && lastName ? ' ' : '') + lastName;

      reviewer.full_name = fullName || '';

      return reviewer;
    },
    doctor: function doctor() {
      var doctor = this.request.doctor || {};

      var firstName = doctor.first_name || '';
      var lastName = doctor.last_name || '';
      var fullName = '' + firstName + (firstName && lastName ? ' ' : '') + lastName;

      doctor.full_name = fullName || '';

      return doctor;
    },
    procedureDate: function procedureDate() {
      return this.request.most_recent_procedure ? false : 'on <span class="fw-bold">' + this.formatDate(this.request.date_of_procedure) + '</span>';
    },
    isReviewer: function isReviewer() {
      return this.userRole.role === 3 || this.userRole.role === 42;
    },
    isOwnProcedure: function isOwnProcedure() {
      return this.request && this.request.doctor && this.request.doctor.id !== this.user.id;
    },
    isPatient: function isPatient() {
      return this.userRole.role === 1;
    },
    reviewQuestions: function reviewQuestions() {
      return {
        was_rubber_dam_used: {
          heading: 'Rubber Dam Used',
          tooltip: 'A Rubber Dam is considered the standard of care and should be used in all instances.                     It may be awkward, but this protects the area the doctor is working on and greatly reduces                     the potential for future infection.'
        },
        conservative_access_prep: {
          heading: 'Conservative Access Prep',
          tooltip: 'Has the dentist drilled the small hole needed, or a much bigger hole than is typically required?                     A bigger hole not only damages your tooth more, it also increases your risk of future problems.'
        },
        all_canal_cleaned_and_shaped: {
          heading: 'All Canals Cleaned and Shaped',
          tooltip: 'Did you know there is not a standard number of canals for each tooth? So finding                     all the canals can be a challenge.  Did the dentist treat each of the canals of your                     tooth or did he/she miss one. Missing a canal can leave an opening for future infections                     and require another procedure in the future.'
        },
        canal_cleaned_and_shaped: {
          heading: 'Canals Cleaned and Shaped to the Apex',
          tooltip: 'The filling should go to the tip of your root. Not filling enough (under-fill)                     can leave space for harmful bacteria to grow. A filling that goes beyond the root                     tip (over-fill) can cause damage to the bone, sinus, or even nerve damage in severe cases.                     Over or under filling increases the chances that you\'ll need to have another procedure down                     the road.'
        },
        adequate_root_density: {
          heading: 'Adequate root filling density',
          tooltip: 'The canals should be filled without leaving any spaces between the walls of the tooth.                     Spaces can leave room for bacteria and toxins that eventually cause an infection, often                     requiring another root canal.'
        },
        perforation: {
          heading: 'Signs of perforation',
          tooltip: 'Dentists are human and sometimes make mistakes. We\u2019re simply looking to see if the dentist                     drilled out the side of your tooth. Yep, it happens.'
        },
        separated_instrument: {
          heading: 'Signs of separated instrument',
          tooltip: 'Sometimes a dentist can break off a piece of the small drill bit or file in your tooth.                     These tools are very delicate and must be used with great care. Ideally the dentist will                     get the broken piece out.  If it\u2019s not possible to get it out, did the dentist at least                     tell you about this?'
        }
      };
    },
    reviewAnswers: function reviewAnswers() {
      return {
        1: 'Yes',
        2: 'No',
        3: 'Unable to tell'
      };
    },
    stateMessage: function stateMessage() {
      return {
        2: 'This request is still pending X-Ray uploads from your dentist, we\'ll notify you when it\'s complete',
        3: 'This request is still pending review, we\'ll notify you when it\'s complete',
        4: 'This request has been completed, please see review below'
      };
    },
    procedureType: function procedureType() {
      return {
        1: 'Restorative',
        2: 'Fixed Pros',
        3: 'Endodontics'
      };
    },
    successButton: function successButton() {
      return {
        1: {
          label: 'Request another review',
          link: 'request'
        },
        3: {
          label: 'Review another request'
        }
      };
    },
    xrayTitle: function xrayTitle() {
      return {
        1: 'Pre-op',
        2: 'Post-op',
        3: 'Working Film'
      };
    },
    files: function files() {
      var files = this.request.files || [];
      var sorted = {};

      if (!files.length) return sorted;

      Object(__WEBPACK_IMPORTED_MODULE_2_services_array__["b" /* arrayLoop */])(files, function (index, file) {
        var category = file.category;
        if (!sorted[category]) {
          sorted[category] = [file];
        } else {
          sorted[category].push(file);
        }
      });

      return sorted;
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('modals', ['openModal']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('review', ['getReviewRequestById', 'getNextReview', 'submitReview']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('forms', ['resetForm']), {
    action: function action() {
      return this.submitReview(Object.assign({
        id: this.request.id
      }, this.model));
    },
    success: function success(_success) {
      this.$set(this.request, 'review', _success);
    },
    fail: function fail(_fail) {
      console.warn(_fail);
    },
    openOverlay: function openOverlay(file) {
      this.overlay = file;
      this.openModal('review-overlay');
    },
    formatDate: function formatDate(date) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_services_dateTime__["a" /* toDateString */])(date);
    },
    getReview: function getReview() {
      return this.id ? this.getReviewRequestById(this.id) : this.getNextReview();
    },
    nextReview: function nextReview() {
      var _this = this;

      if (this.isReviewer) {
        this.loading = true;
        setTimeout(function () {
          _this.hideForm = true;
          _this.getNextReview().then(function (res) {
            _this.status = res.status;
            _this.$set(_this, 'request', res.data || {});
            _this.$nextTick(function () {
              _this.hideForm = false;
              _this.loading = false;
              _this.scrollToTop();
            });
          });
        }, 200);
      }
    },
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }),

  // Lifecycle
  created: function created() {
    var _this2 = this;

    this.getReview().then(function (res) {
      _this2.loading = false;
      _this2.status = res.status;
      // If user role is patient this is their review
      if (_this2.userIsRole([1])) {
        // Check to see if payment request satisfied
        if (!res.data.order) {
          alert('Can not validate payment. Cannot Continue'); // eslint-disable-line no-alert
          return _this2.$router.push({
            name: 'dashboard'
          });
        }
        if (!res.data.order || res.data.order.state !== 2) {
          return _this2.$router.replace({
            name: 'review-payment-request',
            params: { id: res.data.order.id, redirect_to: _this2.$route.fullPath }
          });
        }
      }
      _this2.$set(_this2, 'request', res.data || {});
    });
  }
});

/***/ }),
/* 343 */
/*!*************************************************!*\
  !*** ./client/components/modules/Thumbnail.vue ***!
  \*************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Thumbnail.vue */ 344),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-8fbcb480"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Thumbnail.vue */ 345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/*!***********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Thumbnail.vue ***!
  \***********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Thumbnail.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "module-thumbnail",

  // Props
  props: {
    image: String,
    required: true
  }
});

/***/ }),
/* 345 */
/*!******************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fbcb480"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Thumbnail.vue ***!
  \******************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "m-thumbnail",
    style: (!_vm.image ? {} : {
      backgroundImage: ("url(" + _vm.image + ")"),
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "m-thumbnail__inner"
  })])
},staticRenderFns: []}

/***/ }),
/* 346 */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49b7c249"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/Review.vue ***!
  \************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      'main': !_vm.id
    }]
  }, [_c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('div', {
    class: [{
      'group': !_vm.id,
      'dashboard': !_vm.id,
      'dashboard--full-screen': !_vm.id,
    }]
  }, [_c('module-button', {
    staticClass: "mt0 mb",
    attrs: {
      "button": "tertiary",
      "icon": "arrow-left",
      "link": _vm.request.state === 4 || _vm.isOwnProcedure ? "dashboard-requests" : "dashboard-reviews",
      "negative": true,
      "label": !_vm.isReviewer ? "Back to requests" : _vm.status === 204 || _vm.request.state !== 3 || _vm.isOwnProcedure ? "Back to Dashboard" : "Stop Reviewing"
    }
  }), _vm._v(" "), _c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.status === 204),
      expression: "!loading && status === 204"
    }],
    staticClass: "h3"
  }, [_vm._v("There are currently no pending reviews")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.status === 200),
      expression: "!loading && status === 200"
    }],
    staticClass: "review"
  }, [_c('div', {
    staticClass: "review__heading"
  }, [_c('h1', {
    staticClass: "h3"
  }, [(_vm.isReviewer) ? _c('span', {
    staticClass: "fw-medium"
  }, [_vm._v("Procedure Type: ")]) : _vm._e(), _vm._v(_vm._s(_vm.reviewNomenclatureBySlugAndId("procedure", _vm.request.procedure) || "Request") + "\n            "), (!_vm.isReviewer && _vm.request.state <= 3) ? _c('span', {
    staticClass: "c-mid"
  }, [_vm._v("(Pending)")]) : _vm._e()]), _vm._v(" "), (_vm.userRole.role === 1) ? [_c('p', {
    staticClass: "p c-tertiary"
  }, [_vm._v("Performed by "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v("Dr " + _vm._s(_vm.doctor.full_name) + " <" + _vm._s(_vm.doctor.email) + ">")]), _vm._v(" "), (_vm.procedureDate) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.procedureDate)
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "p c-tertiary"
  }, [_vm._v(_vm._s(_vm.stateMessage[_vm.request.state]))])] : _vm._e(), _vm._v(" "), _c('hr')], 2), _vm._v(" "), _c('div', {
    staticClass: "review__procedure-info"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Procedure Details")]), _vm._v(" "), _c('module-detail-list', {
    attrs: {
      "items": {
        'Procedure Date': _vm.request.most_recent_procedure ? "Most recent procedure" : _vm.request.date_of_procedure,
        'Procedure Details': _vm.request.procedure_type ? _vm.procedureType[_vm.request.procedure_type] : "(Pending)",
        'Tooth Number': _vm.request.tooth_number ? _vm.request.tooth_number : "(Pending)",
        'Rubber Dam Used': typeof _vm.request.was_rubber_dam_used === 'boolean' ? _vm.request.was_rubber_dam_used === false && 'No' || 'Yes' : "(Pending)",
      }
    }
  }), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('div', {
    class: [
      "review__xrays",
      {
        'review__xrays--reviewer': _vm.isReviewer,
      } ]
  }, [(!_vm.isReviewer) ? _c('h2', {
    staticClass: "h4"
  }, [_vm._v("Procedure X-Rays")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "review-previews"
  }, [_vm._l((_vm.files), function(category) {
    return _vm._l((category), function(file) {
      return _c('li', {
        key: file.id,
        staticClass: "review-previews__item"
      }, [_c('module-thumbnail', {
        attrs: {
          "image": (file.image || {}).thumbnail
        },
        nativeOn: {
          "click": function($event) {
            _vm.openOverlay(file.image.original)
          }
        }
      }), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "h5 mb0 mt0 fwbold"
      }, [_vm._v(_vm._s(_vm.xrayTitle[file.category]))]), _vm._v(" "), _c('span', {
        staticClass: "small mt0"
      }, [_vm._v("Date: " + _vm._s(file.date))])])], 1)
    })
  }), _vm._v(" "), (!Object.keys(_vm.files).length) ? [_c('p', {
    staticClass: "p"
  }, [_vm._v("No X-Rays Provided")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Were you provided X-Rays? Click here to "), _c('module-link', {
    staticClass: "location__link fw-bold",
    attrs: {
      "link": {
        name: "request-complete",
        params: {
          id: _vm.id
        }
      }
    }
  }, [_vm._v("Upload X-Rays")])], 1)])] : _vm._e()], 2), _vm._v(" "), _c('module-modal', {
    attrs: {
      "id": "review-overlay"
    }
  }, [(_vm.overlay) ? _c('img', {
    staticClass: "review-overlay__image",
    attrs: {
      "src": _vm.overlay
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReviewer) ? _c('div', {
    staticClass: "review-overlay__thumbnails"
  }, _vm._l((_vm.files), function(file, index) {
    return _c('module-thumbnail', {
      key: index,
      class: [{
        'is--active': _vm.overlay === (file.image || {}).original,
      } ],
      attrs: {
        "image": (file.image || {}).thumbnail
      },
      nativeOn: {
        "click": function($event) {
          _vm.overlay = file.image.original
        }
      }
    })
  })) : _vm._e()])], 1), _vm._v(" "), (_vm.review.id) ? _c('div', {
    staticClass: "review__results"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.review.rating) + "/10")]), _vm._v(" "), _vm._l((_vm.reviewQuestions), function(questionContent, slug) {
    return _c('div', {
      key: slug,
      class: ("expand-" + slug)
    }, [_c('p', {
      staticClass: "p"
    }, [(_vm.isPatient) ? _c('ExpandButton', {
      class: ("expand-" + slug)
    }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(questionContent.heading))])], 1), _vm._v(" "), _c('p', {
      staticClass: "p mb"
    }, [_c('i', [_vm._v(_vm._s(_vm.reviewAnswers[_vm.review[slug]]))])]), _vm._v(" "), (_vm.isPatient) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e(), _vm._v(" "), (_vm.isPatient) ? _c('Expander', {
      attrs: {
        "trigger-element": (".expand-" + slug)
      }
    }, [_c('ui-tooltip', {
      attrs: {
        "level": "tip",
        "close": false
      }
    }, [_c('template', {
      slot: "message"
    }, [_vm._v("\n                  " + _vm._s(questionContent.tooltip) + "\n                ")])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.isPatient) ? _c('div', {
      staticClass: "clearfix mb",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.isPatient) ? _c('p', {
    staticClass: "p"
  }, [_c('strong', [_vm._v("Reviewed")]), (_vm.reviewer.full_name) ? [_vm._v(" by "), _c('strong', [_vm._v("a VeriTooth specialist")])] : _vm._e(), _vm._v(" on "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.review.created_at)))])], 2) : _c('p', {
    staticClass: "p"
  }, [_c('strong', [_vm._v("Reviewed")]), (_vm.reviewer.full_name) ? [_vm._v(" by "), _c('strong', [_vm._v(_vm._s(_vm.reviewer.full_name))])] : _vm._e(), _vm._v(" on "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.review.created_at)))])], 2), _vm._v(" "), (_vm.review.reviewer_notes && !_vm.isPatient) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.review.reviewer_notes))]) : _vm._e(), _vm._v(" "), (_vm.successButton[_vm.userRole.role]) ? _c('module-button', _vm._b({
    attrs: {
      "button": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextReview()
      }
    }
  }, 'module-button', _vm.successButton[_vm.userRole.role], false)) : _vm._e()], 2) : (_vm.isReviewer && !_vm.isOwnProcedure) ? _c('div', {
    staticClass: "review__form"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Your Review")]), _vm._v(" "), (!_vm.hideForm) ? _c('module-form', {
    attrs: {
      "form-id": "submit-review",
      "fields": _vm.fields.reviewer,
      "wide": true,
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail,
      "button": "primary"
    }
  }, [_c('module-button', {
    attrs: {
      "slot": "submit-extras",
      "button": "lightest",
      "size": "m",
      "type": "button",
      "label": "Skip This Review"
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextReview()
      }
    },
    slot: "submit-extras"
  })], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "small submit-details"
  }, [_vm._v("When you submit this review, it will be automatically sent to the patient and their doctor")])], 1) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 347 */
/*!****************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/profile/Locations.vue ***!
  \****************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/profile/Locations.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_models_dashboard_userDetails_js__ = __webpack_require__(/*! models/dashboard/userDetails.js */ 224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_DetailList__ = __webpack_require__(/*! modules/DetailList */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_DetailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_Link__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Models


// Modules





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-dentist-locations',

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_3_modules_Button___default.a,
    ModuleDetailList: __WEBPACK_IMPORTED_MODULE_4_modules_DetailList___default.a,
    ModuleForm: __WEBPACK_IMPORTED_MODULE_5_modules_Form___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_6_modules_Link___default.a
  },

  // Data
  data: function data() {
    return {
      fields: __WEBPACK_IMPORTED_MODULE_2_models_dashboard_userDetails_js__["c" /* dentistLocation */],
      editDetails: false,
      locationId: ''
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['user', 'showTour']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel', 'getStatus']), {
    hasLocations: function hasLocations() {
      return this.user.locationsCount > 0;
    },
    isNewLocation: function isNewLocation() {
      return this.locationId.length < 1;
    },
    submitLabel: function submitLabel() {
      return this.isNewLocation ? 'Save' : 'Save Changes';
    },
    model: function model() {
      return this.getModel('dentist-location');
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('auth', ['requestUpdateDentistLocation', 'requestRemoveDentistLocation', 'deactivateTour']), {
    editLocation: function editLocation(id) {
      var _this = this;

      if (this.editDetails) {
        this.editDetails = false;
        this.locationId = '';
        return false;
      }

      this.locationId = id || '';

      Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(this.fields, function (key) {
        var location = _this.user.locations[id] || {};
        if (_this.fields[key]) {
          var value = id ? location[key] : null;
          _this.fields[key].value = value || '';
        }
      });

      this.$nextTick(function () {
        return _this.editDetails = true;
      });
    },
    removeLocation: function removeLocation() {
      var _this2 = this;

      this.requestRemoveDentistLocation(this.locationId).then(function () {
        _this2.editLocation();
      });
    },
    action: function action() {
      var model = Object.assign({}, this.model, {
        id: this.locationId
      });
      return this.requestUpdateDentistLocation(model);
    },
    success: function success() {
      var _this3 = this;

      if (this.showTour === 'reviewer') {
        this.$router.push({
          name: 'dashboard-reviewer-application'
        });
      } else {
        if (this.showTour === 'dentist') {
          this.deactivateTour();
        }

        setTimeout(function () {
          _this3.editLocation();
        }, 1000);
      }
    },
    fail: function fail(_fail) {
      console.warn(_fail);
    }
  })

});

/***/ }),
/* 348 */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64387717"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/profile/Locations.vue ***!
  \***********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("My Location(s)")]), _vm._v(" "), _c('p', {
    staticClass: "mb2"
  }, [_vm._v("Here you can put locations where you practice so we can help identify you easier.")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editDetails || false) ? _c('module-form', {
    attrs: {
      "fields": _vm.fields,
      "form-id": "dentist-location",
      "button-size": "m",
      "button": "primary",
      "submit": _vm.submitLabel,
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  }, [_c('module-button', {
    attrs: {
      "slot": "submit-extras",
      "button": "tertiary",
      "size": "m",
      "type": "button",
      "label": "Cancel"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editLocation()
      }
    },
    slot: "submit-extras"
  }), _vm._v(" "), _c('div', {
    staticClass: "location__remove mt2",
    attrs: {
      "slot": "submit-extras"
    },
    slot: "submit-extras"
  }, [(!_vm.isNewLocation) ? _c('module-link', {
    staticClass: "location__link small fw-bold",
    attrs: {
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeLocation()
      }
    }
  }, [_vm._v("Remove Location")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.editDetails) ? _c('div', {
    staticClass: "locations"
  }, [(!_vm.hasLocations) ? _c('p', {
    staticClass: "mt mb2"
  }, [_vm._v("You have not added your location yet, click below to add your address")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.user.locations), function(location, index) {
    return _c('div', {
      key: index,
      staticClass: "locations__location"
    }, [_c('div', {
      staticClass: "location__title"
    }, [_c('h4', {
      staticClass: "h4 mt0 mb0"
    }, [_vm._v(_vm._s(location.name))]), _vm._v(" "), _c('module-link', {
      staticClass: "location__link small fw-bold",
      nativeOn: {
        "click": function($event) {
          _vm.editLocation(location.id)
        }
      }
    }, [_vm._v("Edit this location")])], 1), _vm._v(" "), _c('module-detail-list', {
      attrs: {
        "items": {
          'Address Line One': location.address_1,
          'Address Line Two': location.address_2,
          'City': location.city,
          'State': location.state,
          'ZIP': location.zipcode,
        }
      }
    })], 1)
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "size": "m",
      "level": "secondary",
      "button": "primary",
      "label": "Add Location"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editLocation()
      }
    }
  })], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 349 */
/*!******************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/ReviewerApplication.vue ***!
  \******************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/ReviewerApplication.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Form__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Modules


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-reviewer-application',

  // Components
  components: {
    ModuleForm: __WEBPACK_IMPORTED_MODULE_2_modules_Form___default.a
  },

  // Data
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['user']), {
    model: function model() {
      return this.getModel('reviewer-form');
    },
    applied: function applied() {
      return this.user.profile.has_applied_for_reviewer_privileges;
    },
    dataComplete: function dataComplete() {
      var _this = this;

      var finished = true;

      var basicInfo = ['first_name', 'last_name'];
      var profileInfo = ['license_number', 'phone_number', 'specialty'];

      Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(basicInfo, function (i, key) {
        if (_this.user[key].length <= 0) return finished = false;
      });

      Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(profileInfo, function (i, key) {
        if (_this.user.profile[key] && _this.user.profile[key].length <= 0) return finished = false;
      });

      if (this.user.locationsCount === 0) return finished = false;

      return finished;
    },
    fields: function fields() {
      var createFile = function createFile(label) {
        var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return {
          label: label,
          type: 'file',
          labelHidden: true,
          button: 'primary',
          validations: {
            required: required
          }
        };
      };

      var fields = {
        identity_card: Object.assign({
          heading: {
            heading: 'Driver\'s License',
            level: 'h5'
          },
          intro: {
            copy: 'Upload a driving license or any other documents that proves your identity:'
          }
        }, createFile('Identity Card', true)),

        dental_license: Object.assign({
          heading: {
            heading: 'Dental License',
            level: 'h5'
          },
          intro: {
            copy: 'Upload a dental license:'
          }
        }, createFile('Dental License', true)),

        specialty_certificate: Object.assign({
          heading: {
            heading: 'Specialty Certificate',
            level: 'h5'
          },
          intro: {
            copy: 'Upload a copy of your specialty certificate:'
          }
        }, createFile('Specialty Certificate', false)),
        terms: {
          type: 'boolean',
          validations: {
            required: true
          }
        }
      };
      return fields;
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('reviewer', ['requestBecomeReviewer']), {
    action: function action() {
      return this.requestBecomeReviewer(this.model);
    },
    success: function success() /*success*/{
      var _this2 = this;

      setTimeout(function () {
        _this2.$router.push({
          name: 'success',
          params: {
            page: 'reviewer-application'
          }
        });
      }, 1000);
    },
    fail: function fail(_fail) {
      console.warn('Fail', _fail);
    }
  })

});

/***/ }),
/* 350 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4b636a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/ReviewerApplication.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Become a Reviewer")]), _vm._v(" "), (_vm.applied) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("Your current application to become a Reviewer is still pending, we will contact you via email with the results")]) : _vm._e(), _vm._v(" "), (!_vm.dataComplete) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("You must complete all sections in "), _c('router-link', {
    staticClass: "fw-bold c-secondary",
    attrs: {
      "to": {
        name: 'dashboard-profile-info'
      }
    }
  }, [_vm._v("My Information")]), _vm._v(" and add at least one location to "), _c('router-link', {
    staticClass: "fw-bold c-secondary",
    attrs: {
      "to": {
        name: 'dashboard-dentist-locations'
      }
    }
  }, [_vm._v("My Locations")]), _vm._v(" before you can apply to become a Reviewer")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.applied && _vm.dataComplete),
      expression: "!applied && dataComplete"
    }]
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Join the movement! Do you want to help highlight good dental care and identify bad work?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("We’re looking for good dentists and specialist to join our pool of expert reviewers. The reviewing process is fast, simple and anonymous. You can log on to our secure site when you have time and quickly review a set of radiographs right on your mobile phone.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Join the fight for transparency in the dental industry!")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Please make sure that all information listed in your dentist profile is accurate. To verify your identity, please upload the following information:")]), _vm._v(" "), _c('module-form', {
    staticClass: "reviewer-form",
    attrs: {
      "button": "primary",
      "form-id": "reviewer-form",
      "fields": _vm.fields,
      "submit": "Register as Reviewer",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p"
  }, [_vm._v("The criteria for reviewing root canals isn’t our opinion, "), _c('a', {
    attrs: {
      "href": "https://www.aae.org/specialty/wp-content/uploads/sites/2/2018/04/TreatmentStandards_Whitepaper.pdf",
      "target": "_blank"
    }
  }, [_vm._v("it’s the official position of the AAE and ADA.")]), _vm._v(" We want to provide patients and dentists with clear criteria on quality dental care.")])
}]}

/***/ }),
/* 351 */
/*!***************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/ReviewerRequests.vue + 1 modules ***!
  \***************************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/ReviewerRequests.vue (referenced with cjs require) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Button.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/DetailList.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Spinner.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Table.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/vuex/dist/vuex.esm.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(5);

// CONCATENATED MODULE: ./client/models/reviewer.js


var statusMap = {
  1: 'Pending',
  2: 'Approved',
  3: 'Denied'
};
// EXTERNAL MODULE: ./client/components/modules/DetailList.vue
var DetailList = __webpack_require__(206);
var DetailList_default = /*#__PURE__*/__webpack_require__.n(DetailList);

// EXTERNAL MODULE: ./client/components/modules/Button.vue
var Button = __webpack_require__(10);
var Button_default = /*#__PURE__*/__webpack_require__.n(Button);

// EXTERNAL MODULE: ./client/components/modules/Spinner.vue
var Spinner = __webpack_require__(43);
var Spinner_default = /*#__PURE__*/__webpack_require__.n(Spinner);

// EXTERNAL MODULE: ./client/components/modules/Table.vue
var Table = __webpack_require__(209);
var Table_default = /*#__PURE__*/__webpack_require__.n(Table);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/ReviewerRequests.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Models


// Modules





// Export
/* harmony default export */ var ReviewerRequests = __webpack_exports__["default"] = ({
  name: 'ui-dashboard-reviewer-requests',

  // Components
  components: {
    ModuleDetailList: DetailList_default.a,
    ModuleButton: Button_default.a,
    ModuleSpinner: Spinner_default.a,
    ModuleTable: Table_default.a
  },

  // Data
  data: function data() {
    return {
      loading: true
    };
  },


  // Computed
  computed: Object.assign({}, Object(vuex_esm["c" /* mapGetters */])('reviewer', ['reviewerRequests', 'reviewerRequestsLength', 'reviewerRequestsTotal']), {
    columns: function columns() {
      return [{
        heading: 'Status',
        value: function value(request) {
          return statusMap[request.status];
        }
      }, {
        heading: 'Name',
        value: function value(request) {
          return 'Dr ' + request.doctor.last_name;
        }
      }, {
        heading: 'Address',
        value: function value(request) {
          return request.doctor.clinics.length ? request.doctor.clinics[0].city : '';
        }
      }, {
        heading: 'ID',
        value: function value(request) {
          return request.doctor.profile.license_number;
        }
      }, {
        heading: 'Link',
        hidden: true,
        align: 'right',
        value: function value() {
          return {
            is: Button_default.a,
            bind: {
              label: 'View Request',
              button: 'primary',
              size: 's',
              icon: 'arrow-right'
            }
          };
        }
      }];
    }
  }),

  // Methods
  methods: Object.assign({}, Object(vuex_esm["b" /* mapActions */])('reviewer', ['getReviewerRequests']), {
    onRowClick: function onRowClick(id) {
      this.$router.push({
        name: 'admin-reviewer-request',
        params: {
          id: id
        }
      });
    }
  }),

  // Lifecycle
  created: function created() {
    var _this = this;

    this.getReviewerRequests().then(function () {
      return _this.loading = false;
    });
  }
});

/***/ }),
/* 352 */
/*!**********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78473c1a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/ReviewerRequests.vue ***!
  \**********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-requests"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Reviewer Requests")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Here you can approve or refuse dentists requests to become a VeriTooth Reviewer ")]), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.reviewerRequestsLength > 0) ? _c('div', {
    key: "requests-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.reviewerRequests.results,
      "row-click": true
    },
    on: {
      "row-click": _vm.onRowClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-requests__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.reviewerRequestsLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.reviewerRequestsTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.reviewerRequests.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    }
  }) : _vm._e()], 1)], 1) : (_vm.reviewerRequestsLength === 0 && !_vm.loading) ? _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("No current requests")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 353 */
/*!**************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/ReviewerRequest.vue ***!
  \**************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/ReviewerRequest.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_DetailList__ = __webpack_require__(/*! modules/DetailList */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_DetailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Vuex


// Modules




// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reviewer-request',

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_2_modules_Button___default.a,
    ModuleDetailList: __WEBPACK_IMPORTED_MODULE_1_modules_DetailList___default.a,
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_3_modules_Spinner___default.a
  },

  // Data
  data: function data() {
    return {
      loading: true,
      buttonLoading: '',
      request: {}
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('review', ['reviewNomenclatureBySlugAndId']), {
    id: function id() {
      return this.$route.params.id;
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('reviewer', ['getReviewerRequestById', 'submitReviewerRequestDecision']), {
    approve: function approve(decision) {
      var _this = this;

      this.buttonLoading = decision ? 'approve' : 'deny';
      return this.submitReviewerRequestDecision({
        id: this.id,
        approved: decision
      }).then(function () {
        _this.buttonLoading = '';
        _this.$nextTick(_this.$router.push({
          name: 'success',
          params: {
            page: decision ? 'reviewer-approved' : 'reviewer-denied',
            doctorName: 'Dr ' + _this.request.doctor.first_name + ' ' + _this.request.doctor.last_name
          }
        }));
      }).catch(function () {
        _this.buttonLoading = '';
      });
    }
  }),

  // Lifecycle
  created: function created() {
    var _this2 = this;

    this.getReviewerRequestById(this.id).then(function (res) {
      _this2.loading = false;

      _this2.$set(_this2, 'request', res.data || {});
    });
  }
});

/***/ }),
/* 354 */
/*!*********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e99aa29"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/ReviewerRequest.vue ***!
  \*********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Dentist Reviewer Request")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The following dentist requested to become a reviewer:")]), _vm._v(" "), _c('h4', {
    staticClass: "h4 mt2"
  }, [_vm._v("Dentist Details")]), _vm._v(" "), _c('p', {
    staticClass: "mt"
  }, [_vm._v("View: "), _c('a', {
    staticClass: "c-secondary fw-bold",
    attrs: {
      "href": _vm.request.identity_card,
      "target": "_blank"
    }
  }, [_vm._v("Uploaded ID Card")])]), _vm._v(" "), _c('p', {
    staticClass: "mt"
  }, [_vm._v("View: "), _c('a', {
    staticClass: "c-secondary fw-bold",
    attrs: {
      "href": _vm.request.dental_license,
      "target": "_blank"
    }
  }, [_vm._v("Uploaded Dental License")])]), _vm._v(" "), _c('p', {
    staticClass: "mt mb2"
  }, [_vm._v("View: "), _c('a', {
    staticClass: "c-secondary fw-bold",
    attrs: {
      "href": _vm.request.specialty_certificate,
      "target": "_blank"
    }
  }, [_vm._v("Uploaded Speciality Certificate")])]), _vm._v(" "), _c('module-detail-list', {
    attrs: {
      "items": {
        'Title:': "Dr",
        'First Name:': _vm.request.doctor.first_name,
        'Last Name:': _vm.request.doctor.last_name,
        'Email Address:': _vm.request.doctor.email,
        'License Number:': _vm.request.doctor.profile.license_number,
        'Phone Number:': _vm.request.doctor.profile.phone_number,
        'Speciality:': _vm.reviewNomenclatureBySlugAndId("specialties", _vm.request.doctor.profile.specialty),
      }
    }
  }), _vm._v(" "), _vm._l((_vm.request.doctor.clinics), function(location, index) {
    return _c('div', {
      key: index
    }, [_c('h4', {
      staticClass: "h4 mt2"
    }, [_vm._v("Location " + _vm._s(index + 1))]), _vm._v(" "), _c('module-detail-list', {
      attrs: {
        "items": {
          'Address Line One': location.address_1,
          'Address Line Two': location.address_2,
          'City': location.city,
          'State': location.state,
          'ZIP': location.zipcode,
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.request.status === 1 || _vm.request.status === 3) ? _c('div', [_c('module-button', {
    staticClass: "mr2",
    attrs: {
      "size": "m",
      "button": "primary",
      "label": "approve",
      "loading": _vm.buttonLoading === "approve",
      "disabled": _vm.buttonLoading === "deny"
    },
    nativeOn: {
      "click": function($event) {
        _vm.approve(true)
      }
    }
  }), _vm._v(" "), (_vm.request.status === 1) ? _c('module-button', {
    attrs: {
      "size": "m",
      "button": "primary",
      "label": "refuse",
      "loading": _vm.buttonLoading === "deny",
      "disabled": _vm.buttonLoading === "approve"
    },
    nativeOn: {
      "click": function($event) {
        _vm.approve(false)
      }
    }
  }) : _vm._e()], 1) : _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("This request has already been completed")])], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 355 */
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/EmailLogs.vue ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/EmailLogs.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_dateTime__ = __webpack_require__(/*! services/dateTime */ 208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_DetailList__ = __webpack_require__(/*! modules/DetailList */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_DetailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Table__ = __webpack_require__(/*! modules/Table */ 209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_Table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Modules





// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-email-logs',

  // Components
  components: {
    ModuleDetailList: __WEBPACK_IMPORTED_MODULE_2_modules_DetailList___default.a,
    ModuleButton: __WEBPACK_IMPORTED_MODULE_3_modules_Button___default.a,
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_4_modules_Spinner___default.a,
    ModuleTable: __WEBPACK_IMPORTED_MODULE_5_modules_Table___default.a
  },

  // Data
  data: function data() {
    return {
      loading: true
    };
  },


  // Computed
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('emails', ['emailLogs', 'emailLogsLength', 'emailLogsTotal']), {
    columns: function columns() {
      return [{
        heading: 'Email Address',
        value: function value(request) {
          return request.to;
        }
      }, {
        heading: 'Full Name',
        value: function value(request) {
          return request.recipient.first_name + ' ' + request.recipient.last_name;
        }
      }, {
        heading: 'Subject',
        value: function value(request) {
          return request.subject;
        }
      }, {
        heading: 'Activities',
        value: function value(request) {
          return request.num_activities || 0;
        }
      }, {
        heading: 'Views',
        value: function value(request) {
          return request.num_views || 0;
        }
      }, {
        heading: 'Clicks',
        value: function value(request) {
          return request.num_clicks || 0;
        }
      }, {
        header: 'Sent',
        value: function value(request) {
          return Object(__WEBPACK_IMPORTED_MODULE_1_services_dateTime__["a" /* toDateString */])(request.created_at);
        }
      }, {
        heading: 'Link',
        hidden: true,
        align: 'right',
        value: function value() {
          return {
            is: __WEBPACK_IMPORTED_MODULE_3_modules_Button___default.a,
            bind: {
              label: 'View Activity',
              button: 'primary',
              size: 's',
              icon: 'arrow-right'
            }
          };
        }
      }];
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('emails', ['getEmailLogs']), {
    getNextPage: function getNextPage() {
      var _this = this;

      if (this.loading) return false;

      this.loading = true;

      setTimeout(function () {
        _this.getEmailLogs(_this.emailLogs.next).then(function () {
          return _this.loading = false;
        });
      }, 300);
    },
    onRowClick: function onRowClick(id) {
      this.$router.push({
        name: 'admin-email-activity',
        params: {
          id: id
        }
      });
    }
  }),

  // Lifecycle
  created: function created() {
    var _this2 = this;

    this.getEmailLogs().then(function () {
      return _this2.loading = false;
    });
  }
});

/***/ }),
/* 356 */
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7912cd8a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/EmailLogs.vue ***!
  \***************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-emails"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Email Logs")]), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.emailLogsLength > 0) ? _c('div', {
    key: "emails-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.emailLogs.results,
      "row-click": true
    },
    on: {
      "row-click": _vm.onRowClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-emails__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.emailLogsLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.emailLogsTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.emailLogs.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNextPage($event)
      }
    }
  }) : _vm._e()], 1)], 1) : (_vm.emailLogsLength === 0 && !_vm.loading) ? _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("No Email Logs")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 357 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/dashboard/EmailActivity.vue ***!
  \************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/dashboard/EmailActivity.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js__ = __webpack_require__(/*! ua-parser-js */ 358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ua_parser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_dateTime__ = __webpack_require__(/*! services/dateTime */ 208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_DetailList__ = __webpack_require__(/*! modules/DetailList */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_DetailList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Table__ = __webpack_require__(/*! modules/Table */ 209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_Table__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// UA Parser

// Vuex


// Services


// Modules





// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-dashboard-email-activity',

  // Components
  components: {
    ModuleDetailList: __WEBPACK_IMPORTED_MODULE_3_modules_DetailList___default.a,
    ModuleButton: __WEBPACK_IMPORTED_MODULE_4_modules_Button___default.a,
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_5_modules_Spinner___default.a,
    ModuleTable: __WEBPACK_IMPORTED_MODULE_6_modules_Table___default.a
  },

  // Data
  data: function data() {
    return {
      loading: true
    };
  },


  // Computed
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('emails', ['emailActivity', 'emailActivityLength', 'emailActivityTotal']), {
    columns: function columns() {
      var _this = this;

      return [{
        heading: 'Acitivity Type',
        value: function value(request) {
          return _this.getActivityType(request);
        }
      }, {
        heading: 'Operating System',
        value: function value(request) {
          return _this.getOSFromUA(request.user_agent);
        }
      }, {
        heading: 'Browser',
        value: function value(request) {
          return _this.getBrowserFromUA(request.user_agent);
        }
      }, {
        heading: 'IP Address',
        value: function value(request) {
          return request.ip_address ? request.ip_address : 'N/A';
        }
      }, {
        heading: 'Date',
        value: function value(request) {
          return Object(__WEBPACK_IMPORTED_MODULE_2_services_dateTime__["a" /* toDateString */])(request.created_at) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2_services_dateTime__["b" /* toDateTimeString */])(request.created_at);
        }
      }];
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('emails', ['getEmailActivity']), {
    getBrowserFromUA: function getBrowserFromUA(userAgent) {
      if (!userAgent) {
        return 'N/A';
      }

      var name = (__WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default()(userAgent).browser || { name: 'Unknown' }).name;
      var version = (__WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default()(userAgent).browser || { version: 'Unknown' }).version;

      return name + ' ' + version;
    },
    getOSFromUA: function getOSFromUA(userAgent) {
      if (!userAgent) {
        return 'N/A';
      }
      var name = (__WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default()(userAgent).os || { name: 'Unknown' }).name;
      var version = (__WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default()(userAgent).os || { version: 'Unknown' }).version;

      return name + ' ' + version;
    },
    getActivityType: function getActivityType(request) {
      var named_type = 'Viewed';
      switch (request.type) {
        case 1:
          named_type = 'Sent';
          break;
        case 2:
          named_type = 'Viewed';
          break;
        case 3:
          named_type = 'Clicked';
          break;
        default:
          break;
      }
      return named_type;
    },
    getNextPage: function getNextPage() {
      var _this2 = this;

      if (this.loading) return false;

      this.loading = true;

      setTimeout(function () {
        _this2.getEmailActivity(_this2.emailActivity.next).then(function () {
          return _this2.loading = false;
        });
      }, 300);
    }
  }),

  // Lifecycle
  created: function created() {
    var _this3 = this;

    this.getEmailActivity(this.$route.params.id).then(function () {
      return _this3.loading = false;
    });
  }
});

/***/ }),
/* 358 */
/*!****************************************************!*\
  !*** ./node_modules/ua-parser-js/src/ua-parser.js ***!
  \****************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.20
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.20',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            ], [NAME, VERSION], [

            /(konqueror)\/([\w\.]+)/i                                           // Konqueror
            ], [[NAME, 'Konqueror'], VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i                          // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(windowswechat qbcore)\/([\w\.]+)/i                                // WeChat Desktop for Windows Built-in Browser
            ], [[NAME, 'WeChat(Win) Desktop'], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(sailfishbrowser)\/([\w\.]+)/i                                     // Sailfish Browser
            ], [[NAME, 'Sailfish Browser'], VERSION], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i                        // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,                        // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i                   // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i             // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
            /(lenovo)[_\s-]?([\w-]+)/i
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)[\s)]/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    
                                                                                // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
            /(mz)-([\w-]{2,})/i
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /[\s\/\(](smart-?tv)[;\)]/i                                         // SmartTV
            ], [[TYPE, SMARTTV]], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /webkit\/537\.36.+chrome\/(?!27)/i                                  // Blink
            ], [[NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,     
                                                                                // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 359 */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755f9d2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/EmailActivity.vue ***!
  \*******************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-emails"
  }, [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Email Activity")]), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.emailActivityLength > 0) ? _c('div', {
    key: "emails-table"
  }, [_c('module-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.emailActivity.results
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-emails__more"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Showing "), _c('strong', [_vm._v(_vm._s(_vm.emailActivityLength))]), _vm._v(" of "), _c('strong', [_vm._v(_vm._s(_vm.emailActivityTotal))]), _vm._v(" Results")]), _vm._v(" "), (_vm.emailActivity.next) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Load more",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNextPage($event)
      }
    }
  }) : _vm._e()], 1)], 1) : (_vm.emailActivityLength === 0 && !_vm.loading) ? _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("No Email Activity")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 360 */
/*!********************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Success.vue ***!
  \********************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/Success.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Success__ = __webpack_require__(/*! modules/Success */ 361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Success__);
//
//
//
//
//
//
//
//
//
//

// Modules



// Image
var images = {
  tick: __webpack_require__(/*! images/dashboard/success-tick.svg */ 210)
};

// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "success",

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_0_modules_Button___default.a,
    ModuleSuccess: __WEBPACK_IMPORTED_MODULE_1_modules_Success___default.a
  },

  // Data
  data: function data() {
    return {
      images: images,
      pages: {
        "patient-procedure": {
          title: "Procedure Submitted",
          copy: ["Your request has been sent to your dentist\u2019s office.", "To ensure they get your information correct and fulfill your request, we suggest you call their office to confirm they got all the information needed and know you have consented to share your x-rays.", "You will get an email update once they\u2019ve uploaded your x-rays and again once an expert has completed a review."],
          buttonLabel: "View My Dashboard",
          buttonLink: "dashboard-requests"
        },
        "patient-xray-upload": {
          title: "Procedure Details Submitted",
          copy: ["Thank you.  You have successfully completed this request."],
          buttonLabel: "View my dashboard",
          buttonLink: "dashboard-requests"
        },
        "doctor-xray-upload": {
          title: "Procedure Details Submitted",
          copy: ["Thank you.  You have successfully completed your patient\u2019s request.", "VeriTooth is committed to helping dentist demonstrate quality by letting the work speak for itself.  In fact, if our reviewers see high quality work it can even be nominated for recognition and promotion on our social media channels."],
          buttonLabel: "View my dashboard",
          buttonLink: "dashboard-requests"
        },
        "reviewer-xray-upload": {
          title: "Procedure Details Submitted",
          copy: ["Thank you.  You have successfully completed your patient\u2019s request.", "VeriTooth is committed to helping dentist demonstrate quality by letting the work speak for itself.  In fact, if our reviewers see high quality work it can even be nominated for recognition and promotion on our social media channels."],
          buttonLabel: "My Dashboard",
          buttonLink: "dashboard"
        },
        "reviewer-application": {
          title: "Your request is being processed",
          copy: ["Thank you, your request to become a reviewer has been sent to VeriTooth. We will contact you shortly"],
          buttonLabel: "My Dashboard",
          buttonLink: "dashboard"
        },
        "reviewer-approved": {
          title: "Reviewer Approved",
          copy: [this.$route.params.doctorName + " has been added to the pool of reviewers"],
          buttonLabel: "View List of reviewer requests",
          buttonLink: "admin-reviewer-requests"
        },
        "reviewer-denied": {
          title: "Reviewer Denied",
          copy: ["You have denied " + this.$route.params.doctorName + " request to become a reviewer"],
          buttonLabel: "View List of reviewer requests",
          buttonLink: "admin-reviewer-requests"
        }
      }
    };
  },


  computed: {
    successPage: function successPage() {
      return this.pages[this.$route.params.page] || {};
    }
  }
});

/***/ }),
/* 361 */
/*!***********************************************!*\
  !*** ./client/components/modules/Success.vue ***!
  \***********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Success.vue */ 362),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-00561057"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Success.vue */ 363),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Success.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Success.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Modules


// Image
var images = {
  tick: __webpack_require__(/*! images/dashboard/success-tick.svg */ 210)
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-success',

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_0_modules_Button___default.a
  },

  // Props
  props: {
    successPage: Object
  },

  data: function data() {
    return {
      images: images
    };
  }
});

/***/ }),
/* 363 */
/*!****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00561057"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Success.vue ***!
  \****************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.tick,
      "alt": "success",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.successPage.title))]), _vm._v(" "), _vm._l((_vm.successPage.copy), function(copy, index) {
    return _c('p', {
      key: index,
      staticClass: "p"
    }, [_vm._v(_vm._s(copy) + "\n  ")])
  }), _vm._v(" "), _c('module-button', {
    attrs: {
      "button": "primary",
      "link": _vm.successPage.buttonLink,
      "label": _vm.successPage.buttonLabel
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 364 */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d46d46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Success.vue ***!
  \***************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--success success"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('module-success', {
    attrs: {
      "success-page": _vm.successPage
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 365 */
/*!********************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/Request.vue ***!
  \********************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/views/Request.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_string__ = __webpack_require__(/*! services/string */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_DetailList__ = __webpack_require__(/*! modules/DetailList */ 206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_DetailList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_DetailList__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services



// Modules




// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'request',

  // Components
  components: {
    ModuleForm: __WEBPACK_IMPORTED_MODULE_3_modules_Form___default.a,
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_4_modules_Spinner___default.a,
    ModuleDetailList: __WEBPACK_IMPORTED_MODULE_5_modules_DetailList___default.a
  },

  // Data
  data: function data() {
    return {
      loading: true,
      loadingRequest: true,
      content: {
        title: {
          'patient-new': 'Submit a request for a review',
          'patient-complete': 'Submit Procedure Details',
          'doctor-new': 'Submit Procedure Details',
          'doctor-complete': 'Submit Procedure Details'
        },
        intro: {
          'patient-new': 'Fill out the form below and your dentist will get a request to upload your x-rays for review to a secure site; and you\u2019ll get a confirmation.  It\'s that simple.',
          'patient-complete': 'Please fill out the form below',
          'doctor-new': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          'doctor-complete': 'This patient has requested to upload radiographs and give additional information for the following procedure:'
        },
        'intro-continued': {
          'patient-new': 'Please provide your dentist with the most accurate information possible to ensure they submit the correct x-rays for review.  You have the power to make a formal request of your dentist and he/she must legally comply.'
        },
        'field-procedure': {
          heading: {
            'patient-new': 'Which procedure would you like reviewed?',
            'patient-complete': 'What procedure was done?',
            'doctor-new': 'What procedure did you carry out?'
          },
          intro: {
            'patient-new': 'Select the type of dental procedure you\u2019d like verified from the list below.'
          }
        },

        'field-was_rubber_dam_used': {
          heading: {
            'doctor-new': 'Was a rubber dam used?',
            'doctor-complete': 'Was a rubber dam used?',
            'patient-complete': 'Was a rubber dam used?'
          }
        },

        'field-most_recent_procedure': {
          heading: {
            'patient-new': 'Was this your most recent procedure?'
          }
        },

        'field-date_of_procedure': {
          label: {
            'patient-new': 'When did you have this procedure?'
          },
          placeholder: {
            'patient-new': 'Procedure Date (exact of approximate)'
          }
        },

        'field-doctor-first-name': {
          heading: {
            'patient-new': 'Treating Doctor'
          },
          intro: {
            'patient-new': 'Who performed this procedure?'
          },
          placeholder: {
            'patient-new': 'First Name'
          }
        },

        'field-doctor-last-name': {
          placeholder: {
            'patient-new': 'Last Name'
          }
        },

        'field-doctor-email': {
          placeholder: {
            'patient-new': 'Email Address'
          }
        },

        'field-doctor-number': {
          placeholder: {
            'patient-new': 'Phone Number'
          }
        },
        'field-confirm-procedure': {
          heading: {
            'doctor-complete': 'Confirm Procedure Details',
            'patient-complete': 'Confirm Procedure Details'
          },
          intro: {
            'doctor-complete': 'What kind of procedure was done on this patient exactly?',
            'patient-complete': 'What kind of procedure was done exactly?'
          }
        },
        'field-tooth-number': {
          heading: {
            'doctor-complete': 'Tooth Number',
            'patient-complete': 'Tooth Number'
          },
          intro: {
            'doctor-complete': 'On which tooth was this procedure carried out?',
            'patient-complete': 'On which tooth was this procedure carried out?'
          }
        }
      }
    };
  },


  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['userRole']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('review', ['reviewNomenclature', 'reviewNomenclatureBySlug', 'reviewNomenclatureBySlugAndId', 'reviewRequests', 'reviewRequestsById']), {
    model: function model() {
      return this.getModel('request-form');
    },
    requestState: function requestState() {
      var role = this.userRole.role;
      if (role === 1) return this.$route.name === 'request-complete' ? 'patient-complete' : 'patient-new';
      return this.$route.name === 'request-complete' ? 'doctor-complete' : 'doctor-new';
    },
    loaded: function loaded() {
      return !this.loading && !this.loadingRequest;
    },
    currentRequest: function currentRequest() {
      return this.reviewRequestsById(this.$route.params.id);
    },
    patient: function patient() {
      if (typeof this.currentRequest.patient === 'undefined') {
        return {};
      }

      var patient = this.currentRequest.patient;

      var firstName = patient.first_name;
      var lastName = patient.last_name;
      var fullName = '' + firstName + (firstName && lastName ? ' ' : '') + lastName;

      patient.full_name = fullName || '';

      return patient;
    },
    fields: function fields() {
      if (this.loading) return {};

      var createFile = function createFile(label, index) {
        var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return {
          label: (label === 'Working Film' ? 'Image' : 'X-Ray') + ' ' + index,
          type: 'file',
          // helper: `Upload a file and let us know when this X-Ray was taken.`,
          button: 'primary',
          validations: {
            required: required
          }
        };
      };

      var createDate = function createDate(label, index) {
        var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return {
          label: label + ' X-Ray ' + index + ' date',
          labelHidden: true,
          placeholder: 'Enter date of ' + (label === 'Working Film' ? 'image' : 'x-ray'),
          validations: {
            required: required
          }
        };
      };

      var createBoolean = function createBoolean() {
        return {
          type: 'boolean',
          label: 'Add additional file',
          labelHidden: true
        };
      };

      var createAdditionalFiles = function createAdditionalFiles(label, prefix, index) {
        var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        var additionalFiles = {};

        additionalFiles['show_' + prefix + '_' + index] = createBoolean();

        additionalFiles['files_' + prefix + '_' + index] = Object.assign({}, createFile(label, index, required), {
          conditional: function conditional(model) {
            return model['show_' + prefix + '_' + index];
          }
        });

        additionalFiles['files_' + prefix + '_' + index + '_date'] = Object.assign({}, createDate(label, index), {
          conditional: function conditional(model) {
            return model['show_' + prefix + '_' + index];
          }
        });

        return additionalFiles;
      };

      var files = Object.assign({
        // Pre-op
        files_pre_one: Object.assign({
          heading: {
            heading: 'Upload Pre-op X-Ray(s)',
            level: 'h5'
          },
          intro: {
            copy: 'Upload a file and let us know when this X-ray was taken'
          }
        }, createFile('Pre-op', 'one', true)),
        files_pre_one_date: createDate('Pre-op', 'one', true)
      }, createAdditionalFiles('Pre-op', 'pre', 'two'), {

        // Post-op
        files_post_one: Object.assign({
          heading: {
            heading: 'Upload Post-op X-Ray(s)',
            level: 'h5'
          },
          intro: {
            copy: 'Upload a file and let us know when this X-ray was taken'
          }
        }, createFile('Post-op', 'one', true)),
        files_post_one_date: createDate('Post-op', 'one', true)
      }, createAdditionalFiles('Post-op', 'post', 'two'), {

        // Working Film
        files_working_one_req: Object.assign({
          heading: {
            heading: 'Upload Working Film',
            level: 'h5'
          },
          intro: {
            copy: 'Upload a file and let us know when this X-ray was taken'
          }
        }, createFile('Working Film', 'one', true)),
        files_working_one_req_date: createDate('Working Film', 'one', true),
        files_working_one_opt: createFile('Working Film', 'one', false),

        files_working_one_opt_date: createDate('Working Film', 'one', false)
      }, createAdditionalFiles('Working Film', 'working', 'two', false));

      files.files_working_one_req.conditional = function (model) {
        return model.confirm_procedure !== 3;
      };
      files.files_working_one_req_date.conditional = function (model) {
        return model.confirm_procedure !== 3;
      };

      files.files_working_one_opt.conditional = function (model) {
        return model.confirm_procedure === 3;
      };
      files.files_working_one_opt_date.conditional = function (model) {
        return model.confirm_procedure === 3;
      };

      // Procedure
      var procedure = {
        heading: {
          heading: this.getContent('field-procedure', 'heading'),
          level: 'h5'
        },
        intro: {
          copy: this.getContent('field-procedure', 'intro')
        },
        label: 'Type of Procedure',
        labelHidden: true,
        type: 'select',
        items: this.reviewNomenclatureBySlug('procedure'),
        validations: {
          required: true
        }
      };

      // When
      var was_rubber_dam_used = {
        heading: {
          heading: this.getContent('field-was_rubber_dam_used', 'heading'),
          level: 'h5'
        },
        type: 'radio',
        items: [{
          option: 'Yes',
          value: true
        }, {
          option: 'No',
          value: 'date'
        }],
        validations: {
          required: true
        }
      };

      if (this.userRole.role === 1 && this.requestState === 'patient-complete') {
        var img = __webpack_require__(/*! images/rootCanalFaq/rubber-dam.png */ 223);
        was_rubber_dam_used.tooltip = {
          title: 'Click here for more info',
          content: '\n            <p>A Rubber Dam is considered the standard of care and should be used in all instances. It may be awkward, but this protects the area the doctor is working on and greatly reduces the potential for future infection.</p>\n            <br />\n            <img style="max-width: 100%;" src="' + img + '" alt="">\n          '
        };
      }

      // When
      var most_recent_procedure = {
        heading: {
          heading: this.getContent('field-most_recent_procedure', 'heading'),
          level: 'h5'
        },
        type: 'radio',
        items: [{
          option: 'Yes',
          value: true
        }, {
          option: 'No',
          value: 'date'
        }],
        validations: {
          required: true
        }
      };

      // Enter Date
      var date_of_procedure = {
        label: this.getContent('field-date_of_procedure', 'label'),
        labelHidden: true,
        placeholder: this.getContent('field-date_of_procedure', 'placeholder'),
        conditional: function conditional(model) {
          return model.most_recent_procedure === 'date';
        }
      };

      // Doctor Info
      var first_name = {
        heading: {
          heading: this.getContent('field-doctor-first-name', 'heading'),
          level: 'h5'
        },
        intro: {
          copy: this.getContent('field-doctor-first-name', 'intro')
        },
        placeholder: this.getContent('field-doctor-first-name', 'placeholder'),
        label: 'Doctor Information',
        validations: {
          required: true
        }
      };

      var last_name = {
        label: 'Doctor Last Name',
        placeholder: this.getContent('field-doctor-last-name', 'placeholder'),
        labelHidden: true,
        validations: {
          required: true
        }
      };

      var email = {
        label: 'Enter Email',
        labelHidden: true,
        type: 'email',
        errorLabel: 'Email',
        placeholder: this.getContent('field-doctor-email', 'placeholder'),
        validations: {
          required: true,
          email: true
        }
      };
      var phone_number = {
        label: 'Doctor Phone Number',
        placeholder: this.getContent('field-doctor-number', 'placeholder'),
        labelHidden: true,
        validations: {
          required: true
        }
      };

      // Doctor Upload

      // Confirm Procedure
      var confirm_procedure = {
        heading: {
          heading: this.getContent('field-confirm-procedure', 'heading'),
          level: 'h5'
        },
        intro: {
          copy: this.getContent('field-confirm-procedure', 'intro')
        },
        type: 'radio',
        items: [{
          option: 'Endodontics  (Root Canal, Retreatment, Incomplete RCT ie. Emergency palliative)',
          value: 3
        }, {
          option: 'Restorative  (Coming Soon)',
          value: 1,
          disabled: true
        }, {
          option: 'Fixed Pros. (Coming Soon)',
          value: 2,
          disabled: true
        }],
        validations: {
          required: true
        }
      };

      var tooth_number = {
        heading: {
          heading: this.getContent('field-tooth-number', 'heading'),
          level: 'h5'
        },
        intro: {
          copy: this.getContent('field-tooth-number', 'intro')
        },
        type: 'Number',
        label: 'Tooth Number',
        labelHidden: true,
        validations: {
          required: true,
          min: 1,
          max: 32
        }
      };

      var fields = {};

      if (this.requestState === 'patient-new') {
        fields = {
          procedure: procedure,
          most_recent_procedure: most_recent_procedure,
          date_of_procedure: date_of_procedure,
          first_name: first_name,
          last_name: last_name,
          email: email,
          phone_number: phone_number
        };
      } else if (this.requestState === 'doctor-complete') {
        fields = Object.assign({
          confirm_procedure: confirm_procedure,
          tooth_number: tooth_number,
          was_rubber_dam_used: was_rubber_dam_used
        }, files);
      } else if (this.requestState === 'patient-complete') {
        if (this.userRole.role === 1) {
          fields = Object.assign({
            confirm_procedure: confirm_procedure,
            was_rubber_dam_used: was_rubber_dam_used
          }, files);
        } else {
          fields = Object.assign({
            confirm_procedure: confirm_procedure,
            tooth_number: tooth_number,
            was_rubber_dam_used: was_rubber_dam_used
          }, files);
        }
      }

      return fields;
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('forms', ['updateValue']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('review', ['getNomenclature', 'requestReviewId', 'requestReviewPostInfo', 'requestReviewUploadImage', 'getReviewRequestsDoctor', 'getReviewRequestsDoctorById']), {
    action: function action() {
      if (this.requestState === 'patient-new') {
        return this.actionPatientRequest();
      } else if (this.requestState === 'patient-complete') {
        return this.actionPatientUpload();
      }
      return this.actionDentist();
    },
    actionPatientRequest: function actionPatientRequest() {
      var model = {
        procedure: this.model.procedure,
        treating_doctor: {
          first_name: this.model.first_name,
          last_name: this.model.last_name,
          email: this.model.email,
          phone_number: Object(__WEBPACK_IMPORTED_MODULE_2_services_string__["a" /* americanizePhoneNumber */])(this.model.phone_number)
        }
      };

      if (this.model.most_recent_procedure === 'date') {
        model.date_of_procedure = this.model.date_of_procedure;
      } else {
        model.most_recent_procedure = true;
      }
      return this.requestReviewId(model);
    },
    actionPatientUpload: function actionPatientUpload() {
      return this.actionBaseAnswer();
    },
    actionDentist: function actionDentist() {
      return this.actionBaseAnswer();
    },
    actionBaseAnswer: function actionBaseAnswer() {
      var _this = this;

      return new Promise(function (resolve, reject) {

        var model = {
          id: _this.$route.params.id,
          tooth_number: _this.model.tooth_number,
          was_rubber_dam_used: _this.model.was_rubber_dam_used,
          procedure_type: _this.model.confirm_procedure
        };

        var promises = [];

        var categoryMap = {
          pre: 1,
          post: 2,
          working: 3
        };

        Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(_this.model, function (key, value) {
          if (/^files_/.test(key)) {
            if (value && !/_date/.test(key)) {
              promises.push(_this.requestReviewUploadImage({
                image: value,
                id: model.id,
                date: _this.model[key + '_date'],
                category: categoryMap[key.split('_')[1]]
              }));
            }
          }
        });

        return Promise.all(promises).then(function () {
          _this.requestReviewPostInfo(model).then(function () {
            resolve();
          });
        }).catch(function (err) {
          console.warn('Err here', err);
          reject(err);
        });
      });
    },
    success: function success(response) {
      var _this2 = this;

      var getSuccessPage = function getSuccessPage() {
        if (_this2.userRole.role === 1) {
          if (_this2.requestState === 'patient-complete') {
            return 'patient-xray-upload';
          }

          return 'patient-procedure';
        }

        return (_this2.userRole.role === 2 ? 'doctor' : 'reviewer') + '-xray-upload';
      };

      var routeToConfig = {
        method: 'push',
        routeTo: {
          name: 'success',
          params: {
            page: getSuccessPage()
          }
        }
      };

      if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) !== undefined && this.requestState === 'patient-new') {
        var resolvedRoute = this.$router.resolve({
          name: 'dashboard-review',
          params: { id: response.id }
        });
        routeToConfig.method = 'replace';
        routeToConfig.routeTo = {
          name: 'review-payment-request',
          params: { id: response.order.id, redirect_to: resolvedRoute.href }
        };
      }

      setTimeout(function () {
        _this2.$router[routeToConfig.method](routeToConfig.routeTo);
      }, 1000);
    },
    fail: function fail(_fail) {
      console.warn('Fail', _fail);
    },
    getContent: function getContent(string, field) {
      var object = this.content[string] || {};

      if (field) object = object[field] || {};

      return object[this.requestState] || {};
    }
  }),

  // Lifecycle
  created: function created() {
    var _this3 = this;

    this.getNomenclature().then(function () {
      _this3.loading = false;

      _this3.$nextTick(function () {
        // console.log(sessionStorage.getItem(`procedure`));
        _this3.updateValue({
          form: 'request-form',
          field: 'procedure',
          value: sessionStorage.getItem('procedure')
        });

        sessionStorage.removeItem('procedure');
      });
    });
    if (this.requestState === 'doctor-complete' || this.requestState === 'patient-complete') {
      this.getReviewRequestsDoctorById(this.$route.params.id).then(function () {
        _this3.loadingRequest = false;
      }).catch(function (err) {
        if (err && err.status === 404) {
          _this3.$router.replace({
            name: 'notFound'
          });
        }
      });
    } else this.loadingRequest = false;
  }
});

/***/ }),
/* 366 */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-743b55e9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Request.vue ***!
  \***************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--request request"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('module-spinner', {
    attrs: {
      "active": !_vm.loaded,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "group mt request__wrapper"
  }, [_c('div', {
    staticClass: "request__heading"
  }, [(_vm.getContent("title")) ? _c('h3', {
    staticClass: "h3"
  }, [_vm._v(_vm._s(_vm.getContent("title")))]) : _vm._e(), _vm._v(" "), (_vm.getContent("intro")) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.getContent("intro")))]) : _vm._e(), _vm._v(" "), (typeof _vm.getContent("intro-continued") === 'string') ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.getContent("intro-continued")))]) : _vm._e()]), _vm._v(" "), (_vm.requestState === "doctor-complete") ? _c('module-detail-list', {
    attrs: {
      "items": {
        'Patient Name': _vm.patient.full_name,
        'Procedure Type': _vm.reviewNomenclatureBySlugAndId("procedure", _vm.currentRequest.procedure),
        'Procedure Date': _vm.currentRequest.most_recent_procedure ? 'Patient’s most recent procedure' : _vm.currentRequest.date_of_procedure,
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('module-form', {
    staticClass: "request-form",
    attrs: {
      "button": "primary",
      "form-id": "request-form",
      "fields": _vm.fields,
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ })
]));


// WEBPACK FOOTER //
// assets/page-base.7b36ee6e.js